import { gql } from 'urql';
import * as Urql from 'urql';
import { graphql, ResponseResolver, GraphQLRequest, GraphQLContext } from 'msw'
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string | number; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  AssetData: { input: any; output: any; }
  Base64ImageString: { input: any; output: any; }
  Date: { input: any; output: any; }
  Datetime: { input: any; output: any; }
  DebtData: { input: any; output: any; }
  FactfindErrors: { input: any; output: any; }
  FieldErrors: { input: any; output: any; }
  FieldValue: { input: any; output: any; }
  GoalData: { input: any; output: any; }
  JSON: { input: any; output: any; }
  Markdown: { input: any; output: any; }
  MoneyInput: { input: any; output: any; }
  Percentage: { input: any; output: any; }
  PolicyData: { input: any; output: any; }
  RawJSONForDebugging: { input: any; output: any; }
  UUID: { input: any; output: any; }
  ValidationErrors: { input: any; output: any; }
};

export enum AccommodationType {
  Home = 'HOME',
  Rented = 'RENTED',
  Student = 'STUDENT'
}

/** A generic address */
export type Address = {
  __typename: 'Address';
  buildingName?: Maybe<Scalars['String']['output']>;
  buildingNumber?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  county?: Maybe<Scalars['String']['output']>;
  flatNumber?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  subStreet?: Maybe<Scalars['String']['output']>;
  town?: Maybe<Scalars['String']['output']>;
};

export type AddressAssociation = {
  __typename: 'AddressAssociation';
  address?: Maybe<Address>;
  duration?: Maybe<Scalars['Int']['output']>;
  id: Scalars['UUID']['output'];
  isCurrent?: Maybe<Scalars['Boolean']['output']>;
};

export type AddressAssociationInput = {
  address?: InputMaybe<AddressInput>;
  duration?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  isCurrent?: InputMaybe<Scalars['Boolean']['input']>;
  personId?: InputMaybe<Scalars['UUID']['input']>;
};

/** Add an address */
export type AddressInput = {
  buildingName?: InputMaybe<Scalars['String']['input']>;
  buildingNumber?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  county?: InputMaybe<Scalars['String']['input']>;
  flatNumber?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  subStreet?: InputMaybe<Scalars['String']['input']>;
  town?: InputMaybe<Scalars['String']['input']>;
};

export type Allowances = {
  __typename: 'Allowances';
  helpToBuyIsa?: Maybe<Money>;
  isa?: Maybe<Money>;
  lifetimeIsa?: Maybe<Money>;
};

export type AllowancesInput = {
  helpToBuyIsa?: InputMaybe<Scalars['Float']['input']>;
  isa?: InputMaybe<Scalars['Float']['input']>;
  lifetimeIsa?: InputMaybe<Scalars['Float']['input']>;
};

export type Appointment = {
  __typename: 'Appointment';
  advisorAvatarUrl?: Maybe<Scalars['String']['output']>;
  advisorEmail?: Maybe<Scalars['String']['output']>;
  advisorId: Scalars['ID']['output'];
  advisorName: Scalars['String']['output'];
  advisorPhone?: Maybe<Scalars['String']['output']>;
  endTime: Scalars['Datetime']['output'];
  id: Scalars['ID']['output'];
  reason?: Maybe<Scalars['String']['output']>;
  startTime: Scalars['Datetime']['output'];
};

/** Asset entered in fact find */
export type Asset = {
  __typename: 'Asset';
  accessible?: Maybe<Scalars['Boolean']['output']>;
  /** Whether pension is currently active. Affects: Pension */
  active?: Maybe<Scalars['Boolean']['output']>;
  balance?: Maybe<Money>;
  /** Affects: An Post State Savings Account / Life Company Savings Plan */
  frequency?: Maybe<PaymentFrequency>;
  id: Scalars['UUID']['output'];
  /** Whether contributions are increasing each year. Affects: Pension */
  increasing?: Maybe<Scalars['Boolean']['output']>;
  isComplete: Scalars['Boolean']['output'];
  isIrishLifePension?: Maybe<Scalars['Boolean']['output']>;
  /** Affects: Credit Union Account / Shares / Government Bond / Investment Bond / Other */
  maturityDate?: Maybe<Scalars['Date']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  /** Affects: Current account */
  overdrawnBy?: Maybe<Money>;
  owners?: Maybe<Array<Maybe<Person>>>;
  /** Affects: Pension */
  pensionType?: Maybe<PensionType>;
  productType: AssetType;
  /** Affects: Property */
  propertyType?: Maybe<PropertyType>;
  provider?: Maybe<Provider>;
  /** Affects: An Post State Savings Account / Pension / Life Company Savings Plan */
  regularPaymentAmount?: Maybe<Money>;
  /** Affects: An Post State Savings Account / Life Company Savings Plan */
  startDate?: Maybe<Scalars['Date']['output']>;
  /** Whether pension is provided by current employer. Affects: Pension */
  throughCurrentEmployer?: Maybe<Scalars['Boolean']['output']>;
  userId: Scalars['ID']['output'];
  /** Affects: Pension */
  valuationMethod?: Maybe<ValuationMethod>;
  /** Affects: Cash / Current Account / All Savings and Deposits / Credit Union Account / An Post State Savings Account / Shares / Government Bond / Investment Bond / Property / Approved Retirement Fund / Land / Other */
  whereFrom?: Maybe<AssetOrigin>;
};

export type AssetInput = {
  accessible?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether pension is currently active. Affects: Pension */
  active?: InputMaybe<Scalars['Boolean']['input']>;
  balance?: InputMaybe<Scalars['MoneyInput']['input']>;
  /** Affects: An Post State Savings Account / Life Company Savings Plan */
  frequency?: InputMaybe<PaymentFrequency>;
  /** Whether contributions are increasing each year. Affects: Pension */
  increasing?: InputMaybe<Scalars['Boolean']['input']>;
  isIrishLifePension?: InputMaybe<Scalars['Boolean']['input']>;
  /** Affects: Credit Union Account / Shares / Government Bond / Investment Bond / Other */
  maturityDate?: InputMaybe<Scalars['Date']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** Affects: Current account */
  overdrawnBy?: InputMaybe<Scalars['MoneyInput']['input']>;
  owners?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Affects: Pension */
  pensionType?: InputMaybe<PensionType>;
  productType: AssetType;
  /** Affects: Property */
  propertyType?: InputMaybe<PropertyType>;
  provider?: InputMaybe<Scalars['ID']['input']>;
  providerName?: InputMaybe<Scalars['String']['input']>;
  /** Affects: An Post State Savings Account / Pension / Life Company Savings Plan */
  regularPaymentAmount?: InputMaybe<Scalars['MoneyInput']['input']>;
  /** Affects: An Post State Savings Account / Life Company Savings Plan */
  startDate?: InputMaybe<Scalars['Date']['input']>;
  /** Whether pension is provided by current employer. Affects: Pension */
  throughCurrentEmployer?: InputMaybe<Scalars['Boolean']['input']>;
  /** Affects: Pension */
  valuationMethod?: InputMaybe<ValuationMethod>;
  /** Affects: Cash / Current Account / All Savings and Deposits / Credit Union Account / An Post State Savings Account / Shares / Government Bond / Investment Bond / Property / Approved Retirement Fund / Land / Other */
  whereFrom?: InputMaybe<AssetOrigin>;
};

/** Source of the asset balance */
export enum AssetOrigin {
  Bonus = 'BONUS',
  Borrowing = 'BORROWING',
  Compensation = 'COMPENSATION',
  Gift = 'GIFT',
  Inheritance = 'INHERITANCE',
  LifeAssuranceClaimDeath = 'LIFE_ASSURANCE_CLAIM_DEATH',
  LifeAssuranceClaimIllness = 'LIFE_ASSURANCE_CLAIM_ILLNESS',
  Other = 'OTHER',
  PensionLumpSum = 'PENSION_LUMP_SUM',
  Redundancy = 'REDUNDANCY',
  RegularSavings = 'REGULAR_SAVINGS',
  Reinvestment = 'REINVESTMENT',
  Salary = 'SALARY',
  SaleOfInvestment = 'SALE_OF_INVESTMENT',
  SaleOfTheFamilyHome = 'SALE_OF_THE_FAMILY_HOME',
  Windfall = 'WINDFALL'
}

export enum AssetType {
  AnPostSavingsAccount = 'AN_POST_SAVINGS_ACCOUNT',
  ApprovedRetirementFund = 'APPROVED_RETIREMENT_FUND',
  Cash = 'CASH',
  CreditUnionAccount = 'CREDIT_UNION_ACCOUNT',
  CurrentAccount = 'CURRENT_ACCOUNT',
  DepositTracker = 'DEPOSIT_TRACKER',
  GovernmentBond = 'GOVERNMENT_BOND',
  InvestmentBond = 'INVESTMENT_BOND',
  Land = 'LAND',
  LifeCompanySavingsPlan = 'LIFE_COMPANY_SAVINGS_PLAN',
  OtherAsset = 'OTHER_ASSET',
  Pension = 'PENSION',
  Property = 'PROPERTY',
  RegularSavingsDepositAccount = 'REGULAR_SAVINGS_DEPOSIT_ACCOUNT',
  SavingsDepositAccount = 'SAVINGS_DEPOSIT_ACCOUNT',
  Shares = 'SHARES',
  TermAccount = 'TERM_ACCOUNT'
}

export type AssetsInput = {
  accessible?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether pension is currently active. Affects: Pension */
  active?: InputMaybe<Scalars['Boolean']['input']>;
  assetId?: InputMaybe<Scalars['UUID']['input']>;
  balance?: InputMaybe<Scalars['MoneyInput']['input']>;
  /** Affects: An Post State Savings Account / Life Company Savings Plan */
  frequency?: InputMaybe<PaymentFrequency>;
  /** Whether contributions are increasing each year. Affects: Pension */
  increasing?: InputMaybe<Scalars['Boolean']['input']>;
  /** Affects: Credit Union Account / Shares / Government Bond / Investment Bond / Other */
  maturityDate?: InputMaybe<Scalars['Date']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** Affects: Current account */
  overdrawnBy?: InputMaybe<Scalars['MoneyInput']['input']>;
  owners?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Affects: Pension */
  pensionType?: InputMaybe<PensionType>;
  productType: AssetType;
  /** Affects: Property */
  propertyType?: InputMaybe<PropertyType>;
  provider?: InputMaybe<Scalars['ID']['input']>;
  providerName?: InputMaybe<Scalars['String']['input']>;
  /** Affects: An Post State Savings Account / Pension / Life Company Savings Plan */
  regularPaymentAmount?: InputMaybe<Scalars['MoneyInput']['input']>;
  /** Affects: An Post State Savings Account / Life Company Savings Plan */
  startDate?: InputMaybe<Scalars['Date']['input']>;
  /** Whether pension is provided by current employer. Affects: Pension */
  throughCurrentEmployer?: InputMaybe<Scalars['Boolean']['input']>;
  /** Affects: Pension */
  valuationMethod?: InputMaybe<ValuationMethod>;
  /** Affects: Cash / Current Account / All Savings and Deposits / Credit Union Account / An Post State Savings Account / Shares / Government Bond / Investment Bond / Property / Approved Retirement Fund / Land / Other */
  whereFrom?: InputMaybe<AssetOrigin>;
};

export enum AuthorisationStatus {
  AdviceApproved = 'ADVICE_APPROVED',
  AwaitingUserInfo = 'AWAITING_USER_INFO',
  AwaitingUserKycAction = 'AWAITING_USER_KYC_ACTION',
  Error = 'ERROR',
  FailedKyc = 'FAILED_KYC',
  GuidanceDuringSuspend = 'GUIDANCE_DURING_SUSPEND',
  GuidancePendingReview = 'GUIDANCE_PENDING_REVIEW',
  PendingKyc = 'PENDING_KYC',
  PendingReview = 'PENDING_REVIEW',
  Referred = 'REFERRED',
  Rejected = 'REJECTED',
  Suspended = 'SUSPENDED',
  Triaged = 'TRIAGED'
}

export type AvailableAppointment = {
  __typename: 'AvailableAppointment';
  endTime: Scalars['Datetime']['output'];
  id: Scalars['ID']['output'];
  startTime: Scalars['Datetime']['output'];
};

export type AvailableAppointmentDay = {
  __typename: 'AvailableAppointmentDay';
  date: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
};

/** Specifies the biological sex of a person */
export enum BiologicalSex {
  Female = 'FEMALE',
  Male = 'MALE'
}

export type BookAppointmentInput = {
  /** Any other notes about the appointment */
  notes?: InputMaybe<Scalars['String']['input']>;
  /** Reason for the appointment */
  reason?: InputMaybe<Scalars['String']['input']>;
  /** Start time of the appointment */
  startTime: Scalars['Datetime']['input'];
  /** The id of the user */
  userId: Scalars['ID']['input'];
};

export type BookAppointmentPayload = MutationPayload & {
  __typename: 'BookAppointmentPayload';
  appointment?: Maybe<Appointment>;
  error?: Maybe<ErrorType>;
  success: Scalars['Boolean']['output'];
};

export type BreakdownSlice = {
  __typename: 'BreakdownSlice';
  amount: Money;
  name: Scalars['String']['output'];
};

export type ChangeEmailVerificationInput = {
  /** The new email */
  email: Scalars['String']['input'];
  /** The ID of the user */
  userId: Scalars['ID']['input'];
};

export type ChangeEmailVerificationPayload = MutationPayload & {
  __typename: 'ChangeEmailVerificationPayload';
  /** The new email, if the mutation is successful */
  email?: Maybe<Scalars['String']['output']>;
  error?: Maybe<ErrorType>;
  success: Scalars['Boolean']['output'];
};

export type ChildPerson = {
  __typename: 'ChildPerson';
  dateOfBirth?: Maybe<Scalars['Date']['output']>;
  id: Scalars['ID']['output'];
};

export type CollegeCalculatorInput = {
  accommodation: AccommodationType;
  ageOfChild: Scalars['Int']['input'];
  courseDuration: Scalars['Int']['input'];
  eligibleForFreeTuitionFees: Scalars['Boolean']['input'];
  userId?: InputMaybe<Scalars['ID']['input']>;
  whatToInclude: Array<WhatToIncludeType>;
};

export type CollegeCost = {
  __typename: 'CollegeCost';
  accommodationCost?: Maybe<Money>;
  accommodationType?: Maybe<AccommodationType>;
  ageOfChild?: Maybe<Scalars['Int']['output']>;
  annualCost?: Maybe<Money>;
  courseDuration?: Maybe<Scalars['Int']['output']>;
  eligibleForFreeTuitionFees?: Maybe<Scalars['Boolean']['output']>;
  fees?: Maybe<Money>;
  goalId?: Maybe<Scalars['ID']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  monthlySavingsRequired?: Maybe<Money>;
  otherExpenses?: Maybe<Money>;
  targetDate?: Maybe<Scalars['Date']['output']>;
  total?: Maybe<Money>;
  totalAdjustedForInflation?: Maybe<Money>;
  userId?: Maybe<Scalars['ID']['output']>;
  whatToInclude?: Maybe<Array<Maybe<WhatToIncludeType>>>;
};

export type ComparisonBlock = {
  __typename: 'ComparisonBlock';
  features: Array<ComparisonFeature>;
  packages: Array<ComparisonPackage>;
};

export type ComparisonFeature = {
  __typename: 'ComparisonFeature';
  description?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type ComparisonPackage = {
  __typename: 'ComparisonPackage';
  cost: Money;
  features: Array<Scalars['String']['output']>;
  name: Scalars['String']['output'];
};

export type Consent = {
  __typename: 'Consent';
  checkInEmails?: Maybe<Scalars['Boolean']['output']>;
  contactServicesIrishLifeGroup?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  userResearch?: Maybe<Scalars['Boolean']['output']>;
};

export type ConsentInput = {
  checkInEmails?: InputMaybe<Scalars['Boolean']['input']>;
  contactServicesIrishLifeGroup?: InputMaybe<Scalars['Boolean']['input']>;
  userResearch?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContentBlock = ComparisonBlock | MarkdownBlock | UrlBlock;

export type Country = {
  __typename: 'Country';
  code: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type County = {
  __typename: 'County';
  code: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export enum CoverForScenario {
  Covered = 'COVERED',
  NotCovered = 'NOT_COVERED',
  PartiallyCovered = 'PARTIALLY_COVERED'
}

export enum CoverType {
  DeathInService = 'DEATH_IN_SERVICE',
  Decreasing = 'DECREASING',
  Level = 'LEVEL',
  MortgageProtection = 'MORTGAGE_PROTECTION',
  WholeOfLife = 'WHOLE_OF_LIFE'
}

/** Debt entered in fact find */
export type Debt = {
  __typename: 'Debt';
  arePaymentsUpToDate?: Maybe<Scalars['Boolean']['output']>;
  arrears?: Maybe<Money>;
  balance?: Maybe<Money>;
  clearedOnDeath?: Maybe<Scalars['Boolean']['output']>;
  /** Loan */
  endDate?: Maybe<Scalars['Date']['output']>;
  /** Mortgage */
  hasPaymentProtectionInsurance?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['UUID']['output'];
  isComplete: Scalars['Boolean']['output'];
  /** Mortgage */
  isMainMortgage?: Maybe<Scalars['Boolean']['output']>;
  /** Car Loan / Hire Purchase Agreement / Personal Loan / Other */
  maturityDate?: Maybe<Scalars['Date']['output']>;
  monthlyRepayment?: Maybe<Money>;
  /** Mortgage */
  mortgageType?: Maybe<MortgageType>;
  /** Mortgage */
  mortgageYearsLeft?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  owners?: Maybe<Array<Maybe<Person>>>;
  productType: DebtType;
  provider?: Maybe<Provider>;
  repaidMonthly?: Maybe<Scalars['Boolean']['output']>;
  userId: Scalars['ID']['output'];
};

export type DebtInput = {
  arePaymentsUpToDate?: InputMaybe<Scalars['Boolean']['input']>;
  arrears?: InputMaybe<Scalars['MoneyInput']['input']>;
  balance?: InputMaybe<Scalars['MoneyInput']['input']>;
  clearedOnDeath?: InputMaybe<Scalars['Boolean']['input']>;
  /** Loan */
  endDate?: InputMaybe<Scalars['Date']['input']>;
  /** Mortgage */
  hasPaymentProtectionInsurance?: InputMaybe<Scalars['Boolean']['input']>;
  /** Mortgage */
  isMainMortgage?: InputMaybe<Scalars['Boolean']['input']>;
  /** Car Loan / Hire Purchase Agreement / Personal Loan / Other */
  maturityDate?: InputMaybe<Scalars['Date']['input']>;
  monthlyRepayment?: InputMaybe<Scalars['MoneyInput']['input']>;
  /** Mortgage */
  mortgageType?: InputMaybe<MortgageType>;
  /** Mortgage */
  mortgageYearsLeft?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  owners?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  productType: DebtType;
  provider?: InputMaybe<Scalars['ID']['input']>;
  providerName?: InputMaybe<Scalars['String']['input']>;
  repaidMonthly?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DebtSummary = {
  __typename: 'DebtSummary';
  clearedBy: Scalars['String']['output'];
  idealMonthlyRepayment: Money;
  totalDebtAmount: Money;
};

export enum DebtType {
  CarLoan = 'CAR_LOAN',
  CreditCard = 'CREDIT_CARD',
  HirePurchaseAgreement = 'HIRE_PURCHASE_AGREEMENT',
  Loan = 'LOAN',
  Mortgage = 'MORTGAGE',
  OtherDebt = 'OTHER_DEBT',
  PersonalLoan = 'PERSONAL_LOAN'
}

export type DebtsInput = {
  arePaymentsUpToDate?: InputMaybe<Scalars['Boolean']['input']>;
  arrears?: InputMaybe<Scalars['MoneyInput']['input']>;
  balance?: InputMaybe<Scalars['MoneyInput']['input']>;
  clearedOnDeath?: InputMaybe<Scalars['Boolean']['input']>;
  debtId?: InputMaybe<Scalars['UUID']['input']>;
  /** Loan */
  endDate?: InputMaybe<Scalars['Date']['input']>;
  /** Mortgage */
  hasPaymentProtectionInsurance?: InputMaybe<Scalars['Boolean']['input']>;
  /** Mortgage */
  isMainMortgage?: InputMaybe<Scalars['Boolean']['input']>;
  /** Car Loan / Hire Purchase Agreement / Personal Loan / Other */
  maturityDate?: InputMaybe<Scalars['Date']['input']>;
  monthlyRepayment?: InputMaybe<Scalars['MoneyInput']['input']>;
  /** Mortgage */
  mortgageType?: InputMaybe<MortgageType>;
  /** Mortgage */
  mortgageYearsLeft?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  owners?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  productType: DebtType;
  provider?: InputMaybe<Scalars['ID']['input']>;
  providerName?: InputMaybe<Scalars['String']['input']>;
  repaidMonthly?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DeclineSurveyInput = {
  /** The user ID of the user */
  userId: Scalars['ID']['input'];
};

export type DeclineSurveyPayload = MutationPayload & {
  __typename: 'DeclineSurveyPayload';
  error?: Maybe<ErrorType>;
  success: Scalars['Boolean']['output'];
  survey?: Maybe<NpsSurvey>;
};

export type DeleteAssetInput = {
  assetId: Scalars['UUID']['input'];
  userId: Scalars['ID']['input'];
};

export type DeleteAssetPayload = MutationPayload & {
  __typename: 'DeleteAssetPayload';
  error?: Maybe<ErrorType>;
  success: Scalars['Boolean']['output'];
};

export type DeleteDebtInput = {
  debtId: Scalars['UUID']['input'];
  userId: Scalars['ID']['input'];
};

export type DeleteDebtPayload = MutationPayload & {
  __typename: 'DeleteDebtPayload';
  error?: Maybe<ErrorType>;
  success: Scalars['Boolean']['output'];
};

export type DeleteGoalInput = {
  goalId: Scalars['UUID']['input'];
  userId: Scalars['ID']['input'];
};

export type DeleteGoalPayload = MutationPayload & {
  __typename: 'DeleteGoalPayload';
  error?: Maybe<ErrorType>;
  success: Scalars['Boolean']['output'];
};

export type DeleteIncomeInput = {
  incomeId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};

export type DeleteIncomePayload = MutationPayload & {
  __typename: 'DeleteIncomePayload';
  error?: Maybe<ErrorType>;
  success: Scalars['Boolean']['output'];
};

export type DeletePersonInput = {
  personId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};

export type DeletePersonPayload = MutationPayload & {
  __typename: 'DeletePersonPayload';
  error?: Maybe<ErrorType>;
  success: Scalars['Boolean']['output'];
};

export type DeletePolicyInput = {
  policyId: Scalars['UUID']['input'];
  userId: Scalars['ID']['input'];
};

export type DeletePolicyPayload = MutationPayload & {
  __typename: 'DeletePolicyPayload';
  error?: Maybe<ErrorType>;
  success: Scalars['Boolean']['output'];
};

export type DeleteProductInput = {
  productId: Scalars['UUID']['input'];
  productType: Scalars['String']['input'];
  userId: Scalars['ID']['input'];
};

export type DeleteProductPayload = MutationPayload & {
  __typename: 'DeleteProductPayload';
  error?: Maybe<ErrorType>;
  success: Scalars['Boolean']['output'];
};

export type DeleteVulnerabilityReminderInput = {
  userId: Scalars['ID']['input'];
};

export type DeleteVulnerabilityReminderPayload = MutationPayload & {
  __typename: 'DeleteVulnerabilityReminderPayload';
  error?: Maybe<ErrorType>;
  success: Scalars['Boolean']['output'];
};

export enum DependantRelationship {
  Child = 'CHILD',
  OtherFamilyMember = 'OTHER_FAMILY_MEMBER',
  OtherNonFamilyMember = 'OTHER_NON_FAMILY_MEMBER',
  Parent = 'PARENT'
}

export type EmergencyFundProgress = {
  __typename: 'EmergencyFundProgress';
  currentProvision: Money;
  monthsProtected: Scalars['Int']['output'];
  progress: Scalars['Percentage']['output'];
  recommendedProtectedMonths: Scalars['Int']['output'];
  recommendedProvision: Money;
};

export type EmergencyFundSummary = {
  __typename: 'EmergencyFundSummary';
  emergencyFundProgress: EmergencyFundProgress;
};

export enum EmploymentStatus {
  Employed = 'EMPLOYED',
  Homemaker = 'HOMEMAKER',
  Retired = 'RETIRED',
  StudentOrTraining = 'STUDENT_OR_TRAINING',
  Unemployed = 'UNEMPLOYED'
}

export enum EmploymentType {
  CompanyDirector = 'COMPANY_DIRECTOR',
  CompanyDirector_20Pct = 'COMPANY_DIRECTOR_20PCT',
  RegularEmployment = 'REGULAR_EMPLOYMENT',
  SelfEmployed = 'SELF_EMPLOYED'
}

/** Error code to allow further front end behaviour depending on error */
export enum ErrorCode {
  /** Appointment is no longer available */
  AppointmentNotAvailable = 'APPOINTMENT_NOT_AVAILABLE',
  /** Insufficient funds to achieve mutation */
  InsufficientFunds = 'INSUFFICIENT_FUNDS',
  /** Internal server error - something went wrong server side, likely to be unexpected */
  InternalServerError = 'INTERNAL_SERVER_ERROR',
  /** Data is invalid in some way */
  InvalidData = 'INVALID_DATA',
  /** Object not found for a given ID, may have been deleted */
  ObjectNotFound = 'OBJECT_NOT_FOUND'
}

/** Standardised error response type for mutations */
export type ErrorType = {
  __typename: 'ErrorType';
  /** Error code to allow further front end behaviour depending on error */
  code: ErrorCode;
  /** Field errors, if present */
  fieldErrors?: Maybe<Scalars['FieldErrors']['output']>;
  /** User facing message describing the error */
  message: Scalars['String']['output'];
};

export type Factfind = {
  __typename: 'Factfind';
  /** Age of children */
  ageOfChildren?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  /** Extra Essential monthly spending should be (essentialOutgoings - monthlyRent - monthlyBills) */
  extraMonthlyOutgoingEssentials?: Maybe<Scalars['Float']['output']>;
  /** Does the user have children? */
  hasChildren?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the user has a mortgage on their home */
  hasMortgage?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  /** Whether the user has experience investing */
  investmentExperience?: Maybe<Scalars['Boolean']['output']>;
  /** User's marital status */
  maritalStatus?: Maybe<MaritalStatus>;
  /** Essential monthly spending - should be >= than monthlyRent + monthlyUtilities */
  monthlyOutgoingEssentials?: Maybe<Scalars['Float']['output']>;
  /** Non essential monthly spending */
  monthlyOutgoingNonEssentials?: Maybe<Scalars['Float']['output']>;
  /** Monthly rent */
  monthlyRent?: Maybe<Scalars['Float']['output']>;
  /** Monthly utilities cost */
  monthlyUtilities?: Maybe<Scalars['Float']['output']>;
  /** Number of children */
  numberOfChildren?: Maybe<Scalars['Int']['output']>;
  /** Number of other dependants */
  numberOfOtherDependants?: Maybe<Scalars['Int']['output']>;
  /** Any other dependants? */
  otherDependants?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the user owns their own home */
  ownsHome?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the user and partner live at the same address */
  partnerLivesAtSameAddress?: Maybe<Scalars['Boolean']['output']>;
  /** Additional factfind information relating to the user's partner */
  partnerSpecificFactfind?: Maybe<PersonFactfind>;
  /** Who the plan is for */
  planningFor?: Maybe<PlanScope>;
  /** Relationship to dependants */
  relationshipToDependants?: Maybe<DependantRelationship>;
  /** Relationship to dependants */
  relationshipToOtherDependants?: Maybe<Array<Maybe<DependantRelationship>>>;
  staleFields: Array<Maybe<StaleFields>>;
  /** Additional factfind information relating to the user */
  userSpecificFactfind?: Maybe<PersonFactfind>;
  /** Is the user vulnerable */
  vulnerable?: Maybe<Scalars['Boolean']['output']>;
};

export type FactfindContextFields = {
  __typename: 'FactfindContextFields';
  id: Scalars['ID']['output'];
  questionGroups: Array<QuestionGroup>;
};

export type FactfindInput = {
  /** Age of children */
  ageOfChildren?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** Extra Essential monthly spending should be (essentialOutgoings - monthlyRent - monthlyBills) */
  extraMonthlyOutgoingEssentials?: InputMaybe<Scalars['Float']['input']>;
  /** Does the user have children? (deprecated) */
  hasChildren?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether the user has a mortgage on their home */
  hasMortgage?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether the user has experience investing */
  investmentExperience?: InputMaybe<Scalars['Boolean']['input']>;
  /** User's marital status */
  maritalStatus?: InputMaybe<MaritalStatus>;
  /** Essential monthly spending - should be >= than monthlyRent + monthlyUtilities */
  monthlyOutgoingEssentials?: InputMaybe<Scalars['Float']['input']>;
  /** Non essential monthly spending */
  monthlyOutgoingNonEssentials?: InputMaybe<Scalars['Float']['input']>;
  /** Monthly rent */
  monthlyRent?: InputMaybe<Scalars['Float']['input']>;
  /** Monthly utilities cost */
  monthlyUtilities?: InputMaybe<Scalars['Float']['input']>;
  /** Number of children */
  numberOfChildren?: InputMaybe<Scalars['Int']['input']>;
  /** Number of other dependants */
  numberOfOtherDependants?: InputMaybe<Scalars['Int']['input']>;
  /** Any other dependants? */
  otherDependants?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether the user owns their own home */
  ownsHome?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether the user and partner live at the same address */
  partnerLivesAtSameAddress?: InputMaybe<Scalars['Boolean']['input']>;
  /** Additional factfind information relating to the user's partner */
  partnerSpecificFactfind?: InputMaybe<PersonFactfindInput>;
  /** Who the plan is for */
  planningFor?: InputMaybe<PlanScope>;
  /** Relationship to dependants */
  relationshipToDependants?: InputMaybe<DependantRelationship>;
  /** Relationship to dependants */
  relationshipToOtherDependants?: InputMaybe<Array<InputMaybe<DependantRelationship>>>;
  /** Additional factfind information relating to the user */
  userSpecificFactfind?: InputMaybe<PersonFactfindInput>;
  /** Is the user vulnerable */
  vulnerable?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FieldInput = {
  __typename: 'FieldInput';
  defaultValue?: Maybe<Scalars['FieldValue']['output']>;
  disabled?: Maybe<Scalars['Boolean']['output']>;
  format?: Maybe<Scalars['String']['output']>;
  max?: Maybe<Scalars['Int']['output']>;
  min?: Maybe<Scalars['Int']['output']>;
  options?: Maybe<Array<FieldOption>>;
  type: FieldInputType;
};

export enum FieldInputType {
  Address = 'ADDRESS',
  Checkbox = 'CHECKBOX',
  CheckboxButton = 'CHECKBOX_BUTTON',
  Country = 'COUNTRY',
  Currency = 'CURRENCY',
  DateDdMmYyyy = 'DATE_DD_MM_YYYY',
  DateMmYyyy = 'DATE_MM_YYYY',
  DisplayOnly = 'DISPLAY_ONLY',
  Duration = 'DURATION',
  Nationality = 'NATIONALITY',
  NumberFloat = 'NUMBER_FLOAT',
  NumberInteger = 'NUMBER_INTEGER',
  Occupation = 'OCCUPATION',
  Provider = 'PROVIDER',
  Radio = 'RADIO',
  RadioButton = 'RADIO_BUTTON',
  Select = 'SELECT',
  Slider = 'SLIDER',
  Text = 'TEXT',
  YesNo = 'YES_NO'
}

export type FieldOption = {
  __typename: 'FieldOption';
  label: Scalars['String']['output'];
  value: Scalars['FieldValue']['output'];
};

/** Goal entered in fact find */
export type Goal = {
  __typename: 'Goal';
  firstTimeBuyer?: Maybe<Scalars['Boolean']['output']>;
  goalData?: Maybe<Scalars['GoalData']['output']>;
  goalType?: Maybe<GoalType>;
  hasMortgage?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['UUID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  owners: Array<Maybe<Person>>;
  priority?: Maybe<Scalars['Int']['output']>;
  propertyValue?: Maybe<Scalars['MoneyInput']['output']>;
  targetDate?: Maybe<Scalars['Date']['output']>;
  userId: Scalars['ID']['output'];
  valueToSave?: Maybe<Money>;
};

export type GoalInput = {
  firstTimeBuyer?: InputMaybe<Scalars['Boolean']['input']>;
  goalData?: InputMaybe<Scalars['GoalData']['input']>;
  goalType?: InputMaybe<GoalType>;
  hasMortgage?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  owners?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  propertyValue?: InputMaybe<Scalars['MoneyInput']['input']>;
  targetDate?: InputMaybe<Scalars['Date']['input']>;
  valueToSave?: InputMaybe<Scalars['MoneyInput']['input']>;
};

export type GoalProgress = {
  __typename: 'GoalProgress';
  amountSaved: Money;
  goalType: GoalType;
  name: Scalars['String']['output'];
  progress?: Maybe<Scalars['Percentage']['output']>;
  targetAmount: Money;
};

export enum GoalType {
  BuyHome = 'BUY_HOME',
  ChildEducation = 'CHILD_EDUCATION',
  Custom = 'CUSTOM',
  Wedding = 'WEDDING'
}

export type GoalsInput = {
  goalData?: InputMaybe<Scalars['GoalData']['input']>;
  goalId: Scalars['UUID']['input'];
  goalType?: InputMaybe<GoalType>;
  name?: InputMaybe<Scalars['String']['input']>;
  owners?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  targetDate?: InputMaybe<Scalars['Date']['input']>;
  valueToSave?: InputMaybe<Scalars['MoneyInput']['input']>;
};

export type HealthCheck = {
  __typename: 'HealthCheck';
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export enum HealthCoverageStatus {
  Covered = 'COVERED',
  CoveredByIrishLife = 'COVERED_BY_IRISH_LIFE',
  Missing = 'MISSING'
}

export type HealthSummary = {
  __typename: 'HealthSummary';
  covered: HealthCoverageStatus;
  missing: Scalars['Boolean']['output'];
};

/** Income entered in fact find */
export type Income = {
  __typename: 'Income';
  annualBonus?: Maybe<Money>;
  annualIncome?: Maybe<Money>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  owners: Array<Maybe<Person>>;
  userId: Scalars['ID']['output'];
};

export type IncomeInput = {
  annualBonus?: InputMaybe<Scalars['MoneyInput']['input']>;
  annualIncome?: InputMaybe<Scalars['MoneyInput']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  owners?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

export enum IndustryType {
  AgricultureSelfEmployed = 'AGRICULTURE_SELF_EMPLOYED',
  ClericalAndSecretarial = 'CLERICAL_AND_SECRETARIAL',
  ManagerProfessionalAndAdmin = 'MANAGER_PROFESSIONAL_AND_ADMIN',
  Other = 'OTHER',
  PersonalAndProtectiveService = 'PERSONAL_AND_PROTECTIVE_SERVICE',
  PlantAndMachineOperatives = 'PLANT_AND_MACHINE_OPERATIVES',
  Sales = 'SALES',
  TradesCraftsAndRelated = 'TRADES_CRAFTS_AND_RELATED'
}

/** Interaction flag */
export type InteractionFlag = {
  __typename: 'InteractionFlag';
  id: Scalars['ID']['output'];
  value?: Maybe<Scalars['Boolean']['output']>;
};

export enum InvestingSummary {
  MoneyWorking = 'MONEY_WORKING',
  NeedsWork = 'NEEDS_WORK'
}

export type Link = {
  __typename: 'Link';
  text: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export enum MaritalStatus {
  CivilPartnership = 'CIVIL_PARTNERSHIP',
  Cohabitating = 'COHABITATING',
  Divorced = 'DIVORCED',
  Married = 'MARRIED',
  Separated = 'SEPARATED',
  Single = 'SINGLE',
  Widowed = 'WIDOWED'
}

/** List of message ids to be marked as read */
export type MarkAsReadInput = {
  messageIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  userId: Scalars['ID']['input'];
};

export type MarkAsReadPayload = MutationPayload & {
  __typename: 'MarkAsReadPayload';
  error?: Maybe<ErrorType>;
  messageIds?: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
  success: Scalars['Boolean']['output'];
};

export type MarkdownBlock = {
  __typename: 'MarkdownBlock';
  body?: Maybe<Scalars['String']['output']>;
  collapsible?: Maybe<Scalars['Boolean']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

/** A Single Message */
export type Message = {
  __typename: 'Message';
  /** Date message was created */
  dateReceived: Scalars['Date']['output'];
  /** UUID of the message */
  id: Scalars['ID']['output'];
  /** Url for message content */
  link?: Maybe<Scalars['String']['output']>;
  /** Indicates whether a message has been read, false by default */
  read: Scalars['Boolean']['output'];
  /** Message subtitle copy */
  subtitle?: Maybe<Scalars['String']['output']>;
  /** Message title copy */
  title: Scalars['String']['output'];
};

/** Monetary type */
export type Money = {
  __typename: 'Money';
  /** Display format (including currency, commas) representation of the monetary amount */
  display: Scalars['String']['output'];
  /** Floting point representation of the monetary amount */
  float: Scalars['Float']['output'];
  /** String representation of the monetary amount */
  string: Scalars['String']['output'];
};

export enum MortgageType {
  InterestOnly = 'INTEREST_ONLY',
  Repayment = 'REPAYMENT',
  Warehoused = 'WAREHOUSED'
}

export type Mutation = {
  __typename: 'Mutation';
  bookAppointment: BookAppointmentPayload;
  changeEmailVerification?: Maybe<ChangeEmailVerificationPayload>;
  /** New Survey Results */
  createNewSurvey: NewSurveyPayload;
  /** Decline Survey */
  declineSurvey: DeclineSurveyPayload;
  /** Delete a single asset */
  deleteAsset?: Maybe<DeleteAssetPayload>;
  /** Delete a single debt */
  deleteDebt?: Maybe<DeleteDebtPayload>;
  /** Deletes a goal */
  deleteGoal?: Maybe<DeleteGoalPayload>;
  deleteIncome?: Maybe<DeleteIncomePayload>;
  deletePerson: DeletePersonPayload;
  /** Delete a single policy */
  deletePolicy?: Maybe<DeletePolicyPayload>;
  /** Delete a single product */
  deleteProduct?: Maybe<DeleteProductPayload>;
  /** Delete a reminder for a vulnerable user */
  deleteVulnerabilityReminder: DeleteVulnerabilityReminderPayload;
  /** Mark a message as read */
  markAsRead: MarkAsReadPayload;
  /** Kick off plan generation for a user */
  requestPlan: RequestPlanPayload;
  /** Set a reminder for a vulnerable user in 3 months */
  setVulnerabilityReminder: SetVulnerabilityReminderPayload;
  /** Sign up a new user (after firebase sign up) */
  signUp?: Maybe<SignUpPayload>;
  /** Update or submit the user's prsa pension application */
  submitPensionApplication: SubmissionPayload;
  /** New tool subscription */
  subscribeToTool: NewToolPayload;
  /** Suggest new tool */
  suggestNewTool: NewToolPayload;
  /** Sync user data from MIL token */
  syncUser?: Maybe<SyncUserPayload>;
  /** Update or insert the properties of a single asset */
  updateAsset?: Maybe<UpdateAssetPayload>;
  /** Update the properties of multiple asset */
  updateAssets?: Maybe<UpdateAssetsPayload>;
  updateCheckIn: CheckInPayload;
  updateCollegeCosts: CollegeCost;
  updateConsent: UpdateConsentPayload;
  /** Update or insert the properties of a single debt */
  updateDebt?: Maybe<UpdateDebtPayload>;
  /** Update the properties of multiple debts */
  updateDebts?: Maybe<UpdateDebtsPayload>;
  /** Update email */
  updateEmail?: Maybe<UpdateEmailPayload>;
  /** Update the user's factfind */
  updateFactfind: UpdateFactfindPayload;
  /** Updates a goal */
  updateGoal?: Maybe<UpdateGoalPayload>;
  /** Updates multiple goals */
  updateGoals?: Maybe<UpdateGoalsPayload>;
  updateIncome?: Maybe<UpdateIncomePayload>;
  /** Update the value of an interaction flag */
  updateInteractionFlag: UpdateInteractionFlagPayload;
  /** Update the user's prsa pension application */
  updatePensionApplication: PrsaPensionApplicationPayload;
  /** Update a single person (user / partner) */
  updatePerson: UpdatePersonPayload;
  /** Update the properties of multiple policies */
  updatePolicies?: Maybe<UpdatePoliciesPayload>;
  /** Update or insert the properties of a single policy */
  updatePolicy?: Maybe<UpdatePolicyPayload>;
  /** Update or insert the properties of a single product */
  updateProduct?: Maybe<UpdateProductPayload>;
  /** Update the properties of multiple products */
  updateProducts?: Maybe<UpdateProductsPayload>;
  /** Update risk profile information */
  updateRisk: UpdateRiskPayload;
};


export type MutationBookAppointmentArgs = {
  input: BookAppointmentInput;
};


export type MutationChangeEmailVerificationArgs = {
  input?: InputMaybe<ChangeEmailVerificationInput>;
};


export type MutationCreateNewSurveyArgs = {
  input: NewSurveyInput;
};


export type MutationDeclineSurveyArgs = {
  input: DeclineSurveyInput;
};


export type MutationDeleteAssetArgs = {
  input?: InputMaybe<DeleteAssetInput>;
};


export type MutationDeleteDebtArgs = {
  input?: InputMaybe<DeleteDebtInput>;
};


export type MutationDeleteGoalArgs = {
  input?: InputMaybe<DeleteGoalInput>;
};


export type MutationDeleteIncomeArgs = {
  input?: InputMaybe<DeleteIncomeInput>;
};


export type MutationDeletePersonArgs = {
  input?: InputMaybe<DeletePersonInput>;
};


export type MutationDeletePolicyArgs = {
  input?: InputMaybe<DeletePolicyInput>;
};


export type MutationDeleteProductArgs = {
  input?: InputMaybe<DeleteProductInput>;
};


export type MutationDeleteVulnerabilityReminderArgs = {
  input: DeleteVulnerabilityReminderInput;
};


export type MutationMarkAsReadArgs = {
  input: MarkAsReadInput;
};


export type MutationRequestPlanArgs = {
  input: RequestPlanInput;
};


export type MutationSetVulnerabilityReminderArgs = {
  input: SetVulnerabilityReminderInput;
};


export type MutationSignUpArgs = {
  input?: InputMaybe<SignUpInput>;
};


export type MutationSubmitPensionApplicationArgs = {
  input: SubmitPrsaPensionApplicationInput;
};


export type MutationSubscribeToToolArgs = {
  input: NewToolInput;
};


export type MutationSuggestNewToolArgs = {
  input: NewToolInput;
};


export type MutationSyncUserArgs = {
  input?: InputMaybe<SyncUserInput>;
};


export type MutationUpdateAssetArgs = {
  input?: InputMaybe<UpdateAssetInput>;
};


export type MutationUpdateAssetsArgs = {
  input?: InputMaybe<UpdateAssetsInput>;
};


export type MutationUpdateCheckInArgs = {
  input: UpdateCheckInInput;
};


export type MutationUpdateCollegeCostsArgs = {
  input: CollegeCalculatorInput;
};


export type MutationUpdateConsentArgs = {
  input: UpdateConsentInput;
};


export type MutationUpdateDebtArgs = {
  input?: InputMaybe<UpdateDebtInput>;
};


export type MutationUpdateDebtsArgs = {
  input?: InputMaybe<UpdateDebtsInput>;
};


export type MutationUpdateEmailArgs = {
  input?: InputMaybe<UpdateEmailInput>;
};


export type MutationUpdateFactfindArgs = {
  input: UpdateFactfindInput;
};


export type MutationUpdateGoalArgs = {
  input?: InputMaybe<UpdateGoalInput>;
};


export type MutationUpdateGoalsArgs = {
  input?: InputMaybe<UpdateGoalsInput>;
};


export type MutationUpdateIncomeArgs = {
  input?: InputMaybe<UpdateIncomeInput>;
};


export type MutationUpdateInteractionFlagArgs = {
  input: UpdateInteractionFlagInput;
};


export type MutationUpdatePensionApplicationArgs = {
  input: UpdatePrsaPensionApplicationInput;
};


export type MutationUpdatePersonArgs = {
  input: UpdatePersonInput;
};


export type MutationUpdatePoliciesArgs = {
  input?: InputMaybe<UpdatePoliciesInput>;
};


export type MutationUpdatePolicyArgs = {
  input?: InputMaybe<UpdatePolicyInput>;
};


export type MutationUpdateProductArgs = {
  input?: InputMaybe<UpdateProductInput>;
};


export type MutationUpdateProductsArgs = {
  input?: InputMaybe<UpdateProductsInput>;
};


export type MutationUpdateRiskArgs = {
  input: UpdateRiskInput;
};

export type MutationPayload = {
  /** Error information, if present */
  error?: Maybe<ErrorType>;
  /** Whether the mutation was successful */
  success: Scalars['Boolean']['output'];
};

export type NpsSurvey = {
  __typename: 'NPSSurvey';
  completed: Scalars['Boolean']['output'];
  feedback?: Maybe<Scalars['String']['output']>;
  followUp?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  score?: Maybe<Scalars['Int']['output']>;
  userId: Scalars['ID']['output'];
};

export type NewSurveyInput = {
  /** Suggested feedback */
  feedback?: InputMaybe<Scalars['String']['input']>;
  /** Follow up with user */
  followUp?: InputMaybe<Scalars['Boolean']['input']>;
  /** Likelyhood of reccomendation */
  score: Scalars['Int']['input'];
  /** The user ID of the user */
  userId: Scalars['ID']['input'];
};

export type NewSurveyPayload = MutationPayload & {
  __typename: 'NewSurveyPayload';
  error?: Maybe<ErrorType>;
  success: Scalars['Boolean']['output'];
  survey?: Maybe<NpsSurvey>;
};

export type NewToolInput = {
  /** Tool subscribe to */
  tool?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the user */
  userId: Scalars['ID']['input'];
};

export type NewToolPayload = MutationPayload & {
  __typename: 'NewToolPayload';
  error?: Maybe<ErrorType>;
  success: Scalars['Boolean']['output'];
  tool?: Maybe<Scalars['String']['output']>;
};

export enum PrsaFund {
  GlobalCashFund = 'GLOBAL_CASH_FUND',
  PensionPortfolio_2 = 'PENSION_PORTFOLIO_2',
  PensionPortfolio_3 = 'PENSION_PORTFOLIO_3',
  PensionPortfolio_4 = 'PENSION_PORTFOLIO_4',
  PensionPortfolio_5 = 'PENSION_PORTFOLIO_5',
  PensionPortfolio_6 = 'PENSION_PORTFOLIO_6'
}

export type PrsaFundRecommendation = {
  __typename: 'PRSAFundRecommendation';
  fund: PrsaFund;
  percentage: Scalars['Float']['output'];
};

export type PrsaPensionApplication = {
  __typename: 'PRSAPensionApplication';
  id: Scalars['UUID']['output'];
  monthlyContributionFundSplit?: Maybe<PensionFund>;
  oneOffContribution?: Maybe<Scalars['Boolean']['output']>;
  oneOffContributionFundSplit?: Maybe<PensionFund>;
  pensionContributionStartDate?: Maybe<Scalars['Date']['output']>;
  pensionDayOfDirectDebits?: Maybe<Scalars['Int']['output']>;
  pensionInflationProtection?: Maybe<Scalars['Boolean']['output']>;
  pensionSelfContribution?: Maybe<Money>;
  singleEmployeeContribution?: Maybe<Money>;
  submittedPrsaApplication?: Maybe<Scalars['Boolean']['output']>;
  submittedPrsaApplicationDate?: Maybe<Scalars['Date']['output']>;
};

export type PrsaPensionApplicationInput = {
  id?: InputMaybe<Scalars['UUID']['input']>;
  monthlyContributionFundSplit?: InputMaybe<PensionFundInput>;
  oneOffContribution?: InputMaybe<Scalars['Boolean']['input']>;
  oneOffContributionFundSplit?: InputMaybe<PensionFundInput>;
  pensionContributionStartDate?: InputMaybe<Scalars['Date']['input']>;
  pensionDayOfDirectDebits?: InputMaybe<Scalars['Int']['input']>;
  pensionInflationProtection?: InputMaybe<Scalars['Boolean']['input']>;
  pensionSelfContribution?: InputMaybe<Scalars['MoneyInput']['input']>;
  singleEmployeeContribution?: InputMaybe<Scalars['MoneyInput']['input']>;
};

export type PrsaPensionApplicationPayload = MutationPayload & {
  __typename: 'PRSAPensionApplicationPayload';
  error?: Maybe<ErrorType>;
  fields?: Maybe<FactfindContextFields>;
  /** The user's prsa pension application details */
  prsaPensionApplication?: Maybe<PrsaPensionApplication>;
  success: Scalars['Boolean']['output'];
  validationErrors?: Maybe<Scalars['FactfindErrors']['output']>;
};

export enum PaymentFrequency {
  Halfyearly = 'HALFYEARLY',
  Monthly = 'MONTHLY',
  Quarterly = 'QUARTERLY',
  Yearly = 'YEARLY'
}

export type PensionAtDate = {
  __typename: 'PensionAtDate';
  age: Scalars['Int']['output'];
  date: Scalars['Date']['output'];
  employmentIncome: Money;
  personalPensionAmount: Money;
  statePensionAmount: Money;
  targetIncome: Money;
  totalPensionAmount: Money;
};

export type PensionCalculation = {
  __typename: 'PensionCalculation';
  pensionProjection: Array<Maybe<PensionAtDate>>;
};

export type PensionCalculatorInput = {
  contributionPerMonth?: InputMaybe<Scalars['Float']['input']>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  oneOffContribution?: InputMaybe<Scalars['Float']['input']>;
  retirementAge?: InputMaybe<Scalars['Float']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
  targetMonthlyIncome?: InputMaybe<Scalars['Float']['input']>;
  userId: Scalars['ID']['input'];
};

export type PensionFund = {
  __typename: 'PensionFund';
  globalCashFund?: Maybe<Scalars['Float']['output']>;
  pensionPortfolio2?: Maybe<Scalars['Float']['output']>;
  pensionPortfolio3?: Maybe<Scalars['Float']['output']>;
  pensionPortfolio4?: Maybe<Scalars['Float']['output']>;
  pensionPortfolio5?: Maybe<Scalars['Float']['output']>;
  pensionPortfolio6?: Maybe<Scalars['Float']['output']>;
};

export type PensionFundInput = {
  globalCashFund?: InputMaybe<Scalars['Float']['input']>;
  pensionPortfolio2?: InputMaybe<Scalars['Float']['input']>;
  pensionPortfolio3?: InputMaybe<Scalars['Float']['input']>;
  pensionPortfolio4?: InputMaybe<Scalars['Float']['input']>;
  pensionPortfolio5?: InputMaybe<Scalars['Float']['input']>;
  pensionPortfolio6?: InputMaybe<Scalars['Float']['input']>;
};

export enum PensionType {
  Amrf = 'AMRF',
  Arf = 'ARF',
  AvcPension = 'AVC_PENSION',
  CompanyPension = 'COMPANY_PENSION',
  DefinedBenefit = 'DEFINED_BENEFIT',
  DefinedContribution = 'DEFINED_CONTRIBUTION',
  ExecutivePension = 'EXECUTIVE_PENSION',
  PerformancePrsa = 'PERFORMANCE_PRSA',
  PersonalPension = 'PERSONAL_PENSION',
  PersonalRetirementBond = 'PERSONAL_RETIREMENT_BOND',
  StandardPrsa = 'STANDARD_PRSA'
}

/** Readable fields for a single person */
export type Person = {
  __typename: 'Person';
  address?: Maybe<Address>;
  addressAssociations: Array<Maybe<AddressAssociation>>;
  amlCheckDetails?: Maybe<Scalars['RawJSONForDebugging']['output']>;
  amlCheckOutcome?: Maybe<Scalars['String']['output']>;
  amlCheckPassed?: Maybe<Scalars['Boolean']['output']>;
  dateOfBirth?: Maybe<Scalars['Date']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isFinanciallyDependant?: Maybe<Scalars['Boolean']['output']>;
  joinDate?: Maybe<Scalars['Date']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  legalFirstName?: Maybe<Scalars['String']['output']>;
  legalLastName?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  relationship?: Maybe<Relationship>;
  sex?: Maybe<BiologicalSex>;
  title?: Maybe<Scalars['String']['output']>;
};

export type PersonFactfind = {
  __typename: 'PersonFactfind';
  NINumber?: Maybe<Scalars['String']['output']>;
  PPSNumber?: Maybe<Scalars['String']['output']>;
  USConnectedIndividual?: Maybe<Scalars['Boolean']['output']>;
  /** Address */
  address?: Maybe<Address>;
  allowancesCurrentTaxYear?: Maybe<Allowances>;
  /** Base income before bonus of comission */
  baseAnnualIncomeGross?: Maybe<Scalars['Float']['output']>;
  benefitInKind?: Maybe<Money>;
  birthCountry?: Maybe<Scalars['String']['output']>;
  /** Date of birth */
  dateOfBirth?: Maybe<Scalars['Date']['output']>;
  /** whether person is director / owner of a limited company */
  directorOrOwnerOfLimitedCompany?: Maybe<Scalars['Boolean']['output']>;
  domicileCountry?: Maybe<Scalars['String']['output']>;
  /** How long have they lived at their address */
  durationAtAddress?: Maybe<Scalars['Int']['output']>;
  /** Is eligible for state pension */
  eligibleForStatePension?: Maybe<Scalars['Boolean']['output']>;
  employer?: Maybe<Scalars['String']['output']>;
  employerAddressLine1?: Maybe<Scalars['String']['output']>;
  employerAddressLine2?: Maybe<Scalars['String']['output']>;
  employerAddressLine3?: Maybe<Scalars['String']['output']>;
  /** Whether the persons employer provides them with any income protection */
  employerIncomeProtection?: Maybe<Scalars['Boolean']['output']>;
  /** Whether current employer offers a pension scheme */
  employerOffersPensionScheme?: Maybe<Scalars['Boolean']['output']>;
  /** Employment status */
  employmentStatus?: Maybe<EmploymentStatus>;
  expatriate?: Maybe<Scalars['Boolean']['output']>;
  /** Expected annual bonus / comission */
  expectedBonusAmount?: Maybe<Scalars['Float']['output']>;
  /** Expected annual income from other employment */
  expectedOtherIncomeAmount?: Maybe<Scalars['Float']['output']>;
  /** First name */
  firstName?: Maybe<Scalars['String']['output']>;
  /** Has any bonus / commission */
  hasBonus?: Maybe<Scalars['Boolean']['output']>;
  /** Whether person is in good health */
  hasGoodHealth?: Maybe<Scalars['Boolean']['output']>;
  /** Any other sources of income? */
  hasOtherIncome?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the person has a pension */
  hasPension?: Maybe<Scalars['Boolean']['output']>;
  hasValidWill?: Maybe<Scalars['Boolean']['output']>;
  industry?: Maybe<IndustryType>;
  /** Last name */
  lastName?: Maybe<Scalars['String']['output']>;
  /** Primary income type */
  mainEmploymentType?: Maybe<EmploymentType>;
  /** Marginal tax rate in decimal format, N/A if null  */
  marginalTaxRate?: Maybe<Scalars['Float']['output']>;
  /** Whether person is member of employers pension scheme */
  memberOfEmployersPensionScheme?: Maybe<Scalars['Boolean']['output']>;
  /** Monthly income net of tax */
  monthlyIncomeNet?: Maybe<Scalars['Float']['output']>;
  /** Expected outgoings in retirement */
  monthlyRetirementOutgoingExpected?: Maybe<Scalars['Float']['output']>;
  /** How many months the person could financially survive for following an accident or injury, N/A if null, nonspecifically longer than 12 months if value above 12' */
  monthsOfFinancialSafety?: Maybe<Scalars['Int']['output']>;
  nationality?: Maybe<Scalars['String']['output']>;
  /** Occupation */
  occupation?: Maybe<Scalars['String']['output']>;
  pensionSchemeIsIrishLife?: Maybe<Scalars['Boolean']['output']>;
  pep?: Maybe<Scalars['Boolean']['output']>;
  /** Person */
  person?: Maybe<Person>;
  powerOfAttorneyGranted?: Maybe<Scalars['Boolean']['output']>;
  residentCountry?: Maybe<Scalars['String']['output']>;
  /** Estimated retirement age */
  retirementAgeEstimate?: Maybe<Scalars['Int']['output']>;
  /** Smoking status */
  smokingStatus?: Maybe<SmokingStatus>;
  staleFields: Array<Maybe<StaleFields>>;
  /** title */
  title?: Maybe<Scalars['String']['output']>;
  willUpToDate?: Maybe<Scalars['Boolean']['output']>;
};

export type PersonFactfindInput = {
  NINumber?: InputMaybe<Scalars['String']['input']>;
  PPSNumber?: InputMaybe<Scalars['String']['input']>;
  USConnectedIndividual?: InputMaybe<Scalars['Boolean']['input']>;
  /** Address */
  address?: InputMaybe<AddressInput>;
  allowancesCurrentTaxYear?: InputMaybe<AllowancesInput>;
  /** Base income before bonus of comission */
  baseAnnualIncomeGross?: InputMaybe<Scalars['Float']['input']>;
  benefitInKind?: InputMaybe<Scalars['MoneyInput']['input']>;
  birthCountry?: InputMaybe<Scalars['String']['input']>;
  /** Date of birth */
  dateOfBirth?: InputMaybe<Scalars['Date']['input']>;
  /** whether person is director / owner of a limited company */
  directorOrOwnerOfLimitedCompany?: InputMaybe<Scalars['Boolean']['input']>;
  domicileCountry?: InputMaybe<Scalars['String']['input']>;
  /** Is eligible for state pension */
  eligibleForStatePension?: InputMaybe<Scalars['Boolean']['input']>;
  employer?: InputMaybe<Scalars['String']['input']>;
  employerAddressLine1?: InputMaybe<Scalars['String']['input']>;
  employerAddressLine2?: InputMaybe<Scalars['String']['input']>;
  employerAddressLine3?: InputMaybe<Scalars['String']['input']>;
  /** Whether current employer offers a pension scheme */
  employerOffersPensionScheme?: InputMaybe<Scalars['Boolean']['input']>;
  /** Employment status */
  employmentStatus?: InputMaybe<EmploymentStatus>;
  expatriate?: InputMaybe<Scalars['Boolean']['input']>;
  /** Expected annual bonus / comission */
  expectedBonusAmount?: InputMaybe<Scalars['Float']['input']>;
  /** Expected annual income from other employment */
  expectedOtherIncomeAmount?: InputMaybe<Scalars['Float']['input']>;
  /** First name */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** Has any bonus / commission */
  hasBonus?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether person is in good health */
  hasGoodHealth?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other sources of income? */
  hasOtherIncome?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether the person has a pension */
  hasPension?: InputMaybe<Scalars['Boolean']['input']>;
  hasValidWill?: InputMaybe<Scalars['Boolean']['input']>;
  industry?: InputMaybe<IndustryType>;
  /** Last name */
  lastName?: InputMaybe<Scalars['String']['input']>;
  /** Primary income type */
  mainEmploymentType?: InputMaybe<EmploymentType>;
  /** Marginal tax rate in decimal format, leave unspecified if N/A  */
  marginalTaxRate?: InputMaybe<Scalars['Float']['input']>;
  /** Whether person is member of employers pension scheme */
  memberOfEmployersPensionScheme?: InputMaybe<Scalars['Boolean']['input']>;
  /** Monthly income net of tax */
  monthlyIncomeNet?: InputMaybe<Scalars['Float']['input']>;
  /** Expected outgoings in retirement */
  monthlyRetirementOutgoingExpected?: InputMaybe<Scalars['Float']['input']>;
  /** How many months the person could financially survive for following an accident or injury, leave unspecified if N/A, input a value >12 if answer is 'Longer' */
  monthsOfFinancialSafety?: InputMaybe<Scalars['Int']['input']>;
  nationality?: InputMaybe<Scalars['String']['input']>;
  /** Occupation */
  occupation?: InputMaybe<Scalars['String']['input']>;
  pensionSchemeIsIrishLife?: InputMaybe<Scalars['Boolean']['input']>;
  pep?: InputMaybe<Scalars['Boolean']['input']>;
  /** Person data */
  person?: InputMaybe<PersonInput>;
  powerOfAttorneyGranted?: InputMaybe<Scalars['Boolean']['input']>;
  residentCountry?: InputMaybe<Scalars['String']['input']>;
  /** Estimated retirement age */
  retirementAgeEstimate?: InputMaybe<Scalars['Int']['input']>;
  /** Smoking status */
  smokingStatus?: InputMaybe<SmokingStatus>;
  /** title */
  title?: InputMaybe<Scalars['String']['input']>;
  willUpToDate?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Person fields that can be updated */
export type PersonInput = {
  address?: InputMaybe<AddressInput>;
  addressAssociations?: InputMaybe<Array<InputMaybe<AddressAssociationInput>>>;
  dateOfBirth?: InputMaybe<Scalars['Date']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  isFinanciallyDependant?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  legalFirstName?: InputMaybe<Scalars['String']['input']>;
  legalLastName?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  relationship?: InputMaybe<Relationship>;
  sex?: InputMaybe<BiologicalSex>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** A user's financial plan */
export type Plan = {
  __typename: 'Plan';
  /** Base64 encoded image of advisor */
  advisorPhoto?: Maybe<Scalars['Base64ImageString']['output']>;
  authorisationStatus?: Maybe<AuthorisationStatus>;
  factfindErrors?: Maybe<Scalars['FactfindErrors']['output']>;
  /** UUID for the plan */
  id: Scalars['ID']['output'];
  ilCrmData?: Maybe<Scalars['RawJSONForDebugging']['output']>;
  /** When the plan was last regenerated */
  lastUpdated?: Maybe<Scalars['Date']['output']>;
  monthlyAllocationAmount?: Maybe<Money>;
  recommendationGroups?: Maybe<Array<RecommendationGroup>>;
  /** Suitability report related to the plan, if available */
  suitabilityReportLink?: Maybe<Scalars['String']['output']>;
  triageReason?: Maybe<Scalars['String']['output']>;
};

/** Scope of the advice to be generated */
export enum PlanScope {
  User = 'USER',
  UserAndKids = 'USER_AND_KIDS',
  UserAndPartner = 'USER_AND_PARTNER',
  UserAndPartnerAndKids = 'USER_AND_PARTNER_AND_KIDS'
}

export type PoliciesInput = {
  /** Affects: All but health insurance */
  amountOfCover?: InputMaybe<Scalars['MoneyInput']['input']>;
  /** Affects: Life Cover */
  coverType?: InputMaybe<CoverType>;
  /** Affects: Health insurance */
  isIrishLifePolicy?: InputMaybe<Scalars['Boolean']['input']>;
  isOnePlan?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  owners?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Affects: All but health insurance */
  paymentFrequency?: InputMaybe<PaymentFrequency>;
  policyId?: InputMaybe<Scalars['UUID']['input']>;
  /** Affects: All but health insurance */
  premium?: InputMaybe<Scalars['MoneyInput']['input']>;
  productType: PolicyType;
  provider?: InputMaybe<Scalars['ID']['input']>;
  providerName?: InputMaybe<Scalars['String']['input']>;
  /** Affects: Health insurance */
  renewalDate?: InputMaybe<Scalars['Date']['input']>;
  throughCurrentEmployer?: InputMaybe<Scalars['Boolean']['input']>;
  /** Affects: All but health insurance */
  yearsRemaining?: InputMaybe<Scalars['Int']['input']>;
};

/** Policy entered in fact find */
export type Policy = {
  __typename: 'Policy';
  /** Affects: All but health insurance */
  amountOfCover?: Maybe<Money>;
  /** Affects: Life Cover */
  coverType?: Maybe<CoverType>;
  id: Scalars['UUID']['output'];
  isComplete: Scalars['Boolean']['output'];
  /** Affects: Health insurance */
  isIrishLifePolicy?: Maybe<Scalars['Boolean']['output']>;
  isOnePlan?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  owners?: Maybe<Array<Maybe<Person>>>;
  /** Affects: All but health insurance */
  paymentFrequency?: Maybe<PaymentFrequency>;
  /** Affects: All but health insurance */
  premium?: Maybe<Money>;
  productType: PolicyType;
  provider?: Maybe<Provider>;
  /** Affects: Health insurance */
  renewalDate?: Maybe<Scalars['Date']['output']>;
  throughCurrentEmployer?: Maybe<Scalars['Boolean']['output']>;
  userId: Scalars['ID']['output'];
  /** Affects: All but health insurance */
  yearsRemaining?: Maybe<Scalars['Int']['output']>;
};

export type PolicyInput = {
  /** Affects: All but health insurance */
  amountOfCover?: InputMaybe<Scalars['MoneyInput']['input']>;
  /** Affects: Life Cover */
  coverType?: InputMaybe<CoverType>;
  /** Affects: Health insurance */
  isIrishLifePolicy?: InputMaybe<Scalars['Boolean']['input']>;
  isOnePlan?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  owners?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Affects: All but health insurance */
  paymentFrequency?: InputMaybe<PaymentFrequency>;
  /** Affects: All but health insurance */
  premium?: InputMaybe<Scalars['MoneyInput']['input']>;
  productType: PolicyType;
  provider?: InputMaybe<Scalars['ID']['input']>;
  providerName?: InputMaybe<Scalars['String']['input']>;
  /** Affects: Health insurance */
  renewalDate?: InputMaybe<Scalars['Date']['input']>;
  throughCurrentEmployer?: InputMaybe<Scalars['Boolean']['input']>;
  /** Affects: All but health insurance */
  yearsRemaining?: InputMaybe<Scalars['Int']['input']>;
};

export enum PolicyType {
  HealthInsurance = 'HEALTH_INSURANCE',
  IncomeProtection = 'INCOME_PROTECTION',
  LifeCover = 'LIFE_COVER',
  SpecifiedIllnessCover = 'SPECIFIED_ILLNESS_COVER'
}

export type Product = {
  __typename: 'Product';
  balance?: Maybe<Money>;
  fields: Array<ProductTypeField>;
  id: Scalars['UUID']['output'];
  isComplete: Scalars['Boolean']['output'];
  name?: Maybe<Scalars['String']['output']>;
  productGroup: ProductGroup;
  productType: Scalars['ID']['output'];
  productTypeName: Scalars['String']['output'];
  provider?: Maybe<Provider>;
  userId: Scalars['ID']['output'];
};

export type ProductFieldValueInput = {
  key: Scalars['String']['input'];
  value?: InputMaybe<Scalars['FieldValue']['input']>;
};

export enum ProductGroup {
  Asset = 'ASSET',
  Debt = 'DEBT',
  Policy = 'POLICY'
}

export type ProductInput = {
  balance?: InputMaybe<Scalars['MoneyInput']['input']>;
  fields?: InputMaybe<Array<InputMaybe<ProductFieldValueInput>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  owners?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  productType: Scalars['String']['input'];
  provider?: InputMaybe<Scalars['ID']['input']>;
  providerName?: InputMaybe<Scalars['String']['input']>;
};

export type ProductSummary = {
  __typename: 'ProductSummary';
  missing?: Maybe<Scalars['Boolean']['output']>;
  postProductAmount?: Maybe<Scalars['String']['output']>;
  preProductAmount?: Maybe<Scalars['String']['output']>;
  productAmount?: Maybe<Scalars['String']['output']>;
};

export type ProductType = {
  __typename: 'ProductType';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  /** Product relevance, for sorting products */
  relevance?: Maybe<Scalars['Int']['output']>;
};

export type ProductTypeField = {
  __typename: 'ProductTypeField';
  input: FieldInput;
  key: Scalars['String']['output'];
  label?: Maybe<Scalars['String']['output']>;
  placeholder?: Maybe<Scalars['String']['output']>;
  tooltip?: Maybe<Scalars['Markdown']['output']>;
  value?: Maybe<Scalars['FieldValue']['output']>;
};

export type ProductTypeFields = {
  __typename: 'ProductTypeFields';
  fields: Array<ProductTypeField>;
  /** Id of the product type */
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type ProductsInput = {
  balance?: InputMaybe<Scalars['MoneyInput']['input']>;
  fields?: InputMaybe<Array<InputMaybe<ProductFieldValueInput>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  productId?: InputMaybe<Scalars['UUID']['input']>;
  productType: Scalars['String']['input'];
  provider?: InputMaybe<Scalars['ID']['input']>;
  providerName?: InputMaybe<Scalars['String']['input']>;
};

export enum PropertyType {
  CommercialProperty = 'COMMERCIAL_PROPERTY',
  MainResidence = 'MAIN_RESIDENCE',
  ResidentialInvestmentProperty = 'RESIDENTIAL_INVESTMENT_PROPERTY'
}

export enum ProtectionProvision {
  ComprehensivePlan = 'COMPREHENSIVE_PLAN',
  Covered = 'COVERED',
  NotFullyCovered = 'NOT_FULLY_COVERED',
  NoCover = 'NO_COVER'
}

export type ProtectionScenario = {
  __typename: 'ProtectionScenario';
  covered: CoverForScenario;
  description: Scalars['String']['output'];
  recommended: Money;
  recommendedForPartner?: Maybe<Money>;
  recommendedForUser: Money;
  subtitle: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type ProtectionSummary = {
  __typename: 'ProtectionSummary';
  currentCover: ProtectionProvision;
  idealCover: ProtectionProvision;
  missing: Scalars['Boolean']['output'];
  missingPolicies?: Maybe<Scalars['String']['output']>;
  scenarios?: Maybe<Array<Maybe<ProtectionScenario>>>;
};

export type Provider = {
  __typename: 'Provider';
  address?: Maybe<Address>;
  bannerColor?: Maybe<Scalars['String']['output']>;
  iconUrl?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  imageUrl?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  providerTypes: Array<Maybe<ProviderType>>;
};

export enum ProviderType {
  AssetProvider = 'ASSET_PROVIDER',
  DebtProvider = 'DEBT_PROVIDER',
  PolicyProvider = 'POLICY_PROVIDER'
}

/** Queries to Multiply's user data service */
export type Query = {
  __typename: 'Query';
  /** A single asset record entered as part of user's fact find */
  asset?: Maybe<Asset>;
  /** A list of asset product types available in factfind */
  assetTypes: Array<ProductType>;
  /** All asset records entered as part of user's fact find */
  assets?: Maybe<Array<Maybe<Asset>>>;
  /** Days that have available appointments */
  availableAppointmentDays: Array<AvailableAppointmentDay>;
  /** Appointments available on a given day */
  availableAppointments: Array<AvailableAppointment>;
  calculatePension: PensionCalculation;
  checkIn: CheckInPayload;
  collegeCost?: Maybe<CollegeCost>;
  collegeCosts?: Maybe<Array<Maybe<CollegeCost>>>;
  consent?: Maybe<Consent>;
  /** List of countries available in factfind */
  countries: Array<Maybe<Scalars['String']['output']>>;
  /** List of country codes available in factfind */
  countryCodes: Array<Country>;
  /** List of counties / subdivisions in country */
  countyCodes: Array<County>;
  /** A single debt record entered as part of user's fact find */
  debt?: Maybe<Debt>;
  debtTypes: Array<ProductType>;
  /** All debt records entered as part of user's fact find */
  debts?: Maybe<Array<Maybe<Debt>>>;
  /** Retrieve the Factfind for a given user */
  factfind: Factfind;
  /** Retrieve fields for specific factfind context */
  factfindFields: FactfindContextFields;
  /** Goal entered in fact find */
  goal?: Maybe<Goal>;
  /** All goals for a given user */
  goals?: Maybe<Array<Maybe<Goal>>>;
  /** Information about a given version of the app */
  health: HealthCheck;
  /** Income entered in fact find */
  income?: Maybe<Income>;
  /** Front end user interaction flags, for showing banners etc. */
  interactionFlag: InteractionFlag;
  /** List a users messages */
  messages: Array<Message>;
  /** List of nationalities available in factfind */
  nationalities: Array<Maybe<Scalars['String']['output']>>;
  /** Next available appointment */
  nextAvailableAppointment?: Maybe<AvailableAppointment>;
  /** List of occupations available in factfind */
  occupations: Array<Maybe<Scalars['String']['output']>>;
  /** Get a single person (user / partner) */
  person?: Maybe<Person>;
  /** Get a list of persons associated with the user */
  persons: Array<Person>;
  /** Financial plan for the user */
  plan: Plan;
  /** Wealth projection for the user */
  planGraph: WealthProjection;
  /** All policy records entered as part of user's fact find */
  policies?: Maybe<Array<Maybe<Policy>>>;
  /** A single policy record entered as part of user's fact find */
  policy?: Maybe<Policy>;
  policyTypes: Array<ProductType>;
  product?: Maybe<Product>;
  products?: Maybe<Array<Maybe<Product>>>;
  /** Records of providers for a given type, returns all providers if no provider type is specified */
  providers?: Maybe<Array<Maybe<Provider>>>;
  prsaPensionApplication: PrsaPensionApplication;
  /** Risk profile information entered as part of a user's fact find */
  risk: Risk;
  riskProfiles?: Maybe<Array<Maybe<RiskProfile>>>;
  /** Appointments for a given user */
  scheduledAppointments: Array<Appointment>;
  /** Boolean to show survey */
  showSurvey?: Maybe<Scalars['Boolean']['output']>;
  /** All tool suggestions for a given user */
  suggestedTools?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Survey results for a given survey from a given user */
  survey?: Maybe<NpsSurvey>;
  /** All surveys for a given user */
  surveys?: Maybe<Array<Maybe<NpsSurvey>>>;
  /** List of titles */
  titles: Array<Maybe<Scalars['String']['output']>>;
  /** All tools subscribed for a given user */
  tools?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Number of unread messages for the user */
  unreadMessages?: Maybe<Scalars['Int']['output']>;
  /** Customer record */
  user?: Maybe<User>;
  vulnerabilityReminder?: Maybe<Scalars['Date']['output']>;
};


/** Queries to Multiply's user data service */
export type QueryAssetArgs = {
  assetId: Scalars['UUID']['input'];
  userId: Scalars['ID']['input'];
};


/** Queries to Multiply's user data service */
export type QueryAssetTypesArgs = {
  userId: Scalars['ID']['input'];
};


/** Queries to Multiply's user data service */
export type QueryAssetsArgs = {
  userId: Scalars['ID']['input'];
};


/** Queries to Multiply's user data service */
export type QueryAvailableAppointmentDaysArgs = {
  endDate: Scalars['Date']['input'];
  startDate: Scalars['Date']['input'];
  userId?: InputMaybe<Scalars['ID']['input']>;
};


/** Queries to Multiply's user data service */
export type QueryAvailableAppointmentsArgs = {
  date: Scalars['Date']['input'];
  userId?: InputMaybe<Scalars['ID']['input']>;
};


/** Queries to Multiply's user data service */
export type QueryCalculatePensionArgs = {
  input: PensionCalculatorInput;
};


/** Queries to Multiply's user data service */
export type QueryCheckInArgs = {
  staleSince?: InputMaybe<Scalars['Datetime']['input']>;
  userId: Scalars['ID']['input'];
};


/** Queries to Multiply's user data service */
export type QueryCollegeCostArgs = {
  collegeCostId?: InputMaybe<Scalars['ID']['input']>;
  collegeCostUuid?: InputMaybe<Scalars['UUID']['input']>;
  userId: Scalars['ID']['input'];
};


/** Queries to Multiply's user data service */
export type QueryCollegeCostsArgs = {
  userId: Scalars['ID']['input'];
};


/** Queries to Multiply's user data service */
export type QueryConsentArgs = {
  userId: Scalars['ID']['input'];
};


/** Queries to Multiply's user data service */
export type QueryCountyCodesArgs = {
  countryCode: Scalars['String']['input'];
};


/** Queries to Multiply's user data service */
export type QueryDebtArgs = {
  debtId: Scalars['UUID']['input'];
  userId: Scalars['ID']['input'];
};


/** Queries to Multiply's user data service */
export type QueryDebtTypesArgs = {
  userId: Scalars['ID']['input'];
};


/** Queries to Multiply's user data service */
export type QueryDebtsArgs = {
  userId: Scalars['ID']['input'];
};


/** Queries to Multiply's user data service */
export type QueryFactfindArgs = {
  userId: Scalars['ID']['input'];
};


/** Queries to Multiply's user data service */
export type QueryFactfindFieldsArgs = {
  context: Scalars['String']['input'];
  userId: Scalars['ID']['input'];
};


/** Queries to Multiply's user data service */
export type QueryGoalArgs = {
  goalId: Scalars['UUID']['input'];
  userId: Scalars['ID']['input'];
};


/** Queries to Multiply's user data service */
export type QueryGoalsArgs = {
  userId: Scalars['ID']['input'];
};


/** Queries to Multiply's user data service */
export type QueryHealthArgs = {
  message?: InputMaybe<Scalars['String']['input']>;
};


/** Queries to Multiply's user data service */
export type QueryIncomeArgs = {
  incomeId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};


/** Queries to Multiply's user data service */
export type QueryInteractionFlagArgs = {
  flagKey: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};


/** Queries to Multiply's user data service */
export type QueryMessagesArgs = {
  userId: Scalars['ID']['input'];
};


/** Queries to Multiply's user data service */
export type QueryNextAvailableAppointmentArgs = {
  userId: Scalars['ID']['input'];
};


/** Queries to Multiply's user data service */
export type QueryPersonArgs = {
  personId?: InputMaybe<Scalars['ID']['input']>;
  userId: Scalars['ID']['input'];
};


/** Queries to Multiply's user data service */
export type QueryPersonsArgs = {
  userId: Scalars['ID']['input'];
};


/** Queries to Multiply's user data service */
export type QueryPlanArgs = {
  userId: Scalars['ID']['input'];
};


/** Queries to Multiply's user data service */
export type QueryPlanGraphArgs = {
  endDate?: InputMaybe<Scalars['Date']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
  userId: Scalars['ID']['input'];
};


/** Queries to Multiply's user data service */
export type QueryPoliciesArgs = {
  userId: Scalars['ID']['input'];
};


/** Queries to Multiply's user data service */
export type QueryPolicyArgs = {
  policyId: Scalars['UUID']['input'];
  userId: Scalars['ID']['input'];
};


/** Queries to Multiply's user data service */
export type QueryPolicyTypesArgs = {
  userId: Scalars['ID']['input'];
};


/** Queries to Multiply's user data service */
export type QueryProductArgs = {
  productId: Scalars['UUID']['input'];
  userId: Scalars['ID']['input'];
};


/** Queries to Multiply's user data service */
export type QueryProductsArgs = {
  productGroup?: InputMaybe<ProductGroup>;
  userId: Scalars['ID']['input'];
};


/** Queries to Multiply's user data service */
export type QueryProvidersArgs = {
  providerType?: InputMaybe<ProviderType>;
};


/** Queries to Multiply's user data service */
export type QueryPrsaPensionApplicationArgs = {
  userId: Scalars['ID']['input'];
};


/** Queries to Multiply's user data service */
export type QueryRiskArgs = {
  userId: Scalars['ID']['input'];
};


/** Queries to Multiply's user data service */
export type QueryRiskProfilesArgs = {
  userId: Scalars['ID']['input'];
};


/** Queries to Multiply's user data service */
export type QueryScheduledAppointmentsArgs = {
  userId: Scalars['ID']['input'];
};


/** Queries to Multiply's user data service */
export type QueryShowSurveyArgs = {
  userId: Scalars['ID']['input'];
};


/** Queries to Multiply's user data service */
export type QuerySuggestedToolsArgs = {
  userId: Scalars['ID']['input'];
};


/** Queries to Multiply's user data service */
export type QuerySurveyArgs = {
  id: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};


/** Queries to Multiply's user data service */
export type QuerySurveysArgs = {
  userId: Scalars['ID']['input'];
};


/** Queries to Multiply's user data service */
export type QueryToolsArgs = {
  userId: Scalars['ID']['input'];
};


/** Queries to Multiply's user data service */
export type QueryUnreadMessagesArgs = {
  userId: Scalars['ID']['input'];
};


/** Queries to Multiply's user data service */
export type QueryUserArgs = {
  userId: Scalars['ID']['input'];
};


/** Queries to Multiply's user data service */
export type QueryVulnerabilityReminderArgs = {
  userId: Scalars['ID']['input'];
};

export type Question = {
  __typename: 'Question';
  helperText?: Maybe<Scalars['String']['output']>;
  input: FieldInput;
  key: Scalars['String']['output'];
  label?: Maybe<Scalars['String']['output']>;
  placeholder?: Maybe<Scalars['String']['output']>;
};

export type QuestionGroup = {
  __typename: 'QuestionGroup';
  contexts: Array<Scalars['String']['output']>;
  footer?: Maybe<Scalars['Markdown']['output']>;
  helperText?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  preTitle?: Maybe<Scalars['Markdown']['output']>;
  questions: Array<Question>;
  subtitle?: Maybe<Scalars['Markdown']['output']>;
  title: Scalars['Markdown']['output'];
};

export type Recommendation = {
  __typename: 'Recommendation';
  ctas: Array<RecommendationCta>;
  explanation: Array<ContentBlock>;
  id: Scalars['ID']['output'];
  subtitle: Scalars['String']['output'];
  title: Scalars['String']['output'];
  warnings: Array<Scalars['String']['output']>;
};

export type RecommendationCta = {
  __typename: 'RecommendationCTA';
  text: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type RecommendationGroup = {
  __typename: 'RecommendationGroup';
  explanation?: Maybe<Scalars['String']['output']>;
  factfindSummary: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  recommendationType: RecommendationType;
  recommendations?: Maybe<Array<Recommendation>>;
  relatedProducts?: Maybe<ProductSummary>;
  responsiveImage?: Maybe<ResposiveImage>;
  riskProfileQuestionnaireRequired: Scalars['Boolean']['output'];
  subtitle: Scalars['String']['output'];
  summary?: Maybe<RecommendationGroupSummary>;
  thingsToDo?: Maybe<Scalars['Int']['output']>;
  title: Scalars['String']['output'];
};

export type RecommendationGroupSummary = DebtSummary | EmergencyFundSummary | HealthSummary | ProtectionSummary | RetirementSummary | SavingsInvestingSummary;

export enum RecommendationType {
  Debt = 'DEBT',
  EmergencyFund = 'EMERGENCY_FUND',
  Health = 'HEALTH',
  Protection = 'PROTECTION',
  Retirement = 'RETIREMENT',
  SavingsInvesting = 'SAVINGS_INVESTING'
}

/** Specifies whether the person is the user or their partner */
export enum Relationship {
  Child = 'CHILD',
  Grandchild = 'GRANDCHILD',
  Grandparent = 'GRANDPARENT',
  Guardian = 'GUARDIAN',
  Other = 'OTHER',
  Parent = 'PARENT',
  Partner = 'PARTNER',
  Relative = 'RELATIVE',
  Sibling = 'SIBLING',
  User = 'USER'
}

export type RequestPlanInput = {
  /** The id of the user */
  userId: Scalars['ID']['input'];
};

export type RequestPlanPayload = MutationPayload & {
  __typename: 'RequestPlanPayload';
  error?: Maybe<ErrorType>;
  success: Scalars['Boolean']['output'];
};

export type ResposiveImage = {
  __typename: 'ResposiveImage';
  sizes: Scalars['String']['output'];
  src: Scalars['String']['output'];
  srcset: Scalars['String']['output'];
};

export type RetirementSummary = {
  __typename: 'RetirementSummary';
  breakdown: Array<BreakdownSlice>;
  currentProvision: Money;
  prsaRecommendedFund: Array<PrsaFundRecommendation>;
  realisticProvision: Money;
  recommendPRSA: Scalars['Boolean']['output'];
  targetProvision: Money;
};

export type Risk = {
  __typename: 'Risk';
  calculatedProfile?: Maybe<RiskProfile>;
  id: Scalars['ID']['output'];
  questionnaire?: Maybe<RiskQuestionnaire>;
  questionnaireAnswers?: Maybe<Scalars['JSON']['output']>;
  selectedProfile?: Maybe<RiskProfile>;
};

export type RiskInput = {
  questionnaire?: InputMaybe<RiskQuestionnaireInput>;
  questionnaireAnswers?: InputMaybe<Scalars['JSON']['input']>;
  selectedProfile?: InputMaybe<Scalars['String']['input']>;
};

export type RiskProfile = {
  __typename: 'RiskProfile';
  description: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type RiskQuestionnaire = {
  __typename: 'RiskQuestionnaire';
  bestPossibleReturnQ2?: Maybe<Scalars['String']['output']>;
  choiceTwoInvestmentProductsQ12?: Maybe<Scalars['String']['output']>;
  describeThinkAboutPossibleLossesGainsQ14?: Maybe<Scalars['String']['output']>;
  exploringInvestmentOpportunitiesQ1?: Maybe<Scalars['String']['output']>;
  friendDescribeAttitudeRisksQ10?: Maybe<Scalars['String']['output']>;
  highGrowthAcceptLossesQ8?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  investmentGoesDownReactionQ7?: Maybe<Scalars['String']['output']>;
  investmentSafeLowerReturnsQ15?: Maybe<Scalars['String']['output']>;
  investmentsRiskAnxiousQ6?: Maybe<Scalars['String']['output']>;
  largeGainsRiskLargeLossesQ11?: Maybe<Scalars['String']['output']>;
  possibleHighReturnsChanceQ9?: Maybe<Scalars['String']['output']>;
  preferInvestmentSafeQ5?: Maybe<Scalars['String']['output']>;
  preferSmallCertainGainsQ13?: Maybe<Scalars['String']['output']>;
  riskPastFinancialDecisionsQ4?: Maybe<Scalars['String']['output']>;
  typicalAttitudeFinancialDecisionsQ3?: Maybe<Scalars['String']['output']>;
};

export type RiskQuestionnaireInput = {
  bestPossibleReturnQ2?: InputMaybe<Scalars['String']['input']>;
  choiceTwoInvestmentProductsQ12?: InputMaybe<Scalars['String']['input']>;
  describeThinkAboutPossibleLossesGainsQ14?: InputMaybe<Scalars['String']['input']>;
  exploringInvestmentOpportunitiesQ1?: InputMaybe<Scalars['String']['input']>;
  friendDescribeAttitudeRisksQ10?: InputMaybe<Scalars['String']['input']>;
  highGrowthAcceptLossesQ8?: InputMaybe<Scalars['String']['input']>;
  investmentGoesDownReactionQ7?: InputMaybe<Scalars['String']['input']>;
  investmentSafeLowerReturnsQ15?: InputMaybe<Scalars['String']['input']>;
  investmentsRiskAnxiousQ6?: InputMaybe<Scalars['String']['input']>;
  largeGainsRiskLargeLossesQ11?: InputMaybe<Scalars['String']['input']>;
  possibleHighReturnsChanceQ9?: InputMaybe<Scalars['String']['input']>;
  preferInvestmentSafeQ5?: InputMaybe<Scalars['String']['input']>;
  preferSmallCertainGainsQ13?: InputMaybe<Scalars['String']['input']>;
  riskPastFinancialDecisionsQ4?: InputMaybe<Scalars['String']['input']>;
  typicalAttitudeFinancialDecisionsQ3?: InputMaybe<Scalars['String']['input']>;
};

export type SavingsInvestingSummary = {
  __typename: 'SavingsInvestingSummary';
  breakdown: Array<BreakdownSlice>;
  emergencyFundProgress: EmergencyFundProgress;
  goalProgress: Array<Maybe<GoalProgress>>;
  investingSummary: InvestingSummary;
  savingsSummary: SavingsSummary;
};

export enum SavingsSummary {
  NeedsWork = 'NEEDS_WORK',
  OnTrack = 'ON_TRACK'
}

export type SetVulnerabilityReminderInput = {
  userId: Scalars['ID']['input'];
};

export type SetVulnerabilityReminderPayload = MutationPayload & {
  __typename: 'SetVulnerabilityReminderPayload';
  error?: Maybe<ErrorType>;
  /** Expected date of the email reminder */
  reminderDate?: Maybe<Scalars['Date']['output']>;
  success: Scalars['Boolean']['output'];
};

export type SignUpInput = {
  /** Advisor ID of advisor to be associated with the user */
  advisorId?: InputMaybe<Scalars['String']['input']>;
  /** The client ID */
  clientId?: InputMaybe<Scalars['String']['input']>;
  /** The UUID of the user's device */
  deviceId?: InputMaybe<Scalars['String']['input']>;
  /** The user's email */
  email?: InputMaybe<Scalars['String']['input']>;
  /** The user's name */
  name?: InputMaybe<Scalars['String']['input']>;
  /** The source of the customer's referral - for analytics and customisation of the ongoing journey */
  referralSource?: InputMaybe<Scalars['String']['input']>;
  /** The branch name of the user's advisor */
  sourceBranchName?: InputMaybe<Scalars['String']['input']>;
  /** Team name to be assoicated with the user */
  teamName?: InputMaybe<Scalars['String']['input']>;
  /** The id of the user */
  userId: Scalars['ID']['input'];
  /** The user journey for factfind */
  userJourney?: InputMaybe<Scalars['String']['input']>;
  /** The type of user - for analytics and customisation of the ongoing journey */
  userType?: InputMaybe<Scalars['String']['input']>;
};

export type SignUpPayload = MutationPayload & {
  __typename: 'SignUpPayload';
  error?: Maybe<ErrorType>;
  success: Scalars['Boolean']['output'];
};

export enum SmokingStatus {
  Nonsmoker = 'NONSMOKER',
  OccasionalSmoker = 'OCCASIONAL_SMOKER',
  Smoker = 'SMOKER',
  UsedNicotineReplacements = 'USED_NICOTINE_REPLACEMENTS'
}

export type SubmissionPayload = MutationPayload & {
  __typename: 'SubmissionPayload';
  error?: Maybe<ErrorType>;
  success: Scalars['Boolean']['output'];
  validationErrors?: Maybe<Scalars['FactfindErrors']['output']>;
};

export type SubmitPrsaPensionApplicationInput = {
  accountHolder?: InputMaybe<Scalars['String']['input']>;
  confirmedDetails?: InputMaybe<Scalars['Boolean']['input']>;
  dateOfBirth?: InputMaybe<Scalars['Date']['input']>;
  digitalSignature?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  iban?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  sex?: InputMaybe<BiologicalSex>;
  title?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['ID']['input'];
};

export type SyncUserInput = {
  /** The branch name of the user's advisor */
  sourceBranchName?: InputMaybe<Scalars['String']['input']>;
  /** The id of the user */
  userId: Scalars['ID']['input'];
  /** The user journey */
  userJourney?: InputMaybe<Scalars['String']['input']>;
  /** The type of user - for analytics and customisation of the ongoing journey */
  userType?: InputMaybe<Scalars['String']['input']>;
};

export type SyncUserPayload = MutationPayload & {
  __typename: 'SyncUserPayload';
  error?: Maybe<ErrorType>;
  success: Scalars['Boolean']['output'];
  userJourney?: Maybe<Scalars['String']['output']>;
  userType?: Maybe<Scalars['String']['output']>;
};

export type Triage = {
  __typename: 'Triage';
  action?: Maybe<TriageAction>;
  reason?: Maybe<Scalars['String']['output']>;
  userIsTriaged: Scalars['Boolean']['output'];
};

export enum TriageAction {
  BookAppointment = 'BOOK_APPOINTMENT'
}

export type UpdateAssetInput = {
  asset: AssetInput;
  /** The ID of the asset to be updated. If not present, will insert a new asset */
  assetId?: InputMaybe<Scalars['UUID']['input']>;
  userId: Scalars['ID']['input'];
};

export type UpdateAssetPayload = MutationPayload & {
  __typename: 'UpdateAssetPayload';
  asset?: Maybe<Asset>;
  error?: Maybe<ErrorType>;
  success: Scalars['Boolean']['output'];
};

export type UpdateAssetsInput = {
  assets: Array<AssetsInput>;
  userId: Scalars['ID']['input'];
};

export type UpdateAssetsPayload = MutationPayload & {
  __typename: 'UpdateAssetsPayload';
  assets?: Maybe<Array<Maybe<Asset>>>;
  error?: Maybe<ErrorType>;
  success: Scalars['Boolean']['output'];
};

export type UpdateCheckInInput = {
  checkInTypes: Array<CheckInType>;
  staleSince?: InputMaybe<Scalars['Datetime']['input']>;
  userId: Scalars['ID']['input'];
};

export type UpdateConsentInput = {
  consent: ConsentInput;
  userId: Scalars['ID']['input'];
};

export type UpdateConsentPayload = MutationPayload & {
  __typename: 'UpdateConsentPayload';
  consent?: Maybe<Consent>;
  error?: Maybe<ErrorType>;
  success: Scalars['Boolean']['output'];
};

export type UpdateDebtInput = {
  debt: DebtInput;
  /** The ID of the debt to be updated. If not present, will insert a new debt */
  debtId?: InputMaybe<Scalars['UUID']['input']>;
  userId: Scalars['ID']['input'];
};

export type UpdateDebtPayload = MutationPayload & {
  __typename: 'UpdateDebtPayload';
  debt?: Maybe<Debt>;
  error?: Maybe<ErrorType>;
  success: Scalars['Boolean']['output'];
};

export type UpdateDebtsInput = {
  debts: Array<DebtsInput>;
  userId: Scalars['ID']['input'];
};

export type UpdateDebtsPayload = MutationPayload & {
  __typename: 'UpdateDebtsPayload';
  debts?: Maybe<Array<Maybe<Debt>>>;
  error?: Maybe<ErrorType>;
  success: Scalars['Boolean']['output'];
};

export type UpdateEmailInput = {
  code: Scalars['String']['input'];
  /** The new email */
  email: Scalars['String']['input'];
  /** The ID of the user */
  userId: Scalars['ID']['input'];
};

export type UpdateEmailPayload = MutationPayload & {
  __typename: 'UpdateEmailPayload';
  error?: Maybe<ErrorType>;
  success: Scalars['Boolean']['output'];
};

export type UpdateFactfindInput = {
  context?: InputMaybe<Scalars['String']['input']>;
  /** The updated factfind fields */
  factfind: FactfindInput;
  userId: Scalars['ID']['input'];
};

export type UpdateFactfindPayload = MutationPayload & {
  __typename: 'UpdateFactfindPayload';
  error?: Maybe<ErrorType>;
  /** Factfind details */
  factfind?: Maybe<Factfind>;
  fields?: Maybe<FactfindContextFields>;
  success: Scalars['Boolean']['output'];
  triage?: Maybe<Triage>;
  validationErrors?: Maybe<Scalars['FactfindErrors']['output']>;
};

export type UpdateGoalInput = {
  collegeCostId?: InputMaybe<Scalars['ID']['input']>;
  goal: GoalInput;
  /** When no goal ID is passed, the mutation creates a new goal */
  goalId?: InputMaybe<Scalars['UUID']['input']>;
  userId: Scalars['ID']['input'];
};

export type UpdateGoalPayload = MutationPayload & {
  __typename: 'UpdateGoalPayload';
  error?: Maybe<ErrorType>;
  goal?: Maybe<Goal>;
  success: Scalars['Boolean']['output'];
};

export type UpdateGoalsInput = {
  goals: Array<GoalsInput>;
  userId: Scalars['ID']['input'];
};

export type UpdateGoalsPayload = MutationPayload & {
  __typename: 'UpdateGoalsPayload';
  error?: Maybe<ErrorType>;
  goals?: Maybe<Array<Maybe<Goal>>>;
  success: Scalars['Boolean']['output'];
};

export type UpdateIncomeInput = {
  income: IncomeInput;
  incomeId?: InputMaybe<Scalars['ID']['input']>;
  userId: Scalars['ID']['input'];
};

export type UpdateIncomePayload = MutationPayload & {
  __typename: 'UpdateIncomePayload';
  error?: Maybe<ErrorType>;
  income?: Maybe<Income>;
  success: Scalars['Boolean']['output'];
};

export type UpdateInteractionFlagInput = {
  /** Interaction flag id */
  flagKey: Scalars['ID']['input'];
  /** The user id */
  userId: Scalars['ID']['input'];
  /** Flag value */
  value: Scalars['Boolean']['input'];
};

export type UpdateInteractionFlagPayload = MutationPayload & {
  __typename: 'UpdateInteractionFlagPayload';
  error?: Maybe<ErrorType>;
  interactionFlag?: Maybe<InteractionFlag>;
  success: Scalars['Boolean']['output'];
};

/** Input to update a single person. */
export type UpdatePersonInput = {
  person: PersonInput;
  personId?: InputMaybe<Scalars['ID']['input']>;
  userId: Scalars['ID']['input'];
};

export type UpdatePersonPayload = MutationPayload & {
  __typename: 'UpdatePersonPayload';
  error?: Maybe<ErrorType>;
  person?: Maybe<Person>;
  success: Scalars['Boolean']['output'];
};

export type UpdatePoliciesInput = {
  policies: Array<PoliciesInput>;
  userId: Scalars['ID']['input'];
};

export type UpdatePoliciesPayload = MutationPayload & {
  __typename: 'UpdatePoliciesPayload';
  error?: Maybe<ErrorType>;
  policies?: Maybe<Array<Maybe<Policy>>>;
  success: Scalars['Boolean']['output'];
};

export type UpdatePolicyInput = {
  policy: PolicyInput;
  /** The ID of the policy to be updated. If not present, will insert a new policy */
  policyId?: InputMaybe<Scalars['UUID']['input']>;
  userId: Scalars['ID']['input'];
};

export type UpdatePolicyPayload = MutationPayload & {
  __typename: 'UpdatePolicyPayload';
  error?: Maybe<ErrorType>;
  policy?: Maybe<Policy>;
  success: Scalars['Boolean']['output'];
};

export type UpdateProductInput = {
  product: ProductInput;
  /** The ID of the product to be updated. If not present, will insert a new product */
  productId?: InputMaybe<Scalars['UUID']['input']>;
  userId: Scalars['ID']['input'];
};

export type UpdateProductPayload = MutationPayload & {
  __typename: 'UpdateProductPayload';
  error?: Maybe<ErrorType>;
  product?: Maybe<Product>;
  success: Scalars['Boolean']['output'];
  validationErrors?: Maybe<Scalars['FactfindErrors']['output']>;
};

export type UpdateProductsInput = {
  products: Array<ProductsInput>;
  userId: Scalars['ID']['input'];
};

export type UpdateProductsPayload = MutationPayload & {
  __typename: 'UpdateProductsPayload';
  error?: Maybe<ErrorType>;
  products?: Maybe<Array<Maybe<Product>>>;
  success: Scalars['Boolean']['output'];
};

export type UpdatePrsaPensionApplicationInput = {
  context?: InputMaybe<Scalars['String']['input']>;
  /** The updated prsa fields */
  prsaPensionApplication: PrsaPensionApplicationInput;
  userId: Scalars['ID']['input'];
};

export type UpdateRiskInput = {
  /** The updated factfind fields */
  risk: RiskInput;
  userId: Scalars['ID']['input'];
};

export type UpdateRiskPayload = MutationPayload & {
  __typename: 'UpdateRiskPayload';
  error?: Maybe<ErrorType>;
  /** Risk details */
  risk?: Maybe<Risk>;
  success: Scalars['Boolean']['output'];
  validationErrors?: Maybe<Scalars['ValidationErrors']['output']>;
};

export type UrlBlock = {
  __typename: 'UrlBlock';
  links?: Maybe<Array<Maybe<Link>>>;
  title?: Maybe<Scalars['String']['output']>;
};

/** Customer record */
export type User = {
  __typename: 'User';
  /** Customer's email */
  email?: Maybe<Scalars['String']['output']>;
  /** External auth ID */
  id: Scalars['ID']['output'];
  /** Customer's name */
  name?: Maybe<Scalars['String']['output']>;
  /** The source of the customer's referral - for analytics and customisation of the ongoing journey */
  referralSource?: Maybe<Scalars['String']['output']>;
  /** Stripe subscription status */
  stripeSubscriptionStatus?: Maybe<Scalars['String']['output']>;
  /** Denotes triage reason */
  triageReason?: Maybe<Scalars['String']['output']>;
  /** Denotes whether user has been triaged */
  triaged?: Maybe<Scalars['Boolean']['output']>;
  /** The user journey - for fact find */
  userJourney?: Maybe<Scalars['String']['output']>;
  /** The type of user - for analytics and customisation of the ongoing journey */
  userType?: Maybe<Scalars['String']['output']>;
};

/** How a pension is valued */
export enum ValuationMethod {
  EstimatedCurrentValue = 'ESTIMATED_CURRENT_VALUE',
  EstimatedValueAtRetirement = 'ESTIMATED_VALUE_AT_RETIREMENT',
  MonthlyIncomeAtRetirement = 'MONTHLY_INCOME_AT_RETIREMENT'
}

export type WealthAtDate = {
  __typename: 'WealthAtDate';
  amount: Money;
  date: Scalars['Date']['output'];
  goal?: Maybe<Array<Maybe<GoalType>>>;
  goals?: Maybe<Array<Maybe<Goal>>>;
};

export type WealthProjection = {
  __typename: 'WealthProjection';
  currentWealth: Money;
  finalWealth: Money;
  wealthProjection: Array<Maybe<WealthAtDate>>;
};

export enum WhatToIncludeType {
  Accommodation = 'ACCOMMODATION',
  Fees = 'FEES',
  OtherExpenses = 'OTHER_EXPENSES'
}

export type CheckIn = {
  __typename: 'checkIn';
  checkInType: CheckInType;
  lastChecked?: Maybe<Scalars['Datetime']['output']>;
  stale: Scalars['Boolean']['output'];
};

export type CheckInPayload = {
  __typename: 'checkInPayload';
  checkIns?: Maybe<Array<CheckIn>>;
};

export enum CheckInType {
  Factfind = 'FACTFIND',
  Products = 'PRODUCTS'
}

export type StaleFields = {
  __typename: 'staleFields';
  key: Scalars['String']['output'];
  lastUpdated: Scalars['Date']['output'];
};

export type BookAppointmentMutationVariables = Exact<{
  input: BookAppointmentInput;
}>;


export type BookAppointmentMutation = { __typename: 'Mutation', bookAppointment: { __typename: 'BookAppointmentPayload', success: boolean, error?: { __typename: 'ErrorType', message: string, fieldErrors?: any | null } | null, appointment?: { __typename: 'Appointment', id: string, startTime: any, endTime: any, advisorId: string, advisorName: string, advisorEmail?: string | null, advisorPhone?: string | null } | null } };

export type ChangeEmailVerificationMutationVariables = Exact<{
  input: ChangeEmailVerificationInput;
}>;


export type ChangeEmailVerificationMutation = { __typename: 'Mutation', changeEmailVerification?: { __typename: 'ChangeEmailVerificationPayload', success: boolean, email?: string | null, error?: { __typename: 'ErrorType', code: ErrorCode, message: string, fieldErrors?: any | null } | null } | null };

export type CreateSurveyMutationVariables = Exact<{
  input: NewSurveyInput;
}>;


export type CreateSurveyMutation = { __typename: 'Mutation', createNewSurvey: { __typename: 'NewSurveyPayload', success: boolean, error?: { __typename: 'ErrorType', message: string, fieldErrors?: any | null } | null, survey?: { __typename: 'NPSSurvey', id: string, userId: string, score?: number | null, feedback?: string | null, completed: boolean } | null } };

export type DeclineSurveyMutationVariables = Exact<{
  input: DeclineSurveyInput;
}>;


export type DeclineSurveyMutation = { __typename: 'Mutation', declineSurvey: { __typename: 'DeclineSurveyPayload', success: boolean, error?: { __typename: 'ErrorType', message: string, fieldErrors?: any | null } | null, survey?: { __typename: 'NPSSurvey', id: string, userId: string, score?: number | null, feedback?: string | null, completed: boolean } | null } };

export type DeleteAssetMutationVariables = Exact<{
  input: DeleteAssetInput;
}>;


export type DeleteAssetMutation = { __typename: 'Mutation', deleteAsset?: { __typename: 'DeleteAssetPayload', success: boolean, error?: { __typename: 'ErrorType', message: string } | null } | null };

export type DeleteDebtMutationVariables = Exact<{
  input: DeleteDebtInput;
}>;


export type DeleteDebtMutation = { __typename: 'Mutation', deleteDebt?: { __typename: 'DeleteDebtPayload', success: boolean, error?: { __typename: 'ErrorType', message: string } | null } | null };

export type DeleteGoalMutationVariables = Exact<{
  input: DeleteGoalInput;
}>;


export type DeleteGoalMutation = { __typename: 'Mutation', deleteGoal?: { __typename: 'DeleteGoalPayload', success: boolean, error?: { __typename: 'ErrorType', code: ErrorCode, message: string, fieldErrors?: any | null } | null } | null };

export type DeletePolicyMutationVariables = Exact<{
  input: DeletePolicyInput;
}>;


export type DeletePolicyMutation = { __typename: 'Mutation', deletePolicy?: { __typename: 'DeletePolicyPayload', success: boolean, error?: { __typename: 'ErrorType', message: string } | null } | null };

export type DeleteVulnerabilityReminderMutationVariables = Exact<{
  input: DeleteVulnerabilityReminderInput;
}>;


export type DeleteVulnerabilityReminderMutation = { __typename: 'Mutation', deleteVulnerabilityReminder: { __typename: 'DeleteVulnerabilityReminderPayload', success: boolean, error?: { __typename: 'ErrorType', message: string, fieldErrors?: any | null } | null } };

export type GetAssetQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
  assetId: Scalars['UUID']['input'];
}>;


export type GetAssetQuery = { __typename: 'Query', asset?: { __typename: 'Asset', id: any, productType: AssetType, userId: string, isComplete: boolean, name?: string | null, accessible?: boolean | null, maturityDate?: any | null, increasing?: boolean | null, startDate?: any | null, valuationMethod?: ValuationMethod | null, whereFrom?: AssetOrigin | null, propertyType?: PropertyType | null, pensionType?: PensionType | null, frequency?: PaymentFrequency | null, active?: boolean | null, throughCurrentEmployer?: boolean | null, isIrishLifePension?: boolean | null, owners?: Array<{ __typename: 'Person', id: string, relationship?: Relationship | null } | null> | null, provider?: { __typename: 'Provider', id?: string | null, name?: string | null, iconUrl?: string | null } | null, balance?: { __typename: 'Money', float: number, display: string, string: string } | null, overdrawnBy?: { __typename: 'Money', float: number, display: string, string: string } | null, regularPaymentAmount?: { __typename: 'Money', float: number, display: string, string: string } | null } | null };

export type GetAssetsQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;


export type GetAssetsQuery = { __typename: 'Query', assets?: Array<{ __typename: 'Asset', id: any, productType: AssetType, userId: string, isComplete: boolean, name?: string | null, accessible?: boolean | null, maturityDate?: any | null, active?: boolean | null, throughCurrentEmployer?: boolean | null, pensionType?: PensionType | null, owners?: Array<{ __typename: 'Person', id: string, relationship?: Relationship | null } | null> | null, provider?: { __typename: 'Provider', id?: string | null, name?: string | null, iconUrl?: string | null } | null, balance?: { __typename: 'Money', float: number, display: string, string: string } | null, overdrawnBy?: { __typename: 'Money', float: number, display: string, string: string } | null, regularPaymentAmount?: { __typename: 'Money', float: number, display: string, string: string } | null } | null> | null };

export type GetAvailableAppointmentDaysQueryVariables = Exact<{
  userId?: InputMaybe<Scalars['ID']['input']>;
  startDate: Scalars['Date']['input'];
  endDate: Scalars['Date']['input'];
}>;


export type GetAvailableAppointmentDaysQuery = { __typename: 'Query', availableAppointmentDays: Array<{ __typename: 'AvailableAppointmentDay', id: string, date: any }> };

export type GetAvailableAppointmentsQueryVariables = Exact<{
  userId?: InputMaybe<Scalars['ID']['input']>;
  date: Scalars['Date']['input'];
}>;


export type GetAvailableAppointmentsQuery = { __typename: 'Query', availableAppointments: Array<{ __typename: 'AvailableAppointment', id: string, startTime: any, endTime: any }> };

export type GetBasicInfoFactFindQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;


export type GetBasicInfoFactFindQuery = { __typename: 'Query', factfind: { __typename: 'Factfind', id: string, vulnerable?: boolean | null, planningFor?: PlanScope | null, maritalStatus?: MaritalStatus | null, hasChildren?: boolean | null, numberOfChildren?: number | null, ageOfChildren?: Array<number | null> | null, numberOfOtherDependants?: number | null, relationshipToOtherDependants?: Array<DependantRelationship | null> | null, ownsHome?: boolean | null, hasMortgage?: boolean | null, staleFields: Array<{ __typename: 'staleFields', key: string, lastUpdated: any } | null>, partnerSpecificFactfind?: { __typename: 'PersonFactfind', firstName?: string | null, lastName?: string | null, dateOfBirth?: any | null, staleFields: Array<{ __typename: 'staleFields', key: string, lastUpdated: any } | null> } | null } };

export type CheckInQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;


export type CheckInQuery = { __typename: 'Query', checkIn: { __typename: 'checkInPayload', checkIns?: Array<{ __typename: 'checkIn', checkInType: CheckInType, lastChecked?: any | null, stale: boolean }> | null } };

export type GetConsentQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;


export type GetConsentQuery = { __typename: 'Query', consent?: { __typename: 'Consent', id: string, contactServicesIrishLifeGroup?: boolean | null, userResearch?: boolean | null, checkInEmails?: boolean | null } | null };

export type GetCountriesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCountriesQuery = { __typename: 'Query', countries: Array<string | null> };

export type GetDebtQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
  debtId: Scalars['UUID']['input'];
}>;


export type GetDebtQuery = { __typename: 'Query', debt?: { __typename: 'Debt', id: any, productType: DebtType, userId: string, isComplete: boolean, name?: string | null, clearedOnDeath?: boolean | null, maturityDate?: any | null, endDate?: any | null, mortgageType?: MortgageType | null, mortgageYearsLeft?: number | null, isMainMortgage?: boolean | null, repaidMonthly?: boolean | null, arePaymentsUpToDate?: boolean | null, hasPaymentProtectionInsurance?: boolean | null, owners?: Array<{ __typename: 'Person', id: string, firstName?: string | null, lastName?: string | null } | null> | null, provider?: { __typename: 'Provider', id?: string | null, name?: string | null, iconUrl?: string | null } | null, balance?: { __typename: 'Money', float: number, display: string, string: string } | null, monthlyRepayment?: { __typename: 'Money', float: number, display: string, string: string } | null, arrears?: { __typename: 'Money', float: number, string: string, display: string } | null } | null };

export type GetDebtsQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;


export type GetDebtsQuery = { __typename: 'Query', debts?: Array<{ __typename: 'Debt', id: any, productType: DebtType, userId: string, isComplete: boolean, name?: string | null, clearedOnDeath?: boolean | null, maturityDate?: any | null, endDate?: any | null, mortgageType?: MortgageType | null, mortgageYearsLeft?: number | null, isMainMortgage?: boolean | null, repaidMonthly?: boolean | null, arePaymentsUpToDate?: boolean | null, hasPaymentProtectionInsurance?: boolean | null, owners?: Array<{ __typename: 'Person', id: string, firstName?: string | null, lastName?: string | null } | null> | null, provider?: { __typename: 'Provider', id?: string | null, name?: string | null, iconUrl?: string | null } | null, balance?: { __typename: 'Money', float: number, string: string, display: string } | null, monthlyRepayment?: { __typename: 'Money', float: number, string: string, display: string } | null, arrears?: { __typename: 'Money', float: number, string: string, display: string } | null } | null> | null };

export type GetFactFindQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;


export type GetFactFindQuery = { __typename: 'Query', factfind: { __typename: 'Factfind', vulnerable?: boolean | null, id: string, monthlyRent?: number | null, monthlyUtilities?: number | null, monthlyOutgoingEssentials?: number | null, monthlyOutgoingNonEssentials?: number | null, extraMonthlyOutgoingEssentials?: number | null, planningFor?: PlanScope | null, hasChildren?: boolean | null, numberOfChildren?: number | null, ageOfChildren?: Array<number | null> | null, otherDependants?: boolean | null, numberOfOtherDependants?: number | null, relationshipToOtherDependants?: Array<DependantRelationship | null> | null, maritalStatus?: MaritalStatus | null, hasMortgage?: boolean | null, ownsHome?: boolean | null, staleFields: Array<{ __typename: 'staleFields', key: string, lastUpdated: any } | null>, userSpecificFactfind?: { __typename: 'PersonFactfind', employmentStatus?: EmploymentStatus | null, mainEmploymentType?: EmploymentType | null, occupation?: string | null, baseAnnualIncomeGross?: number | null, hasBonus?: boolean | null, expectedBonusAmount?: number | null, monthlyIncomeNet?: number | null, marginalTaxRate?: number | null, hasOtherIncome?: boolean | null, hasPension?: boolean | null, expectedOtherIncomeAmount?: number | null, eligibleForStatePension?: boolean | null, retirementAgeEstimate?: number | null, monthlyRetirementOutgoingExpected?: number | null, hasGoodHealth?: boolean | null, smokingStatus?: SmokingStatus | null, monthsOfFinancialSafety?: number | null, memberOfEmployersPensionScheme?: boolean | null, employerOffersPensionScheme?: boolean | null, PPSNumber?: string | null, birthCountry?: string | null, domicileCountry?: string | null, residentCountry?: string | null, industry?: IndustryType | null, pep?: boolean | null, nationality?: string | null, employer?: string | null, employerAddressLine1?: string | null, employerAddressLine2?: string | null, employerAddressLine3?: string | null, directorOrOwnerOfLimitedCompany?: boolean | null, pensionSchemeIsIrishLife?: boolean | null, staleFields: Array<{ __typename: 'staleFields', key: string, lastUpdated: any } | null>, benefitInKind?: { __typename: 'Money', float: number, display: string, string: string } | null } | null, partnerSpecificFactfind?: { __typename: 'PersonFactfind', firstName?: string | null, lastName?: string | null, dateOfBirth?: any | null, employmentStatus?: EmploymentStatus | null, mainEmploymentType?: EmploymentType | null, occupation?: string | null, baseAnnualIncomeGross?: number | null, hasBonus?: boolean | null, expectedBonusAmount?: number | null, monthlyIncomeNet?: number | null, marginalTaxRate?: number | null, hasOtherIncome?: boolean | null, expectedOtherIncomeAmount?: number | null, eligibleForStatePension?: boolean | null, retirementAgeEstimate?: number | null, monthlyRetirementOutgoingExpected?: number | null, hasGoodHealth?: boolean | null, smokingStatus?: SmokingStatus | null, monthsOfFinancialSafety?: number | null, memberOfEmployersPensionScheme?: boolean | null, employerOffersPensionScheme?: boolean | null, directorOrOwnerOfLimitedCompany?: boolean | null, pensionSchemeIsIrishLife?: boolean | null, staleFields: Array<{ __typename: 'staleFields', key: string, lastUpdated: any } | null> } | null } };

export type GetFieldsQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
  context: Scalars['String']['input'];
}>;


export type GetFieldsQuery = { __typename: 'Query', factfindFields: { __typename: 'FactfindContextFields', id: string, questionGroups: Array<{ __typename: 'QuestionGroup', id: string, title: any, subtitle?: any | null, preTitle?: any | null, helperText?: string | null, contexts: Array<string>, questions: Array<{ __typename: 'Question', key: string, placeholder?: string | null, label?: string | null, helperText?: string | null, input: { __typename: 'FieldInput', type: FieldInputType, min?: number | null, max?: number | null, disabled?: boolean | null, options?: Array<{ __typename: 'FieldOption', label: string, value: any }> | null } }> }> } };

export type GetFinancialsFactFindQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;


export type GetFinancialsFactFindQuery = { __typename: 'Query', factfind: { __typename: 'Factfind', vulnerable?: boolean | null, id: string, monthlyRent?: number | null, monthlyUtilities?: number | null, monthlyOutgoingEssentials?: number | null, monthlyOutgoingNonEssentials?: number | null, extraMonthlyOutgoingEssentials?: number | null, staleFields: Array<{ __typename: 'staleFields', key: string, lastUpdated: any } | null>, userSpecificFactfind?: { __typename: 'PersonFactfind', employmentStatus?: EmploymentStatus | null, mainEmploymentType?: EmploymentType | null, occupation?: string | null, baseAnnualIncomeGross?: number | null, hasBonus?: boolean | null, expectedBonusAmount?: number | null, monthlyIncomeNet?: number | null, marginalTaxRate?: number | null, hasOtherIncome?: boolean | null, expectedOtherIncomeAmount?: number | null, eligibleForStatePension?: boolean | null, retirementAgeEstimate?: number | null, monthlyRetirementOutgoingExpected?: number | null, hasGoodHealth?: boolean | null, smokingStatus?: SmokingStatus | null, monthsOfFinancialSafety?: number | null, staleFields: Array<{ __typename: 'staleFields', key: string, lastUpdated: any } | null> } | null, partnerSpecificFactfind?: { __typename: 'PersonFactfind', employmentStatus?: EmploymentStatus | null, mainEmploymentType?: EmploymentType | null, occupation?: string | null, baseAnnualIncomeGross?: number | null, hasBonus?: boolean | null, expectedBonusAmount?: number | null, monthlyIncomeNet?: number | null, marginalTaxRate?: number | null, hasOtherIncome?: boolean | null, expectedOtherIncomeAmount?: number | null, eligibleForStatePension?: boolean | null, retirementAgeEstimate?: number | null, monthlyRetirementOutgoingExpected?: number | null, hasGoodHealth?: boolean | null, smokingStatus?: SmokingStatus | null, monthsOfFinancialSafety?: number | null, staleFields: Array<{ __typename: 'staleFields', key: string, lastUpdated: any } | null> } | null } };

export type GetGoalQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
  goalId: Scalars['UUID']['input'];
}>;


export type GetGoalQuery = { __typename: 'Query', goal?: { __typename: 'Goal', id: any, userId: string, priority?: number | null, name?: string | null, targetDate?: any | null, goalType?: GoalType | null, goalData?: any | null, owners: Array<{ __typename: 'Person', id: string, firstName?: string | null } | null>, valueToSave?: { __typename: 'Money', float: number, string: string, display: string } | null } | null };

export type GetGoalsQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;


export type GetGoalsQuery = { __typename: 'Query', goals?: Array<{ __typename: 'Goal', id: any, userId: string, priority?: number | null, name?: string | null, targetDate?: any | null, goalType?: GoalType | null, goalData?: any | null, owners: Array<{ __typename: 'Person', id: string, firstName?: string | null } | null>, valueToSave?: { __typename: 'Money', float: number, string: string, display: string } | null } | null> | null };

export type GetInteractionFlagQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
  flagKey: Scalars['ID']['input'];
}>;


export type GetInteractionFlagQuery = { __typename: 'Query', interactionFlag: { __typename: 'InteractionFlag', id: string, value?: boolean | null } };

export type GetMessagesQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;


export type GetMessagesQuery = { __typename: 'Query', messages: Array<{ __typename: 'Message', id: string, title: string, subtitle?: string | null, link?: string | null, read: boolean, dateReceived: any }> };

export type GetNationalitiesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetNationalitiesQuery = { __typename: 'Query', nationalities: Array<string | null> };

export type GetNextAvailableAppointmentQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;


export type GetNextAvailableAppointmentQuery = { __typename: 'Query', nextAvailableAppointment?: { __typename: 'AvailableAppointment', endTime: any, startTime: any, id: string } | null };

export type GetOccupationsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetOccupationsQuery = { __typename: 'Query', occupations: Array<string | null> };

export type GetPensionCalculationQueryVariables = Exact<{
  input: PensionCalculatorInput;
}>;


export type GetPensionCalculationQuery = { __typename: 'Query', calculatePension: { __typename: 'PensionCalculation', pensionProjection: Array<{ __typename: 'PensionAtDate', age: number, date: any, employmentIncome: { __typename: 'Money', float: number, display: string }, personalPensionAmount: { __typename: 'Money', float: number, display: string }, statePensionAmount: { __typename: 'Money', float: number, display: string }, targetIncome: { __typename: 'Money', float: number, display: string }, totalPensionAmount: { __typename: 'Money', float: number, display: string } } | null> } };

export type GetPersonQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
  personId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type GetPersonQuery = { __typename: 'Query', person?: { __typename: 'Person', id: string, title?: string | null, firstName?: string | null, legalFirstName?: string | null, legalLastName?: string | null, lastName?: string | null, dateOfBirth?: any | null, relationship?: Relationship | null, joinDate?: any | null, phoneNumber?: string | null, sex?: BiologicalSex | null, address?: { __typename: 'Address', id?: any | null, postalCode?: string | null, flatNumber?: string | null, buildingNumber?: string | null, buildingName?: string | null, street?: string | null, subStreet?: string | null, town?: string | null, county?: string | null, country?: string | null } | null } | null };

export type GetPersonsQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;


export type GetPersonsQuery = { __typename: 'Query', persons: Array<{ __typename: 'Person', id: string, title?: string | null, firstName?: string | null, legalFirstName?: string | null, legalLastName?: string | null, lastName?: string | null, dateOfBirth?: any | null, relationship?: Relationship | null, joinDate?: any | null, phoneNumber?: string | null, sex?: BiologicalSex | null, address?: { __typename: 'Address', id?: any | null, postalCode?: string | null, flatNumber?: string | null, buildingNumber?: string | null, buildingName?: string | null, street?: string | null, subStreet?: string | null, town?: string | null, county?: string | null, country?: string | null } | null }> };

export type GetPlanGraphQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
  startDate?: InputMaybe<Scalars['Date']['input']>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
}>;


export type GetPlanGraphQuery = { __typename: 'Query', planGraph: { __typename: 'WealthProjection', currentWealth: { __typename: 'Money', float: number, display: string }, finalWealth: { __typename: 'Money', float: number, display: string }, wealthProjection: Array<{ __typename: 'WealthAtDate', date: any, amount: { __typename: 'Money', float: number, display: string }, goals?: Array<{ __typename: 'Goal', id: any, userId: string, priority?: number | null, name?: string | null, targetDate?: any | null, goalType?: GoalType | null, goalData?: any | null, owners: Array<{ __typename: 'Person', id: string, firstName?: string | null } | null>, valueToSave?: { __typename: 'Money', float: number, string: string, display: string } | null } | null> | null } | null> } };

export type GetPoliciesQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;


export type GetPoliciesQuery = { __typename: 'Query', policies?: Array<{ __typename: 'Policy', id: any, productType: PolicyType, userId: string, isComplete: boolean, renewalDate?: any | null, name?: string | null, isOnePlan?: boolean | null, coverType?: CoverType | null, yearsRemaining?: number | null, paymentFrequency?: PaymentFrequency | null, isIrishLifePolicy?: boolean | null, throughCurrentEmployer?: boolean | null, owners?: Array<{ __typename: 'Person', id: string, relationship?: Relationship | null } | null> | null, provider?: { __typename: 'Provider', id?: string | null, name?: string | null, iconUrl?: string | null } | null, amountOfCover?: { __typename: 'Money', float: number, display: string, string: string } | null, premium?: { __typename: 'Money', float: number, display: string, string: string } | null } | null> | null };

export type GetPolicyQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
  policyId: Scalars['UUID']['input'];
}>;


export type GetPolicyQuery = { __typename: 'Query', policy?: { __typename: 'Policy', id: any, productType: PolicyType, userId: string, isComplete: boolean, renewalDate?: any | null, name?: string | null, isOnePlan?: boolean | null, coverType?: CoverType | null, yearsRemaining?: number | null, paymentFrequency?: PaymentFrequency | null, isIrishLifePolicy?: boolean | null, throughCurrentEmployer?: boolean | null, owners?: Array<{ __typename: 'Person', id: string, relationship?: Relationship | null } | null> | null, provider?: { __typename: 'Provider', id?: string | null, name?: string | null, iconUrl?: string | null } | null, amountOfCover?: { __typename: 'Money', float: number, display: string, string: string } | null, premium?: { __typename: 'Money', float: number, display: string, string: string } | null } | null };

export type GetProvidersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetProvidersQuery = { __typename: 'Query', providers?: Array<{ __typename: 'Provider', id?: string | null, name?: string | null, imageUrl?: string | null, iconUrl?: string | null, bannerColor?: string | null, address?: { __typename: 'Address', postalCode?: string | null } | null } | null> | null };

export type GetPrsaPensionApplicationQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;


export type GetPrsaPensionApplicationQuery = { __typename: 'Query', prsaPensionApplication: { __typename: 'PRSAPensionApplication', id: any, pensionContributionStartDate?: any | null, pensionDayOfDirectDebits?: number | null, pensionInflationProtection?: boolean | null, oneOffContribution?: boolean | null, submittedPrsaApplication?: boolean | null, submittedPrsaApplicationDate?: any | null, pensionSelfContribution?: { __typename: 'Money', float: number, display: string, string: string } | null, singleEmployeeContribution?: { __typename: 'Money', float: number, display: string, string: string } | null } };

export type GetRetirementAgeFactFindQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;


export type GetRetirementAgeFactFindQuery = { __typename: 'Query', factfind: { __typename: 'Factfind', id: string, userSpecificFactfind?: { __typename: 'PersonFactfind', retirementAgeEstimate?: number | null } | null, partnerSpecificFactfind?: { __typename: 'PersonFactfind', retirementAgeEstimate?: number | null } | null } };

export type GetRiskQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;


export type GetRiskQuery = { __typename: 'Query', risk: { __typename: 'Risk', id: string, selectedProfile?: { __typename: 'RiskProfile', id: string, name: string, description: string } | null, calculatedProfile?: { __typename: 'RiskProfile', id: string, name: string, description: string } | null, questionnaire?: { __typename: 'RiskQuestionnaire', id: string, exploringInvestmentOpportunitiesQ1?: string | null, bestPossibleReturnQ2?: string | null, typicalAttitudeFinancialDecisionsQ3?: string | null, riskPastFinancialDecisionsQ4?: string | null, preferInvestmentSafeQ5?: string | null, investmentsRiskAnxiousQ6?: string | null, investmentGoesDownReactionQ7?: string | null, highGrowthAcceptLossesQ8?: string | null, possibleHighReturnsChanceQ9?: string | null, friendDescribeAttitudeRisksQ10?: string | null, largeGainsRiskLargeLossesQ11?: string | null, choiceTwoInvestmentProductsQ12?: string | null, preferSmallCertainGainsQ13?: string | null, describeThinkAboutPossibleLossesGainsQ14?: string | null, investmentSafeLowerReturnsQ15?: string | null } | null } };

export type GetRiskProfilesQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;


export type GetRiskProfilesQuery = { __typename: 'Query', riskProfiles?: Array<{ __typename: 'RiskProfile', id: string, name: string, description: string } | null> | null };

export type GetScheduledAppointmentsQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;


export type GetScheduledAppointmentsQuery = { __typename: 'Query', scheduledAppointments: Array<{ __typename: 'Appointment', id: string, startTime: any, endTime: any, advisorId: string, advisorName: string, advisorEmail?: string | null, advisorPhone?: string | null, reason?: string | null }> };

export type GetToolsQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;


export type GetToolsQuery = { __typename: 'Query', tools?: Array<string | null> | null };

export type GetUserQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;


export type GetUserQuery = { __typename: 'Query', user?: { __typename: 'User', id: string, email?: string | null, referralSource?: string | null, userType?: string | null, userJourney?: string | null } | null };

export type GetVulnerabilityReminderQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;


export type GetVulnerabilityReminderQuery = { __typename: 'Query', vulnerabilityReminder?: any | null };

export type RequestPlanMutationVariables = Exact<{
  input: RequestPlanInput;
}>;


export type RequestPlanMutation = { __typename: 'Mutation', requestPlan: { __typename: 'RequestPlanPayload', success: boolean, error?: { __typename: 'ErrorType', message: string, fieldErrors?: any | null } | null } };

export type SetVulnerabilityReminderMutationVariables = Exact<{
  input: SetVulnerabilityReminderInput;
}>;


export type SetVulnerabilityReminderMutation = { __typename: 'Mutation', setVulnerabilityReminder: { __typename: 'SetVulnerabilityReminderPayload', success: boolean, reminderDate?: any | null, error?: { __typename: 'ErrorType', message: string, fieldErrors?: any | null } | null } };

export type ShowSurveyQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;


export type ShowSurveyQuery = { __typename: 'Query', showSurvey?: boolean | null };

export type SignUpMutationVariables = Exact<{
  input: SignUpInput;
}>;


export type SignUpMutation = { __typename: 'Mutation', signUp?: { __typename: 'SignUpPayload', success: boolean, error?: { __typename: 'ErrorType', code: ErrorCode, message: string } | null } | null };

export type SubmitPensionApplicationMutationVariables = Exact<{
  input: SubmitPrsaPensionApplicationInput;
}>;


export type SubmitPensionApplicationMutation = { __typename: 'Mutation', submitPensionApplication: { __typename: 'SubmissionPayload', validationErrors?: any | null, success: boolean, error?: { __typename: 'ErrorType', message: string, fieldErrors?: any | null } | null } };

export type SubscribeToToolMutationVariables = Exact<{
  input: NewToolInput;
}>;


export type SubscribeToToolMutation = { __typename: 'Mutation', subscribeToTool: { __typename: 'NewToolPayload', success: boolean, tool?: string | null, error?: { __typename: 'ErrorType', message: string, fieldErrors?: any | null } | null } };

export type SuggestNewToolMutationVariables = Exact<{
  input: NewToolInput;
}>;


export type SuggestNewToolMutation = { __typename: 'Mutation', suggestNewTool: { __typename: 'NewToolPayload', success: boolean, tool?: string | null, error?: { __typename: 'ErrorType', message: string, fieldErrors?: any | null } | null } };

export type SyncUserMutationVariables = Exact<{
  input: SyncUserInput;
}>;


export type SyncUserMutation = { __typename: 'Mutation', syncUser?: { __typename: 'SyncUserPayload', success: boolean, error?: { __typename: 'ErrorType', code: ErrorCode, message: string } | null } | null };

export type UpdateAssetMutationVariables = Exact<{
  input: UpdateAssetInput;
}>;


export type UpdateAssetMutation = { __typename: 'Mutation', updateAsset?: { __typename: 'UpdateAssetPayload', success: boolean, error?: { __typename: 'ErrorType', message: string, fieldErrors?: any | null } | null, asset?: { __typename: 'Asset', id: any, productType: AssetType, userId: string, isComplete: boolean, name?: string | null, accessible?: boolean | null, maturityDate?: any | null, increasing?: boolean | null, startDate?: any | null, valuationMethod?: ValuationMethod | null, whereFrom?: AssetOrigin | null, propertyType?: PropertyType | null, pensionType?: PensionType | null, frequency?: PaymentFrequency | null, active?: boolean | null, owners?: Array<{ __typename: 'Person', id: string, relationship?: Relationship | null } | null> | null, provider?: { __typename: 'Provider', id?: string | null, name?: string | null, iconUrl?: string | null } | null, balance?: { __typename: 'Money', float: number, display: string, string: string } | null, overdrawnBy?: { __typename: 'Money', float: number, display: string, string: string } | null, regularPaymentAmount?: { __typename: 'Money', float: number, display: string, string: string } | null } | null } | null };

export type UpdateAssetsMutationVariables = Exact<{
  input: UpdateAssetsInput;
}>;


export type UpdateAssetsMutation = { __typename: 'Mutation', updateAssets?: { __typename: 'UpdateAssetsPayload', success: boolean, error?: { __typename: 'ErrorType', message: string, fieldErrors?: any | null } | null, assets?: Array<{ __typename: 'Asset', id: any, productType: AssetType, userId: string, isComplete: boolean, name?: string | null, accessible?: boolean | null, maturityDate?: any | null, active?: boolean | null, owners?: Array<{ __typename: 'Person', id: string, relationship?: Relationship | null } | null> | null, provider?: { __typename: 'Provider', id?: string | null, name?: string | null, iconUrl?: string | null } | null, balance?: { __typename: 'Money', float: number, display: string, string: string } | null, overdrawnBy?: { __typename: 'Money', float: number, display: string, string: string } | null } | null> | null } | null };

export type UpdateBasicInfoFactFindMutationVariables = Exact<{
  input: UpdateFactfindInput;
}>;


export type UpdateBasicInfoFactFindMutation = { __typename: 'Mutation', updateFactfind: { __typename: 'UpdateFactfindPayload', success: boolean, error?: { __typename: 'ErrorType', code: ErrorCode, message: string } | null, factfind?: { __typename: 'Factfind', vulnerable?: boolean | null, id: string, planningFor?: PlanScope | null, maritalStatus?: MaritalStatus | null, hasChildren?: boolean | null, numberOfChildren?: number | null, ageOfChildren?: Array<number | null> | null, numberOfOtherDependants?: number | null, relationshipToOtherDependants?: Array<DependantRelationship | null> | null, ownsHome?: boolean | null, hasMortgage?: boolean | null, staleFields: Array<{ __typename: 'staleFields', key: string, lastUpdated: any } | null>, partnerSpecificFactfind?: { __typename: 'PersonFactfind', firstName?: string | null, lastName?: string | null, staleFields: Array<{ __typename: 'staleFields', key: string, lastUpdated: any } | null> } | null } | null, fields?: { __typename: 'FactfindContextFields', id: string, questionGroups: Array<{ __typename: 'QuestionGroup', id: string, title: any, subtitle?: any | null, preTitle?: any | null, helperText?: string | null, contexts: Array<string>, questions: Array<{ __typename: 'Question', key: string, placeholder?: string | null, label?: string | null, helperText?: string | null, input: { __typename: 'FieldInput', type: FieldInputType, min?: number | null, max?: number | null, disabled?: boolean | null, options?: Array<{ __typename: 'FieldOption', label: string, value: any }> | null } }> }> } | null } };

export type UpdateCheckInMutationVariables = Exact<{
  input: UpdateCheckInInput;
}>;


export type UpdateCheckInMutation = { __typename: 'Mutation', updateCheckIn: { __typename: 'checkInPayload', checkIns?: Array<{ __typename: 'checkIn', checkInType: CheckInType, lastChecked?: any | null, stale: boolean }> | null } };

export type UpdateConsentMutationVariables = Exact<{
  input: UpdateConsentInput;
}>;


export type UpdateConsentMutation = { __typename: 'Mutation', updateConsent: { __typename: 'UpdateConsentPayload', success: boolean, error?: { __typename: 'ErrorType', message: string, fieldErrors?: any | null } | null, consent?: { __typename: 'Consent', id: string, contactServicesIrishLifeGroup?: boolean | null, userResearch?: boolean | null, checkInEmails?: boolean | null } | null } };

export type UpdateDebtMutationVariables = Exact<{
  input: UpdateDebtInput;
}>;


export type UpdateDebtMutation = { __typename: 'Mutation', updateDebt?: { __typename: 'UpdateDebtPayload', success: boolean, error?: { __typename: 'ErrorType', message: string, fieldErrors?: any | null } | null, debt?: { __typename: 'Debt', id: any, productType: DebtType, userId: string, isComplete: boolean, name?: string | null, clearedOnDeath?: boolean | null, maturityDate?: any | null, endDate?: any | null, mortgageType?: MortgageType | null, mortgageYearsLeft?: number | null, isMainMortgage?: boolean | null, repaidMonthly?: boolean | null, arePaymentsUpToDate?: boolean | null, hasPaymentProtectionInsurance?: boolean | null, owners?: Array<{ __typename: 'Person', id: string, firstName?: string | null, lastName?: string | null } | null> | null, provider?: { __typename: 'Provider', id?: string | null, name?: string | null, iconUrl?: string | null } | null, balance?: { __typename: 'Money', float: number, display: string } | null, monthlyRepayment?: { __typename: 'Money', float: number, display: string } | null } | null } | null };

export type UpdateDebtsMutationVariables = Exact<{
  input: UpdateDebtsInput;
}>;


export type UpdateDebtsMutation = { __typename: 'Mutation', updateDebts?: { __typename: 'UpdateDebtsPayload', success: boolean, error?: { __typename: 'ErrorType', message: string, fieldErrors?: any | null } | null, debts?: Array<{ __typename: 'Debt', id: any, productType: DebtType, userId: string, isComplete: boolean, name?: string | null, clearedOnDeath?: boolean | null, maturityDate?: any | null, endDate?: any | null, mortgageType?: MortgageType | null, mortgageYearsLeft?: number | null, isMainMortgage?: boolean | null, repaidMonthly?: boolean | null, arePaymentsUpToDate?: boolean | null, hasPaymentProtectionInsurance?: boolean | null, owners?: Array<{ __typename: 'Person', id: string, firstName?: string | null, lastName?: string | null } | null> | null, provider?: { __typename: 'Provider', id?: string | null, name?: string | null, iconUrl?: string | null } | null, balance?: { __typename: 'Money', float: number, display: string } | null, monthlyRepayment?: { __typename: 'Money', float: number, display: string } | null } | null> | null } | null };

export type UpdateEmailMutationVariables = Exact<{
  input: UpdateEmailInput;
}>;


export type UpdateEmailMutation = { __typename: 'Mutation', updateEmail?: { __typename: 'UpdateEmailPayload', success: boolean, error?: { __typename: 'ErrorType', code: ErrorCode, message: string, fieldErrors?: any | null } | null } | null };

export type UpdateFactFindMutationVariables = Exact<{
  input: UpdateFactfindInput;
}>;


export type UpdateFactFindMutation = { __typename: 'Mutation', updateFactfind: { __typename: 'UpdateFactfindPayload', success: boolean, validationErrors?: any | null, error?: { __typename: 'ErrorType', code: ErrorCode, message: string, fieldErrors?: any | null } | null, triage?: { __typename: 'Triage', userIsTriaged: boolean, action?: TriageAction | null, reason?: string | null } | null, factfind?: { __typename: 'Factfind', vulnerable?: boolean | null, id: string, monthlyRent?: number | null, monthlyUtilities?: number | null, monthlyOutgoingEssentials?: number | null, monthlyOutgoingNonEssentials?: number | null, extraMonthlyOutgoingEssentials?: number | null, planningFor?: PlanScope | null, hasChildren?: boolean | null, numberOfChildren?: number | null, ageOfChildren?: Array<number | null> | null, otherDependants?: boolean | null, numberOfOtherDependants?: number | null, relationshipToOtherDependants?: Array<DependantRelationship | null> | null, maritalStatus?: MaritalStatus | null, hasMortgage?: boolean | null, ownsHome?: boolean | null, staleFields: Array<{ __typename: 'staleFields', key: string, lastUpdated: any } | null>, userSpecificFactfind?: { __typename: 'PersonFactfind', employmentStatus?: EmploymentStatus | null, mainEmploymentType?: EmploymentType | null, occupation?: string | null, baseAnnualIncomeGross?: number | null, hasBonus?: boolean | null, expectedBonusAmount?: number | null, monthlyIncomeNet?: number | null, marginalTaxRate?: number | null, hasOtherIncome?: boolean | null, hasPension?: boolean | null, expectedOtherIncomeAmount?: number | null, eligibleForStatePension?: boolean | null, retirementAgeEstimate?: number | null, monthlyRetirementOutgoingExpected?: number | null, hasGoodHealth?: boolean | null, smokingStatus?: SmokingStatus | null, monthsOfFinancialSafety?: number | null, memberOfEmployersPensionScheme?: boolean | null, employerOffersPensionScheme?: boolean | null, PPSNumber?: string | null, birthCountry?: string | null, domicileCountry?: string | null, residentCountry?: string | null, industry?: IndustryType | null, pep?: boolean | null, nationality?: string | null, employer?: string | null, employerAddressLine1?: string | null, employerAddressLine2?: string | null, employerAddressLine3?: string | null, directorOrOwnerOfLimitedCompany?: boolean | null, pensionSchemeIsIrishLife?: boolean | null, staleFields: Array<{ __typename: 'staleFields', key: string, lastUpdated: any } | null>, benefitInKind?: { __typename: 'Money', float: number, display: string, string: string } | null } | null, partnerSpecificFactfind?: { __typename: 'PersonFactfind', firstName?: string | null, lastName?: string | null, dateOfBirth?: any | null, employmentStatus?: EmploymentStatus | null, mainEmploymentType?: EmploymentType | null, occupation?: string | null, baseAnnualIncomeGross?: number | null, hasBonus?: boolean | null, expectedBonusAmount?: number | null, monthlyIncomeNet?: number | null, marginalTaxRate?: number | null, hasOtherIncome?: boolean | null, expectedOtherIncomeAmount?: number | null, eligibleForStatePension?: boolean | null, retirementAgeEstimate?: number | null, monthlyRetirementOutgoingExpected?: number | null, hasGoodHealth?: boolean | null, smokingStatus?: SmokingStatus | null, monthsOfFinancialSafety?: number | null, memberOfEmployersPensionScheme?: boolean | null, employerOffersPensionScheme?: boolean | null, directorOrOwnerOfLimitedCompany?: boolean | null, pensionSchemeIsIrishLife?: boolean | null, staleFields: Array<{ __typename: 'staleFields', key: string, lastUpdated: any } | null> } | null } | null, fields?: { __typename: 'FactfindContextFields', id: string, questionGroups: Array<{ __typename: 'QuestionGroup', id: string, title: any, subtitle?: any | null, preTitle?: any | null, helperText?: string | null, contexts: Array<string>, questions: Array<{ __typename: 'Question', key: string, placeholder?: string | null, label?: string | null, helperText?: string | null, input: { __typename: 'FieldInput', type: FieldInputType, min?: number | null, max?: number | null, disabled?: boolean | null, options?: Array<{ __typename: 'FieldOption', label: string, value: any }> | null } }> }> } | null } };

export type UpdateFinancialsFactFindMutationVariables = Exact<{
  input: UpdateFactfindInput;
}>;


export type UpdateFinancialsFactFindMutation = { __typename: 'Mutation', updateFactfind: { __typename: 'UpdateFactfindPayload', success: boolean, error?: { __typename: 'ErrorType', code: ErrorCode, message: string, fieldErrors?: any | null } | null, factfind?: { __typename: 'Factfind', vulnerable?: boolean | null, id: string, monthlyRent?: number | null, monthlyUtilities?: number | null, monthlyOutgoingEssentials?: number | null, monthlyOutgoingNonEssentials?: number | null, extraMonthlyOutgoingEssentials?: number | null, staleFields: Array<{ __typename: 'staleFields', key: string, lastUpdated: any } | null>, userSpecificFactfind?: { __typename: 'PersonFactfind', employmentStatus?: EmploymentStatus | null, mainEmploymentType?: EmploymentType | null, occupation?: string | null, baseAnnualIncomeGross?: number | null, hasBonus?: boolean | null, expectedBonusAmount?: number | null, monthlyIncomeNet?: number | null, marginalTaxRate?: number | null, hasOtherIncome?: boolean | null, expectedOtherIncomeAmount?: number | null, eligibleForStatePension?: boolean | null, retirementAgeEstimate?: number | null, monthlyRetirementOutgoingExpected?: number | null, hasGoodHealth?: boolean | null, smokingStatus?: SmokingStatus | null, monthsOfFinancialSafety?: number | null, staleFields: Array<{ __typename: 'staleFields', key: string, lastUpdated: any } | null> } | null, partnerSpecificFactfind?: { __typename: 'PersonFactfind', employmentStatus?: EmploymentStatus | null, mainEmploymentType?: EmploymentType | null, occupation?: string | null, baseAnnualIncomeGross?: number | null, hasBonus?: boolean | null, expectedBonusAmount?: number | null, monthlyIncomeNet?: number | null, marginalTaxRate?: number | null, hasOtherIncome?: boolean | null, expectedOtherIncomeAmount?: number | null, eligibleForStatePension?: boolean | null, retirementAgeEstimate?: number | null, monthlyRetirementOutgoingExpected?: number | null, hasGoodHealth?: boolean | null, smokingStatus?: SmokingStatus | null, monthsOfFinancialSafety?: number | null, staleFields: Array<{ __typename: 'staleFields', key: string, lastUpdated: any } | null> } | null } | null, fields?: { __typename: 'FactfindContextFields', id: string, questionGroups: Array<{ __typename: 'QuestionGroup', id: string, title: any, subtitle?: any | null, preTitle?: any | null, helperText?: string | null, contexts: Array<string>, questions: Array<{ __typename: 'Question', key: string, placeholder?: string | null, label?: string | null, helperText?: string | null, input: { __typename: 'FieldInput', type: FieldInputType, min?: number | null, max?: number | null, disabled?: boolean | null, options?: Array<{ __typename: 'FieldOption', label: string, value: any }> | null } }> }> } | null } };

export type UpdateGoalMutationVariables = Exact<{
  input: UpdateGoalInput;
}>;


export type UpdateGoalMutation = { __typename: 'Mutation', updateGoal?: { __typename: 'UpdateGoalPayload', success: boolean, error?: { __typename: 'ErrorType', code: ErrorCode, message: string, fieldErrors?: any | null } | null, goal?: { __typename: 'Goal', id: any, userId: string, name?: string | null, targetDate?: any | null, goalType?: GoalType | null, priority?: number | null, owners: Array<{ __typename: 'Person', id: string, firstName?: string | null } | null>, valueToSave?: { __typename: 'Money', float: number, string: string, display: string } | null } | null } | null };

export type UpdateGoalsMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
  goals: Array<GoalsInput> | GoalsInput;
}>;


export type UpdateGoalsMutation = { __typename: 'Mutation', updateGoals?: { __typename: 'UpdateGoalsPayload', success: boolean, error?: { __typename: 'ErrorType', code: ErrorCode, message: string, fieldErrors?: any | null } | null, goals?: Array<{ __typename: 'Goal', id: any, userId: string, name?: string | null, targetDate?: any | null, goalType?: GoalType | null, priority?: number | null, owners: Array<{ __typename: 'Person', id: string, firstName?: string | null } | null>, valueToSave?: { __typename: 'Money', float: number, string: string, display: string } | null } | null> | null } | null };

export type UpdateInteractionFlagMutationVariables = Exact<{
  input: UpdateInteractionFlagInput;
}>;


export type UpdateInteractionFlagMutation = { __typename: 'Mutation', updateInteractionFlag: { __typename: 'UpdateInteractionFlagPayload', success: boolean, error?: { __typename: 'ErrorType', message: string, fieldErrors?: any | null } | null, interactionFlag?: { __typename: 'InteractionFlag', id: string, value?: boolean | null } | null } };

export type UpdatePensionApplicationMutationVariables = Exact<{
  input: UpdatePrsaPensionApplicationInput;
}>;


export type UpdatePensionApplicationMutation = { __typename: 'Mutation', updatePensionApplication: { __typename: 'PRSAPensionApplicationPayload', success: boolean, validationErrors?: any | null, error?: { __typename: 'ErrorType', code: ErrorCode, message: string, fieldErrors?: any | null } | null, prsaPensionApplication?: { __typename: 'PRSAPensionApplication', id: any, pensionContributionStartDate?: any | null, pensionDayOfDirectDebits?: number | null, pensionInflationProtection?: boolean | null, oneOffContribution?: boolean | null, submittedPrsaApplication?: boolean | null, submittedPrsaApplicationDate?: any | null, pensionSelfContribution?: { __typename: 'Money', float: number, display: string, string: string } | null, singleEmployeeContribution?: { __typename: 'Money', float: number, display: string, string: string } | null } | null, fields?: { __typename: 'FactfindContextFields', id: string, questionGroups: Array<{ __typename: 'QuestionGroup', id: string, title: any, subtitle?: any | null, preTitle?: any | null, helperText?: string | null, contexts: Array<string>, questions: Array<{ __typename: 'Question', key: string, placeholder?: string | null, label?: string | null, helperText?: string | null, input: { __typename: 'FieldInput', type: FieldInputType, min?: number | null, max?: number | null, disabled?: boolean | null, options?: Array<{ __typename: 'FieldOption', label: string, value: any }> | null } }> }> } | null } };

export type UpdatePersonMutationVariables = Exact<{
  input: UpdatePersonInput;
}>;


export type UpdatePersonMutation = { __typename: 'Mutation', updatePerson: { __typename: 'UpdatePersonPayload', success: boolean, error?: { __typename: 'ErrorType', code: ErrorCode, message: string, fieldErrors?: any | null } | null, person?: { __typename: 'Person', id: string, sex?: BiologicalSex | null, firstName?: string | null, lastName?: string | null, dateOfBirth?: any | null, phoneNumber?: string | null, address?: { __typename: 'Address', id?: any | null, postalCode?: string | null, flatNumber?: string | null, buildingNumber?: string | null, buildingName?: string | null, street?: string | null, town?: string | null, county?: string | null, country?: string | null } | null } | null } };

export type UpdatePoliciesMutationVariables = Exact<{
  input: UpdatePoliciesInput;
}>;


export type UpdatePoliciesMutation = { __typename: 'Mutation', updatePolicies?: { __typename: 'UpdatePoliciesPayload', success: boolean, error?: { __typename: 'ErrorType', message: string, fieldErrors?: any | null } | null, policies?: Array<{ __typename: 'Policy', id: any, productType: PolicyType, userId: string, isComplete: boolean, renewalDate?: any | null, name?: string | null, coverType?: CoverType | null, yearsRemaining?: number | null, paymentFrequency?: PaymentFrequency | null, isIrishLifePolicy?: boolean | null, throughCurrentEmployer?: boolean | null, owners?: Array<{ __typename: 'Person', id: string, relationship?: Relationship | null } | null> | null, provider?: { __typename: 'Provider', id?: string | null, name?: string | null, iconUrl?: string | null } | null, amountOfCover?: { __typename: 'Money', float: number, display: string } | null, premium?: { __typename: 'Money', float: number, display: string } | null } | null> | null } | null };

export type UpdatePolicyMutationVariables = Exact<{
  input: UpdatePolicyInput;
}>;


export type UpdatePolicyMutation = { __typename: 'Mutation', updatePolicy?: { __typename: 'UpdatePolicyPayload', success: boolean, error?: { __typename: 'ErrorType', message: string, fieldErrors?: any | null } | null, policy?: { __typename: 'Policy', id: any, productType: PolicyType, userId: string, isComplete: boolean, renewalDate?: any | null, name?: string | null, isOnePlan?: boolean | null, coverType?: CoverType | null, yearsRemaining?: number | null, paymentFrequency?: PaymentFrequency | null, isIrishLifePolicy?: boolean | null, throughCurrentEmployer?: boolean | null, owners?: Array<{ __typename: 'Person', id: string, relationship?: Relationship | null } | null> | null, provider?: { __typename: 'Provider', id?: string | null, name?: string | null, iconUrl?: string | null } | null, amountOfCover?: { __typename: 'Money', float: number, display: string, string: string } | null, premium?: { __typename: 'Money', float: number, display: string, string: string } | null } | null } | null };

export type UpdateRiskMutationVariables = Exact<{
  input: UpdateRiskInput;
}>;


export type UpdateRiskMutation = { __typename: 'Mutation', updateRisk: { __typename: 'UpdateRiskPayload', success: boolean, validationErrors?: any | null, error?: { __typename: 'ErrorType', message: string, fieldErrors?: any | null } | null, risk?: { __typename: 'Risk', id: string, selectedProfile?: { __typename: 'RiskProfile', id: string, name: string, description: string } | null, calculatedProfile?: { __typename: 'RiskProfile', id: string, name: string, description: string } | null, questionnaire?: { __typename: 'RiskQuestionnaire', id: string, exploringInvestmentOpportunitiesQ1?: string | null, bestPossibleReturnQ2?: string | null, typicalAttitudeFinancialDecisionsQ3?: string | null, riskPastFinancialDecisionsQ4?: string | null, preferInvestmentSafeQ5?: string | null, investmentsRiskAnxiousQ6?: string | null, investmentGoesDownReactionQ7?: string | null, highGrowthAcceptLossesQ8?: string | null, possibleHighReturnsChanceQ9?: string | null, friendDescribeAttitudeRisksQ10?: string | null, largeGainsRiskLargeLossesQ11?: string | null, choiceTwoInvestmentProductsQ12?: string | null, preferSmallCertainGainsQ13?: string | null, describeThinkAboutPossibleLossesGainsQ14?: string | null, investmentSafeLowerReturnsQ15?: string | null } | null } | null } };

export type CalculateCollegeCostsMutationVariables = Exact<{
  input: CollegeCalculatorInput;
}>;


export type CalculateCollegeCostsMutation = { __typename: 'Mutation', updateCollegeCosts: { __typename: 'CollegeCost', accommodationType?: AccommodationType | null, ageOfChild?: number | null, courseDuration?: number | null, eligibleForFreeTuitionFees?: boolean | null, goalId?: string | null, id?: string | null, targetDate?: any | null, userId?: string | null, whatToInclude?: Array<WhatToIncludeType | null> | null, accommodationCost?: { __typename: 'Money', float: number, string: string, display: string } | null, annualCost?: { __typename: 'Money', float: number, string: string, display: string } | null, fees?: { __typename: 'Money', float: number, string: string, display: string } | null, monthlySavingsRequired?: { __typename: 'Money', float: number, string: string, display: string } | null, otherExpenses?: { __typename: 'Money', float: number, string: string, display: string } | null, total?: { __typename: 'Money', float: number, string: string, display: string } | null, totalAdjustedForInflation?: { __typename: 'Money', float: number, string: string, display: string } | null } };

export type GetAllCollegeCostsQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;


export type GetAllCollegeCostsQuery = { __typename: 'Query', collegeCosts?: Array<{ __typename: 'CollegeCost', accommodationType?: AccommodationType | null, ageOfChild?: number | null, courseDuration?: number | null, eligibleForFreeTuitionFees?: boolean | null, goalId?: string | null, id?: string | null, targetDate?: any | null, userId?: string | null, whatToInclude?: Array<WhatToIncludeType | null> | null, accommodationCost?: { __typename: 'Money', float: number, string: string, display: string } | null, annualCost?: { __typename: 'Money', float: number, string: string, display: string } | null, fees?: { __typename: 'Money', float: number, string: string, display: string } | null, monthlySavingsRequired?: { __typename: 'Money', float: number, string: string, display: string } | null, otherExpenses?: { __typename: 'Money', float: number, string: string, display: string } | null, total?: { __typename: 'Money', float: number, string: string, display: string } | null, totalAdjustedForInflation?: { __typename: 'Money', float: number, string: string, display: string } | null } | null> | null };

export type GetCollegeCostQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
  collegeCostId?: InputMaybe<Scalars['ID']['input']>;
  collegeCostUuid?: InputMaybe<Scalars['UUID']['input']>;
}>;


export type GetCollegeCostQuery = { __typename: 'Query', collegeCost?: { __typename: 'CollegeCost', accommodationType?: AccommodationType | null, ageOfChild?: number | null, courseDuration?: number | null, eligibleForFreeTuitionFees?: boolean | null, goalId?: string | null, id?: string | null, targetDate?: any | null, userId?: string | null, whatToInclude?: Array<WhatToIncludeType | null> | null, accommodationCost?: { __typename: 'Money', float: number, string: string, display: string } | null, annualCost?: { __typename: 'Money', float: number, string: string, display: string } | null, fees?: { __typename: 'Money', float: number, string: string, display: string } | null, monthlySavingsRequired?: { __typename: 'Money', float: number, string: string, display: string } | null, otherExpenses?: { __typename: 'Money', float: number, string: string, display: string } | null, total?: { __typename: 'Money', float: number, string: string, display: string } | null, totalAdjustedForInflation?: { __typename: 'Money', float: number, string: string, display: string } | null } | null };

export type FactfindFragmentFragment = { __typename: 'Factfind', vulnerable?: boolean | null, id: string, monthlyRent?: number | null, monthlyUtilities?: number | null, monthlyOutgoingEssentials?: number | null, monthlyOutgoingNonEssentials?: number | null, extraMonthlyOutgoingEssentials?: number | null, planningFor?: PlanScope | null, hasChildren?: boolean | null, numberOfChildren?: number | null, ageOfChildren?: Array<number | null> | null, otherDependants?: boolean | null, numberOfOtherDependants?: number | null, relationshipToOtherDependants?: Array<DependantRelationship | null> | null, maritalStatus?: MaritalStatus | null, hasMortgage?: boolean | null, ownsHome?: boolean | null, staleFields: Array<{ __typename: 'staleFields', key: string, lastUpdated: any } | null>, userSpecificFactfind?: { __typename: 'PersonFactfind', employmentStatus?: EmploymentStatus | null, mainEmploymentType?: EmploymentType | null, occupation?: string | null, baseAnnualIncomeGross?: number | null, hasBonus?: boolean | null, expectedBonusAmount?: number | null, monthlyIncomeNet?: number | null, marginalTaxRate?: number | null, hasOtherIncome?: boolean | null, hasPension?: boolean | null, expectedOtherIncomeAmount?: number | null, eligibleForStatePension?: boolean | null, retirementAgeEstimate?: number | null, monthlyRetirementOutgoingExpected?: number | null, hasGoodHealth?: boolean | null, smokingStatus?: SmokingStatus | null, monthsOfFinancialSafety?: number | null, memberOfEmployersPensionScheme?: boolean | null, employerOffersPensionScheme?: boolean | null, PPSNumber?: string | null, birthCountry?: string | null, domicileCountry?: string | null, residentCountry?: string | null, industry?: IndustryType | null, pep?: boolean | null, nationality?: string | null, employer?: string | null, employerAddressLine1?: string | null, employerAddressLine2?: string | null, employerAddressLine3?: string | null, directorOrOwnerOfLimitedCompany?: boolean | null, pensionSchemeIsIrishLife?: boolean | null, staleFields: Array<{ __typename: 'staleFields', key: string, lastUpdated: any } | null>, benefitInKind?: { __typename: 'Money', float: number, display: string, string: string } | null } | null, partnerSpecificFactfind?: { __typename: 'PersonFactfind', firstName?: string | null, lastName?: string | null, dateOfBirth?: any | null, employmentStatus?: EmploymentStatus | null, mainEmploymentType?: EmploymentType | null, occupation?: string | null, baseAnnualIncomeGross?: number | null, hasBonus?: boolean | null, expectedBonusAmount?: number | null, monthlyIncomeNet?: number | null, marginalTaxRate?: number | null, hasOtherIncome?: boolean | null, expectedOtherIncomeAmount?: number | null, eligibleForStatePension?: boolean | null, retirementAgeEstimate?: number | null, monthlyRetirementOutgoingExpected?: number | null, hasGoodHealth?: boolean | null, smokingStatus?: SmokingStatus | null, monthsOfFinancialSafety?: number | null, memberOfEmployersPensionScheme?: boolean | null, employerOffersPensionScheme?: boolean | null, directorOrOwnerOfLimitedCompany?: boolean | null, pensionSchemeIsIrishLife?: boolean | null, staleFields: Array<{ __typename: 'staleFields', key: string, lastUpdated: any } | null> } | null };

export type FieldContextFragmentFragment = { __typename: 'FactfindContextFields', id: string, questionGroups: Array<{ __typename: 'QuestionGroup', id: string, title: any, subtitle?: any | null, preTitle?: any | null, helperText?: string | null, contexts: Array<string>, questions: Array<{ __typename: 'Question', key: string, placeholder?: string | null, label?: string | null, helperText?: string | null, input: { __typename: 'FieldInput', type: FieldInputType, min?: number | null, max?: number | null, disabled?: boolean | null, options?: Array<{ __typename: 'FieldOption', label: string, value: any }> | null } }> }> };

export type GoalFragmentFragment = { __typename: 'Goal', id: any, userId: string, priority?: number | null, name?: string | null, targetDate?: any | null, goalType?: GoalType | null, goalData?: any | null, owners: Array<{ __typename: 'Person', id: string, firstName?: string | null } | null>, valueToSave?: { __typename: 'Money', float: number, string: string, display: string } | null };

export type PersonFragmentFragment = { __typename: 'Person', id: string, title?: string | null, firstName?: string | null, legalFirstName?: string | null, legalLastName?: string | null, lastName?: string | null, dateOfBirth?: any | null, relationship?: Relationship | null, joinDate?: any | null, phoneNumber?: string | null, sex?: BiologicalSex | null, address?: { __typename: 'Address', id?: any | null, postalCode?: string | null, flatNumber?: string | null, buildingNumber?: string | null, buildingName?: string | null, street?: string | null, subStreet?: string | null, town?: string | null, county?: string | null, country?: string | null } | null };

export type GetPlanQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;


export type GetPlanQuery = { __typename: 'Query', plan: { __typename: 'Plan', id: string, factfindErrors?: any | null, lastUpdated?: any | null, suitabilityReportLink?: string | null, authorisationStatus?: AuthorisationStatus | null, triageReason?: string | null, monthlyAllocationAmount?: { __typename: 'Money', display: string, string: string, float: number } | null, recommendationGroups?: Array<{ __typename: 'RecommendationGroup', id: string, title: string, subtitle: string, factfindSummary: string, recommendationType: RecommendationType, thingsToDo?: number | null, riskProfileQuestionnaireRequired: boolean, summary?: { __typename: 'DebtSummary', clearedBy: string, totalDebtAmount: { __typename: 'Money', display: string, string: string, float: number }, idealMonthlyRepayment: { __typename: 'Money', display: string, string: string, float: number } } | { __typename: 'EmergencyFundSummary', emergencyFundProgress: { __typename: 'EmergencyFundProgress', monthsProtected: number, recommendedProtectedMonths: number, progress: any, currentProvision: { __typename: 'Money', display: string, string: string, float: number }, recommendedProvision: { __typename: 'Money', display: string, string: string, float: number } } } | { __typename: 'HealthSummary', missing: boolean, covered: HealthCoverageStatus } | { __typename: 'ProtectionSummary', currentCover: ProtectionProvision, idealCover: ProtectionProvision, missing: boolean, missingPolicies?: string | null, scenarios?: Array<{ __typename: 'ProtectionScenario', title: string, subtitle: string, covered: CoverForScenario, description: string, recommended: { __typename: 'Money', display: string, string: string, float: number }, recommendedForUser: { __typename: 'Money', display: string, string: string, float: number }, recommendedForPartner?: { __typename: 'Money', display: string, string: string, float: number } | null } | null> | null } | { __typename: 'RetirementSummary', recommendPRSA: boolean, prsaRecommendedFund: Array<{ __typename: 'PRSAFundRecommendation', fund: PrsaFund, percentage: number }>, currentProvision: { __typename: 'Money', display: string, string: string, float: number }, targetProvision: { __typename: 'Money', display: string, float: number, string: string }, realisticProvision: { __typename: 'Money', display: string, string: string, float: number }, breakdown: Array<{ __typename: 'BreakdownSlice', name: string, amount: { __typename: 'Money', display: string, float: number, string: string } }> } | { __typename: 'SavingsInvestingSummary', savingsSummary: SavingsSummary, investingSummary: InvestingSummary, breakdown: Array<{ __typename: 'BreakdownSlice', name: string, amount: { __typename: 'Money', display: string, string: string, float: number } }>, emergencyFundProgress: { __typename: 'EmergencyFundProgress', monthsProtected: number, recommendedProtectedMonths: number, progress: any, currentProvision: { __typename: 'Money', display: string, string: string, float: number }, recommendedProvision: { __typename: 'Money', display: string, string: string, float: number } }, goalProgress: Array<{ __typename: 'GoalProgress', name: string, goalType: GoalType, progress?: any | null, amountSaved: { __typename: 'Money', display: string, string: string, float: number }, targetAmount: { __typename: 'Money', display: string, string: string, float: number } } | null> } | null, relatedProducts?: { __typename: 'ProductSummary', missing?: boolean | null, preProductAmount?: string | null, productAmount?: string | null, postProductAmount?: string | null } | null, recommendations?: Array<{ __typename: 'Recommendation', id: string, title: string, subtitle: string, warnings: Array<string>, ctas: Array<{ __typename: 'RecommendationCTA', text: string, url: string }>, explanation: Array<{ __typename: 'ComparisonBlock', packages: Array<{ __typename: 'ComparisonPackage', name: string, features: Array<string>, cost: { __typename: 'Money', float: number, string: string, display: string } }>, features: Array<{ __typename: 'ComparisonFeature', name?: string | null, description?: string | null }> } | { __typename: 'MarkdownBlock', title?: string | null, body?: string | null } | { __typename: 'UrlBlock', title?: string | null, links?: Array<{ __typename: 'Link', text: string, url: string } | null> | null }> }> | null }> | null } };

export type GetPlanAdviceInfoQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;


export type GetPlanAdviceInfoQuery = { __typename: 'Query', plan: { __typename: 'Plan', id: string, factfindErrors?: any | null, lastUpdated?: any | null, authorisationStatus?: AuthorisationStatus | null, advisorPhoto?: any | null, monthlyAllocationAmount?: { __typename: 'Money', display: string, string: string, float: number } | null, recommendationGroups?: Array<{ __typename: 'RecommendationGroup', id: string, title: string, subtitle: string, explanation?: string | null, recommendationType: RecommendationType, thingsToDo?: number | null, responsiveImage?: { __typename: 'ResposiveImage', src: string, srcset: string, sizes: string } | null, summary?: { __typename: 'DebtSummary', totalDebtAmount: { __typename: 'Money', display: string, string: string, float: number } } | { __typename: 'EmergencyFundSummary', emergencyFundProgress: { __typename: 'EmergencyFundProgress', monthsProtected: number, recommendedProtectedMonths: number } } | { __typename: 'HealthSummary', missing: boolean, covered: HealthCoverageStatus } | { __typename: 'ProtectionSummary', currentCover: ProtectionProvision, idealCover: ProtectionProvision, missing: boolean, missingPolicies?: string | null } | { __typename: 'RetirementSummary', recommendPRSA: boolean, prsaRecommendedFund: Array<{ __typename: 'PRSAFundRecommendation', fund: PrsaFund, percentage: number }>, currentProvision: { __typename: 'Money', display: string, string: string, float: number }, targetProvision: { __typename: 'Money', display: string, float: number, string: string } } | { __typename: 'SavingsInvestingSummary', savingsSummary: SavingsSummary, investingSummary: InvestingSummary, goalProgress: Array<{ __typename: 'GoalProgress', name: string, goalType: GoalType, progress?: any | null, amountSaved: { __typename: 'Money', display: string, string: string, float: number }, targetAmount: { __typename: 'Money', display: string, string: string, float: number } } | null> } | null }> | null } };

export type GetPlanRecommendationsQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;


export type GetPlanRecommendationsQuery = { __typename: 'Query', plan: { __typename: 'Plan', id: string, factfindErrors?: any | null, lastUpdated?: any | null, suitabilityReportLink?: string | null, authorisationStatus?: AuthorisationStatus | null, triageReason?: string | null, monthlyAllocationAmount?: { __typename: 'Money', display: string, string: string, float: number } | null, recommendationGroups?: Array<{ __typename: 'RecommendationGroup', id: string, title: string, subtitle: string, explanation?: string | null, factfindSummary: string, recommendationType: RecommendationType, thingsToDo?: number | null, riskProfileQuestionnaireRequired: boolean, responsiveImage?: { __typename: 'ResposiveImage', src: string, srcset: string, sizes: string } | null, summary?: { __typename: 'DebtSummary', clearedBy: string, totalDebtAmount: { __typename: 'Money', display: string, string: string, float: number }, idealMonthlyRepayment: { __typename: 'Money', display: string, string: string, float: number } } | { __typename: 'EmergencyFundSummary', emergencyFundProgress: { __typename: 'EmergencyFundProgress', monthsProtected: number, recommendedProtectedMonths: number, progress: any, currentProvision: { __typename: 'Money', display: string, string: string, float: number }, recommendedProvision: { __typename: 'Money', display: string, string: string, float: number } } } | { __typename: 'HealthSummary', missing: boolean, covered: HealthCoverageStatus } | { __typename: 'ProtectionSummary', currentCover: ProtectionProvision, idealCover: ProtectionProvision, missing: boolean, missingPolicies?: string | null, scenarios?: Array<{ __typename: 'ProtectionScenario', title: string, subtitle: string, covered: CoverForScenario, description: string, recommended: { __typename: 'Money', display: string, string: string, float: number }, recommendedForUser: { __typename: 'Money', display: string, string: string, float: number }, recommendedForPartner?: { __typename: 'Money', display: string, string: string, float: number } | null } | null> | null } | { __typename: 'RetirementSummary', recommendPRSA: boolean, prsaRecommendedFund: Array<{ __typename: 'PRSAFundRecommendation', fund: PrsaFund, percentage: number }>, currentProvision: { __typename: 'Money', display: string, string: string, float: number }, targetProvision: { __typename: 'Money', display: string, float: number, string: string }, realisticProvision: { __typename: 'Money', display: string, string: string, float: number }, breakdown: Array<{ __typename: 'BreakdownSlice', name: string, amount: { __typename: 'Money', display: string, float: number, string: string } }> } | { __typename: 'SavingsInvestingSummary', savingsSummary: SavingsSummary, investingSummary: InvestingSummary, breakdown: Array<{ __typename: 'BreakdownSlice', name: string, amount: { __typename: 'Money', display: string, string: string, float: number } }>, emergencyFundProgress: { __typename: 'EmergencyFundProgress', monthsProtected: number, recommendedProtectedMonths: number, progress: any, currentProvision: { __typename: 'Money', display: string, string: string, float: number }, recommendedProvision: { __typename: 'Money', display: string, string: string, float: number } }, goalProgress: Array<{ __typename: 'GoalProgress', name: string, goalType: GoalType, progress?: any | null, amountSaved: { __typename: 'Money', display: string, string: string, float: number }, targetAmount: { __typename: 'Money', display: string, string: string, float: number } } | null> } | null, relatedProducts?: { __typename: 'ProductSummary', missing?: boolean | null, preProductAmount?: string | null, productAmount?: string | null, postProductAmount?: string | null } | null, recommendations?: Array<{ __typename: 'Recommendation', id: string, title: string, subtitle: string, warnings: Array<string>, ctas: Array<{ __typename: 'RecommendationCTA', text: string, url: string }>, explanation: Array<{ __typename: 'ComparisonBlock', packages: Array<{ __typename: 'ComparisonPackage', name: string, features: Array<string>, cost: { __typename: 'Money', float: number, string: string, display: string } }>, features: Array<{ __typename: 'ComparisonFeature', name?: string | null, description?: string | null }> } | { __typename: 'MarkdownBlock', title?: string | null, body?: string | null } | { __typename: 'UrlBlock', title?: string | null, links?: Array<{ __typename: 'Link', text: string, url: string } | null> | null }> }> | null }> | null } };

export type GetPlanSuitabilityReportLinkQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;


export type GetPlanSuitabilityReportLinkQuery = { __typename: 'Query', plan: { __typename: 'Plan', id: string, suitabilityReportLink?: string | null } };

export const FactfindFragmentFragmentDoc = gql`
    fragment FactfindFragment on Factfind {
  staleFields {
    key
    lastUpdated
  }
  vulnerable
  id
  staleFields {
    key
    lastUpdated
  }
  monthlyRent
  monthlyUtilities
  monthlyOutgoingEssentials
  monthlyOutgoingNonEssentials
  extraMonthlyOutgoingEssentials
  planningFor
  hasChildren
  numberOfChildren
  ageOfChildren
  otherDependants
  numberOfOtherDependants
  relationshipToOtherDependants
  maritalStatus
  hasMortgage
  ownsHome
  userSpecificFactfind {
    staleFields {
      key
      lastUpdated
    }
    employmentStatus
    mainEmploymentType
    occupation
    baseAnnualIncomeGross
    hasBonus
    expectedBonusAmount
    monthlyIncomeNet
    marginalTaxRate
    hasOtherIncome
    hasPension
    expectedOtherIncomeAmount
    eligibleForStatePension
    retirementAgeEstimate
    monthlyRetirementOutgoingExpected
    hasGoodHealth
    smokingStatus
    monthsOfFinancialSafety
    memberOfEmployersPensionScheme
    employerOffersPensionScheme
    PPSNumber
    birthCountry
    domicileCountry
    residentCountry
    industry
    pep
    nationality
    employer
    employerAddressLine1
    employerAddressLine2
    employerAddressLine3
    hasPension
    benefitInKind {
      float
      display
      string
    }
    directorOrOwnerOfLimitedCompany
    pensionSchemeIsIrishLife
  }
  partnerSpecificFactfind {
    staleFields {
      key
      lastUpdated
    }
    firstName
    lastName
    dateOfBirth
    employmentStatus
    mainEmploymentType
    occupation
    baseAnnualIncomeGross
    hasBonus
    expectedBonusAmount
    monthlyIncomeNet
    marginalTaxRate
    hasOtherIncome
    expectedOtherIncomeAmount
    eligibleForStatePension
    retirementAgeEstimate
    monthlyRetirementOutgoingExpected
    hasGoodHealth
    smokingStatus
    monthsOfFinancialSafety
    memberOfEmployersPensionScheme
    employerOffersPensionScheme
    directorOrOwnerOfLimitedCompany
    pensionSchemeIsIrishLife
  }
}
    `;
export const FieldContextFragmentFragmentDoc = gql`
    fragment FieldContextFragment on FactfindContextFields {
  id
  questionGroups {
    id
    title
    subtitle
    preTitle
    helperText
    questions {
      key
      placeholder
      label
      helperText
      input {
        type
        options {
          label
          value
        }
        min
        max
        disabled
      }
    }
    contexts
  }
}
    `;
export const GoalFragmentFragmentDoc = gql`
    fragment GoalFragment on Goal {
  id
  userId
  priority
  owners {
    id
    firstName
  }
  name
  targetDate
  valueToSave {
    float
    string
    display
  }
  goalType
  goalData
}
    `;
export const PersonFragmentFragmentDoc = gql`
    fragment PersonFragment on Person {
  id
  title
  firstName
  legalFirstName
  legalLastName
  lastName
  dateOfBirth
  relationship
  joinDate
  phoneNumber
  sex
  address {
    id
    postalCode
    flatNumber
    buildingNumber
    buildingName
    street
    subStreet
    town
    county
    country
  }
}
    `;
export const BookAppointmentDocument = gql`
    mutation BookAppointment($input: BookAppointmentInput!) {
  bookAppointment(input: $input) {
    success
    error {
      message
      fieldErrors
    }
    appointment {
      id
      startTime
      endTime
      advisorId
      advisorName
      advisorEmail
      advisorPhone
    }
  }
}
    `;

export function useBookAppointmentMutation() {
  return Urql.useMutation<BookAppointmentMutation, BookAppointmentMutationVariables>(BookAppointmentDocument);
};
export const ChangeEmailVerificationDocument = gql`
    mutation ChangeEmailVerification($input: ChangeEmailVerificationInput!) {
  changeEmailVerification(input: $input) {
    success
    email
    error {
      code
      message
      fieldErrors
    }
  }
}
    `;

export function useChangeEmailVerificationMutation() {
  return Urql.useMutation<ChangeEmailVerificationMutation, ChangeEmailVerificationMutationVariables>(ChangeEmailVerificationDocument);
};
export const CreateSurveyDocument = gql`
    mutation CreateSurvey($input: NewSurveyInput!) {
  createNewSurvey(input: $input) {
    success
    error {
      message
      fieldErrors
    }
    survey {
      id
      userId
      score
      feedback
      completed
    }
  }
}
    `;

export function useCreateSurveyMutation() {
  return Urql.useMutation<CreateSurveyMutation, CreateSurveyMutationVariables>(CreateSurveyDocument);
};
export const DeclineSurveyDocument = gql`
    mutation DeclineSurvey($input: DeclineSurveyInput!) {
  declineSurvey(input: $input) {
    success
    error {
      message
      fieldErrors
    }
    survey {
      id
      userId
      score
      feedback
      completed
    }
  }
}
    `;

export function useDeclineSurveyMutation() {
  return Urql.useMutation<DeclineSurveyMutation, DeclineSurveyMutationVariables>(DeclineSurveyDocument);
};
export const DeleteAssetDocument = gql`
    mutation DeleteAsset($input: DeleteAssetInput!) {
  deleteAsset(input: $input) {
    success
    error {
      message
    }
  }
}
    `;

export function useDeleteAssetMutation() {
  return Urql.useMutation<DeleteAssetMutation, DeleteAssetMutationVariables>(DeleteAssetDocument);
};
export const DeleteDebtDocument = gql`
    mutation DeleteDebt($input: DeleteDebtInput!) {
  deleteDebt(input: $input) {
    success
    error {
      message
    }
  }
}
    `;

export function useDeleteDebtMutation() {
  return Urql.useMutation<DeleteDebtMutation, DeleteDebtMutationVariables>(DeleteDebtDocument);
};
export const DeleteGoalDocument = gql`
    mutation DeleteGoal($input: DeleteGoalInput!) {
  deleteGoal(input: $input) {
    success
    error {
      code
      message
      fieldErrors
    }
  }
}
    `;

export function useDeleteGoalMutation() {
  return Urql.useMutation<DeleteGoalMutation, DeleteGoalMutationVariables>(DeleteGoalDocument);
};
export const DeletePolicyDocument = gql`
    mutation DeletePolicy($input: DeletePolicyInput!) {
  deletePolicy(input: $input) {
    success
    error {
      message
    }
  }
}
    `;

export function useDeletePolicyMutation() {
  return Urql.useMutation<DeletePolicyMutation, DeletePolicyMutationVariables>(DeletePolicyDocument);
};
export const DeleteVulnerabilityReminderDocument = gql`
    mutation DeleteVulnerabilityReminder($input: DeleteVulnerabilityReminderInput!) {
  deleteVulnerabilityReminder(input: $input) {
    success
    error {
      message
      fieldErrors
    }
  }
}
    `;

export function useDeleteVulnerabilityReminderMutation() {
  return Urql.useMutation<DeleteVulnerabilityReminderMutation, DeleteVulnerabilityReminderMutationVariables>(DeleteVulnerabilityReminderDocument);
};
export const GetAssetDocument = gql`
    query GetAsset($userId: ID!, $assetId: UUID!) {
  asset(userId: $userId, assetId: $assetId) {
    id
    productType
    userId
    isComplete
    owners {
      id
      relationship
    }
    name
    provider {
      id
      name
      iconUrl
    }
    accessible
    balance {
      float
      display
      string
    }
    overdrawnBy {
      float
      display
      string
    }
    maturityDate
    increasing
    regularPaymentAmount {
      float
      display
      string
    }
    startDate
    valuationMethod
    whereFrom
    propertyType
    pensionType
    frequency
    active
    throughCurrentEmployer
    isIrishLifePension
  }
}
    `;

export function useGetAssetQuery(options: Omit<Urql.UseQueryArgs<GetAssetQueryVariables>, 'query'>) {
  return Urql.useQuery<GetAssetQuery, GetAssetQueryVariables>({ query: GetAssetDocument, ...options });
};
export const GetAssetsDocument = gql`
    query GetAssets($userId: ID!) {
  assets(userId: $userId) {
    id
    productType
    userId
    isComplete
    owners {
      id
      relationship
    }
    name
    provider {
      id
      name
      iconUrl
    }
    accessible
    balance {
      float
      display
      string
    }
    overdrawnBy {
      float
      display
      string
    }
    maturityDate
    active
    throughCurrentEmployer
    pensionType
    regularPaymentAmount {
      float
      display
      string
    }
  }
}
    `;

export function useGetAssetsQuery(options: Omit<Urql.UseQueryArgs<GetAssetsQueryVariables>, 'query'>) {
  return Urql.useQuery<GetAssetsQuery, GetAssetsQueryVariables>({ query: GetAssetsDocument, ...options });
};
export const GetAvailableAppointmentDaysDocument = gql`
    query GetAvailableAppointmentDays($userId: ID, $startDate: Date!, $endDate: Date!) {
  availableAppointmentDays(
    userId: $userId
    startDate: $startDate
    endDate: $endDate
  ) {
    id
    date
  }
}
    `;

export function useGetAvailableAppointmentDaysQuery(options: Omit<Urql.UseQueryArgs<GetAvailableAppointmentDaysQueryVariables>, 'query'>) {
  return Urql.useQuery<GetAvailableAppointmentDaysQuery, GetAvailableAppointmentDaysQueryVariables>({ query: GetAvailableAppointmentDaysDocument, ...options });
};
export const GetAvailableAppointmentsDocument = gql`
    query GetAvailableAppointments($userId: ID, $date: Date!) {
  availableAppointments(userId: $userId, date: $date) {
    id
    startTime
    endTime
  }
}
    `;

export function useGetAvailableAppointmentsQuery(options: Omit<Urql.UseQueryArgs<GetAvailableAppointmentsQueryVariables>, 'query'>) {
  return Urql.useQuery<GetAvailableAppointmentsQuery, GetAvailableAppointmentsQueryVariables>({ query: GetAvailableAppointmentsDocument, ...options });
};
export const GetBasicInfoFactFindDocument = gql`
    query GetBasicInfoFactFind($userId: ID!) {
  factfind(userId: $userId) {
    staleFields {
      key
      lastUpdated
    }
    id
    vulnerable
    staleFields {
      key
      lastUpdated
    }
    planningFor
    maritalStatus
    hasChildren
    numberOfChildren
    ageOfChildren
    numberOfOtherDependants
    relationshipToOtherDependants
    ownsHome
    hasMortgage
    partnerSpecificFactfind {
      staleFields {
        key
        lastUpdated
      }
      firstName
      lastName
      dateOfBirth
    }
  }
}
    `;

export function useGetBasicInfoFactFindQuery(options: Omit<Urql.UseQueryArgs<GetBasicInfoFactFindQueryVariables>, 'query'>) {
  return Urql.useQuery<GetBasicInfoFactFindQuery, GetBasicInfoFactFindQueryVariables>({ query: GetBasicInfoFactFindDocument, ...options });
};
export const CheckInDocument = gql`
    query CheckIn($userId: ID!) {
  checkIn(userId: $userId) {
    checkIns {
      checkInType
      lastChecked
      stale
    }
  }
}
    `;

export function useCheckInQuery(options: Omit<Urql.UseQueryArgs<CheckInQueryVariables>, 'query'>) {
  return Urql.useQuery<CheckInQuery, CheckInQueryVariables>({ query: CheckInDocument, ...options });
};
export const GetConsentDocument = gql`
    query GetConsent($userId: ID!) {
  consent(userId: $userId) {
    id
    contactServicesIrishLifeGroup
    userResearch
    checkInEmails
  }
}
    `;

export function useGetConsentQuery(options: Omit<Urql.UseQueryArgs<GetConsentQueryVariables>, 'query'>) {
  return Urql.useQuery<GetConsentQuery, GetConsentQueryVariables>({ query: GetConsentDocument, ...options });
};
export const GetCountriesDocument = gql`
    query GetCountries {
  countries
}
    `;

export function useGetCountriesQuery(options?: Omit<Urql.UseQueryArgs<GetCountriesQueryVariables>, 'query'>) {
  return Urql.useQuery<GetCountriesQuery, GetCountriesQueryVariables>({ query: GetCountriesDocument, ...options });
};
export const GetDebtDocument = gql`
    query GetDebt($userId: ID!, $debtId: UUID!) {
  debt(userId: $userId, debtId: $debtId) {
    id
    productType
    userId
    isComplete
    owners {
      id
      firstName
      lastName
    }
    name
    provider {
      id
      name
      iconUrl
    }
    balance {
      float
      display
      string
    }
    monthlyRepayment {
      float
      display
      string
    }
    clearedOnDeath
    maturityDate
    endDate
    mortgageType
    mortgageYearsLeft
    isMainMortgage
    repaidMonthly
    arePaymentsUpToDate
    hasPaymentProtectionInsurance
    arrears {
      float
      string
      display
    }
  }
}
    `;

export function useGetDebtQuery(options: Omit<Urql.UseQueryArgs<GetDebtQueryVariables>, 'query'>) {
  return Urql.useQuery<GetDebtQuery, GetDebtQueryVariables>({ query: GetDebtDocument, ...options });
};
export const GetDebtsDocument = gql`
    query GetDebts($userId: ID!) {
  debts(userId: $userId) {
    id
    productType
    userId
    isComplete
    owners {
      id
      firstName
      lastName
    }
    name
    provider {
      id
      name
      iconUrl
    }
    balance {
      float
      string
      display
    }
    monthlyRepayment {
      float
      string
      display
    }
    clearedOnDeath
    maturityDate
    endDate
    mortgageType
    mortgageYearsLeft
    isMainMortgage
    repaidMonthly
    arePaymentsUpToDate
    hasPaymentProtectionInsurance
    arrears {
      float
      string
      display
    }
  }
}
    `;

export function useGetDebtsQuery(options: Omit<Urql.UseQueryArgs<GetDebtsQueryVariables>, 'query'>) {
  return Urql.useQuery<GetDebtsQuery, GetDebtsQueryVariables>({ query: GetDebtsDocument, ...options });
};
export const GetFactFindDocument = gql`
    query GetFactFind($userId: ID!) {
  factfind(userId: $userId) {
    ...FactfindFragment
  }
}
    ${FactfindFragmentFragmentDoc}`;

export function useGetFactFindQuery(options: Omit<Urql.UseQueryArgs<GetFactFindQueryVariables>, 'query'>) {
  return Urql.useQuery<GetFactFindQuery, GetFactFindQueryVariables>({ query: GetFactFindDocument, ...options });
};
export const GetFieldsDocument = gql`
    query GetFields($userId: ID!, $context: String!) {
  factfindFields(userId: $userId, context: $context) {
    ...FieldContextFragment
  }
}
    ${FieldContextFragmentFragmentDoc}`;

export function useGetFieldsQuery(options: Omit<Urql.UseQueryArgs<GetFieldsQueryVariables>, 'query'>) {
  return Urql.useQuery<GetFieldsQuery, GetFieldsQueryVariables>({ query: GetFieldsDocument, ...options });
};
export const GetFinancialsFactFindDocument = gql`
    query GetFinancialsFactFind($userId: ID!) {
  factfind(userId: $userId) {
    staleFields {
      key
      lastUpdated
    }
    vulnerable
    id
    staleFields {
      key
      lastUpdated
    }
    monthlyRent
    monthlyUtilities
    monthlyOutgoingEssentials
    monthlyOutgoingNonEssentials
    extraMonthlyOutgoingEssentials
    userSpecificFactfind {
      staleFields {
        key
        lastUpdated
      }
      employmentStatus
      mainEmploymentType
      occupation
      baseAnnualIncomeGross
      hasBonus
      expectedBonusAmount
      monthlyIncomeNet
      marginalTaxRate
      hasOtherIncome
      expectedOtherIncomeAmount
      eligibleForStatePension
      retirementAgeEstimate
      monthlyRetirementOutgoingExpected
      hasGoodHealth
      smokingStatus
      monthsOfFinancialSafety
    }
    partnerSpecificFactfind {
      staleFields {
        key
        lastUpdated
      }
      employmentStatus
      mainEmploymentType
      occupation
      baseAnnualIncomeGross
      hasBonus
      expectedBonusAmount
      monthlyIncomeNet
      marginalTaxRate
      hasOtherIncome
      expectedOtherIncomeAmount
      eligibleForStatePension
      retirementAgeEstimate
      monthlyRetirementOutgoingExpected
      hasGoodHealth
      smokingStatus
      monthsOfFinancialSafety
    }
  }
}
    `;

export function useGetFinancialsFactFindQuery(options: Omit<Urql.UseQueryArgs<GetFinancialsFactFindQueryVariables>, 'query'>) {
  return Urql.useQuery<GetFinancialsFactFindQuery, GetFinancialsFactFindQueryVariables>({ query: GetFinancialsFactFindDocument, ...options });
};
export const GetGoalDocument = gql`
    query GetGoal($userId: ID!, $goalId: UUID!) {
  goal(userId: $userId, goalId: $goalId) {
    ...GoalFragment
  }
}
    ${GoalFragmentFragmentDoc}`;

export function useGetGoalQuery(options: Omit<Urql.UseQueryArgs<GetGoalQueryVariables>, 'query'>) {
  return Urql.useQuery<GetGoalQuery, GetGoalQueryVariables>({ query: GetGoalDocument, ...options });
};
export const GetGoalsDocument = gql`
    query GetGoals($userId: ID!) {
  goals(userId: $userId) {
    ...GoalFragment
  }
}
    ${GoalFragmentFragmentDoc}`;

export function useGetGoalsQuery(options: Omit<Urql.UseQueryArgs<GetGoalsQueryVariables>, 'query'>) {
  return Urql.useQuery<GetGoalsQuery, GetGoalsQueryVariables>({ query: GetGoalsDocument, ...options });
};
export const GetInteractionFlagDocument = gql`
    query GetInteractionFlag($userId: ID!, $flagKey: ID!) {
  interactionFlag(userId: $userId, flagKey: $flagKey) {
    id
    value
  }
}
    `;

export function useGetInteractionFlagQuery(options: Omit<Urql.UseQueryArgs<GetInteractionFlagQueryVariables>, 'query'>) {
  return Urql.useQuery<GetInteractionFlagQuery, GetInteractionFlagQueryVariables>({ query: GetInteractionFlagDocument, ...options });
};
export const GetMessagesDocument = gql`
    query GetMessages($userId: ID!) {
  messages(userId: $userId) {
    id
    title
    subtitle
    link
    read
    dateReceived
  }
}
    `;

export function useGetMessagesQuery(options: Omit<Urql.UseQueryArgs<GetMessagesQueryVariables>, 'query'>) {
  return Urql.useQuery<GetMessagesQuery, GetMessagesQueryVariables>({ query: GetMessagesDocument, ...options });
};
export const GetNationalitiesDocument = gql`
    query GetNationalities {
  nationalities
}
    `;

export function useGetNationalitiesQuery(options?: Omit<Urql.UseQueryArgs<GetNationalitiesQueryVariables>, 'query'>) {
  return Urql.useQuery<GetNationalitiesQuery, GetNationalitiesQueryVariables>({ query: GetNationalitiesDocument, ...options });
};
export const GetNextAvailableAppointmentDocument = gql`
    query GetNextAvailableAppointment($userId: ID!) {
  nextAvailableAppointment(userId: $userId) {
    endTime
    startTime
    id
  }
}
    `;

export function useGetNextAvailableAppointmentQuery(options: Omit<Urql.UseQueryArgs<GetNextAvailableAppointmentQueryVariables>, 'query'>) {
  return Urql.useQuery<GetNextAvailableAppointmentQuery, GetNextAvailableAppointmentQueryVariables>({ query: GetNextAvailableAppointmentDocument, ...options });
};
export const GetOccupationsDocument = gql`
    query GetOccupations {
  occupations
}
    `;

export function useGetOccupationsQuery(options?: Omit<Urql.UseQueryArgs<GetOccupationsQueryVariables>, 'query'>) {
  return Urql.useQuery<GetOccupationsQuery, GetOccupationsQueryVariables>({ query: GetOccupationsDocument, ...options });
};
export const GetPensionCalculationDocument = gql`
    query GetPensionCalculation($input: PensionCalculatorInput!) {
  calculatePension(input: $input) {
    pensionProjection {
      age
      date
      employmentIncome {
        float
        display
      }
      personalPensionAmount {
        float
        display
      }
      statePensionAmount {
        float
        display
      }
      targetIncome {
        float
        display
      }
      totalPensionAmount {
        float
        display
      }
    }
  }
}
    `;

export function useGetPensionCalculationQuery(options: Omit<Urql.UseQueryArgs<GetPensionCalculationQueryVariables>, 'query'>) {
  return Urql.useQuery<GetPensionCalculationQuery, GetPensionCalculationQueryVariables>({ query: GetPensionCalculationDocument, ...options });
};
export const GetPersonDocument = gql`
    query GetPerson($userId: ID!, $personId: ID) {
  person(userId: $userId, personId: $personId) {
    ...PersonFragment
  }
}
    ${PersonFragmentFragmentDoc}`;

export function useGetPersonQuery(options: Omit<Urql.UseQueryArgs<GetPersonQueryVariables>, 'query'>) {
  return Urql.useQuery<GetPersonQuery, GetPersonQueryVariables>({ query: GetPersonDocument, ...options });
};
export const GetPersonsDocument = gql`
    query GetPersons($userId: ID!) {
  persons(userId: $userId) {
    ...PersonFragment
  }
}
    ${PersonFragmentFragmentDoc}`;

export function useGetPersonsQuery(options: Omit<Urql.UseQueryArgs<GetPersonsQueryVariables>, 'query'>) {
  return Urql.useQuery<GetPersonsQuery, GetPersonsQueryVariables>({ query: GetPersonsDocument, ...options });
};
export const GetPlanGraphDocument = gql`
    query GetPlanGraph($userId: ID!, $startDate: Date, $endDate: Date) {
  planGraph(userId: $userId, startDate: $startDate, endDate: $endDate) {
    currentWealth {
      float
      display
    }
    finalWealth {
      float
      display
    }
    wealthProjection {
      date
      amount {
        float
        display
      }
      goals {
        ...GoalFragment
      }
    }
  }
}
    ${GoalFragmentFragmentDoc}`;

export function useGetPlanGraphQuery(options: Omit<Urql.UseQueryArgs<GetPlanGraphQueryVariables>, 'query'>) {
  return Urql.useQuery<GetPlanGraphQuery, GetPlanGraphQueryVariables>({ query: GetPlanGraphDocument, ...options });
};
export const GetPoliciesDocument = gql`
    query GetPolicies($userId: ID!) {
  policies(userId: $userId) {
    id
    productType
    userId
    isComplete
    renewalDate
    owners {
      id
      relationship
    }
    name
    provider {
      id
      name
      iconUrl
    }
    isOnePlan
    coverType
    amountOfCover {
      float
      display
      string
    }
    yearsRemaining
    premium {
      float
      display
      string
    }
    paymentFrequency
    renewalDate
    isIrishLifePolicy
    throughCurrentEmployer
  }
}
    `;

export function useGetPoliciesQuery(options: Omit<Urql.UseQueryArgs<GetPoliciesQueryVariables>, 'query'>) {
  return Urql.useQuery<GetPoliciesQuery, GetPoliciesQueryVariables>({ query: GetPoliciesDocument, ...options });
};
export const GetPolicyDocument = gql`
    query GetPolicy($userId: ID!, $policyId: UUID!) {
  policy(userId: $userId, policyId: $policyId) {
    id
    productType
    userId
    isComplete
    renewalDate
    owners {
      id
      relationship
    }
    name
    provider {
      id
      name
      iconUrl
    }
    isOnePlan
    coverType
    amountOfCover {
      float
      display
      string
    }
    yearsRemaining
    premium {
      float
      display
      string
    }
    paymentFrequency
    renewalDate
    isIrishLifePolicy
    throughCurrentEmployer
  }
}
    `;

export function useGetPolicyQuery(options: Omit<Urql.UseQueryArgs<GetPolicyQueryVariables>, 'query'>) {
  return Urql.useQuery<GetPolicyQuery, GetPolicyQueryVariables>({ query: GetPolicyDocument, ...options });
};
export const GetProvidersDocument = gql`
    query GetProviders {
  providers {
    id
    name
    imageUrl
    iconUrl
    bannerColor
    address {
      postalCode
    }
  }
}
    `;

export function useGetProvidersQuery(options?: Omit<Urql.UseQueryArgs<GetProvidersQueryVariables>, 'query'>) {
  return Urql.useQuery<GetProvidersQuery, GetProvidersQueryVariables>({ query: GetProvidersDocument, ...options });
};
export const GetPrsaPensionApplicationDocument = gql`
    query GetPrsaPensionApplication($userId: ID!) {
  prsaPensionApplication(userId: $userId) {
    id
    pensionContributionStartDate
    pensionSelfContribution {
      float
      display
      string
    }
    pensionDayOfDirectDebits
    pensionInflationProtection
    singleEmployeeContribution {
      float
      display
      string
    }
    oneOffContribution
    submittedPrsaApplication
    submittedPrsaApplicationDate
  }
}
    `;

export function useGetPrsaPensionApplicationQuery(options: Omit<Urql.UseQueryArgs<GetPrsaPensionApplicationQueryVariables>, 'query'>) {
  return Urql.useQuery<GetPrsaPensionApplicationQuery, GetPrsaPensionApplicationQueryVariables>({ query: GetPrsaPensionApplicationDocument, ...options });
};
export const GetRetirementAgeFactFindDocument = gql`
    query GetRetirementAgeFactFind($userId: ID!) {
  factfind(userId: $userId) {
    id
    userSpecificFactfind {
      retirementAgeEstimate
    }
    partnerSpecificFactfind {
      retirementAgeEstimate
    }
  }
}
    `;

export function useGetRetirementAgeFactFindQuery(options: Omit<Urql.UseQueryArgs<GetRetirementAgeFactFindQueryVariables>, 'query'>) {
  return Urql.useQuery<GetRetirementAgeFactFindQuery, GetRetirementAgeFactFindQueryVariables>({ query: GetRetirementAgeFactFindDocument, ...options });
};
export const GetRiskDocument = gql`
    query GetRisk($userId: ID!) {
  risk(userId: $userId) {
    id
    selectedProfile {
      id
      name
      description
    }
    calculatedProfile {
      id
      name
      description
    }
    questionnaire {
      id
      exploringInvestmentOpportunitiesQ1
      bestPossibleReturnQ2
      typicalAttitudeFinancialDecisionsQ3
      riskPastFinancialDecisionsQ4
      preferInvestmentSafeQ5
      investmentsRiskAnxiousQ6
      investmentGoesDownReactionQ7
      highGrowthAcceptLossesQ8
      possibleHighReturnsChanceQ9
      friendDescribeAttitudeRisksQ10
      largeGainsRiskLargeLossesQ11
      choiceTwoInvestmentProductsQ12
      preferSmallCertainGainsQ13
      describeThinkAboutPossibleLossesGainsQ14
      investmentSafeLowerReturnsQ15
    }
  }
}
    `;

export function useGetRiskQuery(options: Omit<Urql.UseQueryArgs<GetRiskQueryVariables>, 'query'>) {
  return Urql.useQuery<GetRiskQuery, GetRiskQueryVariables>({ query: GetRiskDocument, ...options });
};
export const GetRiskProfilesDocument = gql`
    query GetRiskProfiles($userId: ID!) {
  riskProfiles(userId: $userId) {
    id
    name
    description
  }
}
    `;

export function useGetRiskProfilesQuery(options: Omit<Urql.UseQueryArgs<GetRiskProfilesQueryVariables>, 'query'>) {
  return Urql.useQuery<GetRiskProfilesQuery, GetRiskProfilesQueryVariables>({ query: GetRiskProfilesDocument, ...options });
};
export const GetScheduledAppointmentsDocument = gql`
    query GetScheduledAppointments($userId: ID!) {
  scheduledAppointments(userId: $userId) {
    id
    startTime
    endTime
    advisorId
    advisorName
    advisorEmail
    advisorPhone
    reason
  }
}
    `;

export function useGetScheduledAppointmentsQuery(options: Omit<Urql.UseQueryArgs<GetScheduledAppointmentsQueryVariables>, 'query'>) {
  return Urql.useQuery<GetScheduledAppointmentsQuery, GetScheduledAppointmentsQueryVariables>({ query: GetScheduledAppointmentsDocument, ...options });
};
export const GetToolsDocument = gql`
    query GetTools($userId: ID!) {
  tools(userId: $userId)
}
    `;

export function useGetToolsQuery(options: Omit<Urql.UseQueryArgs<GetToolsQueryVariables>, 'query'>) {
  return Urql.useQuery<GetToolsQuery, GetToolsQueryVariables>({ query: GetToolsDocument, ...options });
};
export const GetUserDocument = gql`
    query GetUser($userId: ID!) {
  user(userId: $userId) {
    id
    email
    referralSource
    userType
    userJourney
  }
}
    `;

export function useGetUserQuery(options: Omit<Urql.UseQueryArgs<GetUserQueryVariables>, 'query'>) {
  return Urql.useQuery<GetUserQuery, GetUserQueryVariables>({ query: GetUserDocument, ...options });
};
export const GetVulnerabilityReminderDocument = gql`
    query GetVulnerabilityReminder($userId: ID!) {
  vulnerabilityReminder(userId: $userId)
}
    `;

export function useGetVulnerabilityReminderQuery(options: Omit<Urql.UseQueryArgs<GetVulnerabilityReminderQueryVariables>, 'query'>) {
  return Urql.useQuery<GetVulnerabilityReminderQuery, GetVulnerabilityReminderQueryVariables>({ query: GetVulnerabilityReminderDocument, ...options });
};
export const RequestPlanDocument = gql`
    mutation RequestPlan($input: RequestPlanInput!) {
  requestPlan(input: $input) {
    success
    error {
      message
      fieldErrors
    }
  }
}
    `;

export function useRequestPlanMutation() {
  return Urql.useMutation<RequestPlanMutation, RequestPlanMutationVariables>(RequestPlanDocument);
};
export const SetVulnerabilityReminderDocument = gql`
    mutation SetVulnerabilityReminder($input: SetVulnerabilityReminderInput!) {
  setVulnerabilityReminder(input: $input) {
    success
    error {
      message
      fieldErrors
    }
    reminderDate
  }
}
    `;

export function useSetVulnerabilityReminderMutation() {
  return Urql.useMutation<SetVulnerabilityReminderMutation, SetVulnerabilityReminderMutationVariables>(SetVulnerabilityReminderDocument);
};
export const ShowSurveyDocument = gql`
    query ShowSurvey($userId: ID!) {
  showSurvey(userId: $userId)
}
    `;

export function useShowSurveyQuery(options: Omit<Urql.UseQueryArgs<ShowSurveyQueryVariables>, 'query'>) {
  return Urql.useQuery<ShowSurveyQuery, ShowSurveyQueryVariables>({ query: ShowSurveyDocument, ...options });
};
export const SignUpDocument = gql`
    mutation SignUp($input: SignUpInput!) {
  signUp(input: $input) {
    success
    error {
      code
      message
    }
  }
}
    `;

export function useSignUpMutation() {
  return Urql.useMutation<SignUpMutation, SignUpMutationVariables>(SignUpDocument);
};
export const SubmitPensionApplicationDocument = gql`
    mutation SubmitPensionApplication($input: SubmitPrsaPensionApplicationInput!) {
  submitPensionApplication(input: $input) {
    validationErrors
    success
    error {
      message
      fieldErrors
    }
  }
}
    `;

export function useSubmitPensionApplicationMutation() {
  return Urql.useMutation<SubmitPensionApplicationMutation, SubmitPensionApplicationMutationVariables>(SubmitPensionApplicationDocument);
};
export const SubscribeToToolDocument = gql`
    mutation SubscribeToTool($input: NewToolInput!) {
  subscribeToTool(input: $input) {
    success
    error {
      message
      fieldErrors
    }
    tool
  }
}
    `;

export function useSubscribeToToolMutation() {
  return Urql.useMutation<SubscribeToToolMutation, SubscribeToToolMutationVariables>(SubscribeToToolDocument);
};
export const SuggestNewToolDocument = gql`
    mutation SuggestNewTool($input: NewToolInput!) {
  suggestNewTool(input: $input) {
    success
    error {
      message
      fieldErrors
    }
    tool
  }
}
    `;

export function useSuggestNewToolMutation() {
  return Urql.useMutation<SuggestNewToolMutation, SuggestNewToolMutationVariables>(SuggestNewToolDocument);
};
export const SyncUserDocument = gql`
    mutation SyncUser($input: SyncUserInput!) {
  syncUser(input: $input) {
    success
    error {
      code
      message
    }
  }
}
    `;

export function useSyncUserMutation() {
  return Urql.useMutation<SyncUserMutation, SyncUserMutationVariables>(SyncUserDocument);
};
export const UpdateAssetDocument = gql`
    mutation UpdateAsset($input: UpdateAssetInput!) {
  updateAsset(input: $input) {
    success
    error {
      message
      fieldErrors
    }
    asset {
      id
      productType
      userId
      isComplete
      owners {
        id
        relationship
      }
      name
      provider {
        id
        name
        iconUrl
      }
      accessible
      balance {
        float
        display
        string
      }
      overdrawnBy {
        float
        display
        string
      }
      maturityDate
      increasing
      regularPaymentAmount {
        float
        display
        string
      }
      startDate
      valuationMethod
      whereFrom
      propertyType
      pensionType
      frequency
      active
    }
  }
}
    `;

export function useUpdateAssetMutation() {
  return Urql.useMutation<UpdateAssetMutation, UpdateAssetMutationVariables>(UpdateAssetDocument);
};
export const UpdateAssetsDocument = gql`
    mutation UpdateAssets($input: UpdateAssetsInput!) {
  updateAssets(input: $input) {
    success
    error {
      message
      fieldErrors
    }
    assets {
      id
      productType
      userId
      isComplete
      owners {
        id
        relationship
      }
      name
      provider {
        id
        name
        iconUrl
      }
      accessible
      balance {
        float
        display
        string
      }
      overdrawnBy {
        float
        display
        string
      }
      maturityDate
      active
    }
  }
}
    `;

export function useUpdateAssetsMutation() {
  return Urql.useMutation<UpdateAssetsMutation, UpdateAssetsMutationVariables>(UpdateAssetsDocument);
};
export const UpdateBasicInfoFactFindDocument = gql`
    mutation UpdateBasicInfoFactFind($input: UpdateFactfindInput!) {
  updateFactfind(input: $input) {
    success
    error {
      code
      message
    }
    factfind {
      staleFields {
        key
        lastUpdated
      }
      vulnerable
      id
      staleFields {
        key
        lastUpdated
      }
      planningFor
      maritalStatus
      hasChildren
      numberOfChildren
      ageOfChildren
      numberOfOtherDependants
      relationshipToOtherDependants
      ownsHome
      hasMortgage
      partnerSpecificFactfind {
        staleFields {
          key
          lastUpdated
        }
        firstName
        lastName
      }
    }
    fields {
      ...FieldContextFragment
    }
  }
}
    ${FieldContextFragmentFragmentDoc}`;

export function useUpdateBasicInfoFactFindMutation() {
  return Urql.useMutation<UpdateBasicInfoFactFindMutation, UpdateBasicInfoFactFindMutationVariables>(UpdateBasicInfoFactFindDocument);
};
export const UpdateCheckInDocument = gql`
    mutation UpdateCheckIn($input: UpdateCheckInInput!) {
  updateCheckIn(input: $input) {
    checkIns {
      checkInType
      lastChecked
      stale
    }
  }
}
    `;

export function useUpdateCheckInMutation() {
  return Urql.useMutation<UpdateCheckInMutation, UpdateCheckInMutationVariables>(UpdateCheckInDocument);
};
export const UpdateConsentDocument = gql`
    mutation UpdateConsent($input: UpdateConsentInput!) {
  updateConsent(input: $input) {
    success
    error {
      message
      fieldErrors
    }
    consent {
      id
      contactServicesIrishLifeGroup
      userResearch
      checkInEmails
    }
  }
}
    `;

export function useUpdateConsentMutation() {
  return Urql.useMutation<UpdateConsentMutation, UpdateConsentMutationVariables>(UpdateConsentDocument);
};
export const UpdateDebtDocument = gql`
    mutation UpdateDebt($input: UpdateDebtInput!) {
  updateDebt(input: $input) {
    success
    error {
      message
      fieldErrors
    }
    debt {
      id
      productType
      userId
      isComplete
      owners {
        id
        firstName
        lastName
      }
      name
      provider {
        id
        name
        iconUrl
      }
      balance {
        float
        display
      }
      monthlyRepayment {
        float
        display
      }
      clearedOnDeath
      maturityDate
      endDate
      mortgageType
      mortgageYearsLeft
      isMainMortgage
      repaidMonthly
      arePaymentsUpToDate
      hasPaymentProtectionInsurance
    }
  }
}
    `;

export function useUpdateDebtMutation() {
  return Urql.useMutation<UpdateDebtMutation, UpdateDebtMutationVariables>(UpdateDebtDocument);
};
export const UpdateDebtsDocument = gql`
    mutation UpdateDebts($input: UpdateDebtsInput!) {
  updateDebts(input: $input) {
    success
    error {
      message
      fieldErrors
    }
    debts {
      id
      productType
      userId
      isComplete
      owners {
        id
        firstName
        lastName
      }
      name
      provider {
        id
        name
        iconUrl
      }
      balance {
        float
        display
      }
      monthlyRepayment {
        float
        display
      }
      clearedOnDeath
      maturityDate
      endDate
      mortgageType
      mortgageYearsLeft
      isMainMortgage
      repaidMonthly
      arePaymentsUpToDate
      hasPaymentProtectionInsurance
    }
  }
}
    `;

export function useUpdateDebtsMutation() {
  return Urql.useMutation<UpdateDebtsMutation, UpdateDebtsMutationVariables>(UpdateDebtsDocument);
};
export const UpdateEmailDocument = gql`
    mutation UpdateEmail($input: UpdateEmailInput!) {
  updateEmail(input: $input) {
    success
    error {
      code
      message
      fieldErrors
    }
  }
}
    `;

export function useUpdateEmailMutation() {
  return Urql.useMutation<UpdateEmailMutation, UpdateEmailMutationVariables>(UpdateEmailDocument);
};
export const UpdateFactFindDocument = gql`
    mutation UpdateFactFind($input: UpdateFactfindInput!) {
  updateFactfind(input: $input) {
    success
    error {
      code
      message
      fieldErrors
    }
    triage {
      userIsTriaged
      action
      reason
    }
    validationErrors
    factfind {
      ...FactfindFragment
    }
    fields {
      ...FieldContextFragment
    }
  }
}
    ${FactfindFragmentFragmentDoc}
${FieldContextFragmentFragmentDoc}`;

export function useUpdateFactFindMutation() {
  return Urql.useMutation<UpdateFactFindMutation, UpdateFactFindMutationVariables>(UpdateFactFindDocument);
};
export const UpdateFinancialsFactFindDocument = gql`
    mutation UpdateFinancialsFactFind($input: UpdateFactfindInput!) {
  updateFactfind(input: $input) {
    success
    error {
      code
      message
      fieldErrors
    }
    factfind {
      staleFields {
        key
        lastUpdated
      }
      vulnerable
      id
      staleFields {
        key
        lastUpdated
      }
      monthlyRent
      monthlyUtilities
      monthlyOutgoingEssentials
      monthlyOutgoingNonEssentials
      extraMonthlyOutgoingEssentials
      userSpecificFactfind {
        staleFields {
          key
          lastUpdated
        }
        employmentStatus
        mainEmploymentType
        occupation
        baseAnnualIncomeGross
        hasBonus
        expectedBonusAmount
        monthlyIncomeNet
        marginalTaxRate
        hasOtherIncome
        expectedOtherIncomeAmount
        eligibleForStatePension
        retirementAgeEstimate
        monthlyRetirementOutgoingExpected
        hasGoodHealth
        smokingStatus
        monthsOfFinancialSafety
      }
      partnerSpecificFactfind {
        staleFields {
          key
          lastUpdated
        }
        employmentStatus
        mainEmploymentType
        occupation
        baseAnnualIncomeGross
        hasBonus
        expectedBonusAmount
        monthlyIncomeNet
        marginalTaxRate
        hasOtherIncome
        expectedOtherIncomeAmount
        eligibleForStatePension
        retirementAgeEstimate
        monthlyRetirementOutgoingExpected
        hasGoodHealth
        smokingStatus
        monthsOfFinancialSafety
      }
    }
    fields {
      ...FieldContextFragment
    }
  }
}
    ${FieldContextFragmentFragmentDoc}`;

export function useUpdateFinancialsFactFindMutation() {
  return Urql.useMutation<UpdateFinancialsFactFindMutation, UpdateFinancialsFactFindMutationVariables>(UpdateFinancialsFactFindDocument);
};
export const UpdateGoalDocument = gql`
    mutation UpdateGoal($input: UpdateGoalInput!) {
  updateGoal(input: $input) {
    success
    error {
      code
      message
      fieldErrors
    }
    goal {
      id
      userId
      owners {
        id
        firstName
      }
      name
      targetDate
      goalType
      priority
      valueToSave {
        float
        string
        display
      }
    }
  }
}
    `;

export function useUpdateGoalMutation() {
  return Urql.useMutation<UpdateGoalMutation, UpdateGoalMutationVariables>(UpdateGoalDocument);
};
export const UpdateGoalsDocument = gql`
    mutation UpdateGoals($userId: ID!, $goals: [GoalsInput!]!) {
  updateGoals(input: {userId: $userId, goals: $goals}) {
    success
    error {
      code
      message
      fieldErrors
    }
    goals {
      id
      userId
      owners {
        id
        firstName
      }
      name
      targetDate
      goalType
      priority
      valueToSave {
        float
        string
        display
      }
    }
  }
}
    `;

export function useUpdateGoalsMutation() {
  return Urql.useMutation<UpdateGoalsMutation, UpdateGoalsMutationVariables>(UpdateGoalsDocument);
};
export const UpdateInteractionFlagDocument = gql`
    mutation UpdateInteractionFlag($input: UpdateInteractionFlagInput!) {
  updateInteractionFlag(input: $input) {
    success
    error {
      message
      fieldErrors
    }
    interactionFlag {
      id
      value
    }
  }
}
    `;

export function useUpdateInteractionFlagMutation() {
  return Urql.useMutation<UpdateInteractionFlagMutation, UpdateInteractionFlagMutationVariables>(UpdateInteractionFlagDocument);
};
export const UpdatePensionApplicationDocument = gql`
    mutation UpdatePensionApplication($input: UpdatePrsaPensionApplicationInput!) {
  updatePensionApplication(input: $input) {
    success
    error {
      code
      message
      fieldErrors
    }
    validationErrors
    prsaPensionApplication {
      id
      pensionContributionStartDate
      pensionSelfContribution {
        float
        display
        string
      }
      pensionSelfContribution {
        float
        display
        string
      }
      pensionDayOfDirectDebits
      pensionInflationProtection
      singleEmployeeContribution {
        float
        display
        string
      }
      oneOffContribution
      submittedPrsaApplication
      submittedPrsaApplicationDate
    }
    fields {
      ...FieldContextFragment
    }
  }
}
    ${FieldContextFragmentFragmentDoc}`;

export function useUpdatePensionApplicationMutation() {
  return Urql.useMutation<UpdatePensionApplicationMutation, UpdatePensionApplicationMutationVariables>(UpdatePensionApplicationDocument);
};
export const UpdatePersonDocument = gql`
    mutation UpdatePerson($input: UpdatePersonInput!) {
  updatePerson(input: $input) {
    success
    error {
      code
      message
      fieldErrors
    }
    person {
      id
      address {
        id
        postalCode
        flatNumber
        buildingNumber
        buildingName
        street
        town
        county
        country
      }
      sex
      firstName
      lastName
      dateOfBirth
      phoneNumber
    }
  }
}
    `;

export function useUpdatePersonMutation() {
  return Urql.useMutation<UpdatePersonMutation, UpdatePersonMutationVariables>(UpdatePersonDocument);
};
export const UpdatePoliciesDocument = gql`
    mutation UpdatePolicies($input: UpdatePoliciesInput!) {
  updatePolicies(input: $input) {
    success
    error {
      message
      fieldErrors
    }
    policies {
      id
      productType
      userId
      isComplete
      renewalDate
      owners {
        id
        relationship
      }
      name
      provider {
        id
        name
        iconUrl
      }
      coverType
      amountOfCover {
        float
        display
      }
      yearsRemaining
      premium {
        float
        display
      }
      paymentFrequency
      isIrishLifePolicy
      throughCurrentEmployer
    }
  }
}
    `;

export function useUpdatePoliciesMutation() {
  return Urql.useMutation<UpdatePoliciesMutation, UpdatePoliciesMutationVariables>(UpdatePoliciesDocument);
};
export const UpdatePolicyDocument = gql`
    mutation UpdatePolicy($input: UpdatePolicyInput!) {
  updatePolicy(input: $input) {
    success
    error {
      message
      fieldErrors
    }
    policy {
      id
      productType
      userId
      isComplete
      renewalDate
      owners {
        id
        relationship
      }
      name
      provider {
        id
        name
        iconUrl
      }
      isOnePlan
      coverType
      amountOfCover {
        float
        display
        string
      }
      yearsRemaining
      premium {
        float
        display
        string
      }
      paymentFrequency
      renewalDate
      isIrishLifePolicy
      throughCurrentEmployer
    }
  }
}
    `;

export function useUpdatePolicyMutation() {
  return Urql.useMutation<UpdatePolicyMutation, UpdatePolicyMutationVariables>(UpdatePolicyDocument);
};
export const UpdateRiskDocument = gql`
    mutation UpdateRisk($input: UpdateRiskInput!) {
  updateRisk(input: $input) {
    success
    error {
      message
      fieldErrors
    }
    validationErrors
    risk {
      id
      selectedProfile {
        id
        name
        description
      }
      calculatedProfile {
        id
        name
        description
      }
      questionnaire {
        id
        exploringInvestmentOpportunitiesQ1
        bestPossibleReturnQ2
        typicalAttitudeFinancialDecisionsQ3
        riskPastFinancialDecisionsQ4
        preferInvestmentSafeQ5
        investmentsRiskAnxiousQ6
        investmentGoesDownReactionQ7
        highGrowthAcceptLossesQ8
        possibleHighReturnsChanceQ9
        friendDescribeAttitudeRisksQ10
        largeGainsRiskLargeLossesQ11
        choiceTwoInvestmentProductsQ12
        preferSmallCertainGainsQ13
        describeThinkAboutPossibleLossesGainsQ14
        investmentSafeLowerReturnsQ15
      }
    }
  }
}
    `;

export function useUpdateRiskMutation() {
  return Urql.useMutation<UpdateRiskMutation, UpdateRiskMutationVariables>(UpdateRiskDocument);
};
export const CalculateCollegeCostsDocument = gql`
    mutation CalculateCollegeCosts($input: CollegeCalculatorInput!) {
  updateCollegeCosts(input: $input) {
    __typename
    accommodationCost {
      float
      string
      display
    }
    accommodationType
    ageOfChild
    annualCost {
      float
      string
      display
    }
    courseDuration
    eligibleForFreeTuitionFees
    fees {
      float
      string
      display
    }
    goalId
    id
    monthlySavingsRequired {
      float
      string
      display
    }
    otherExpenses {
      float
      string
      display
    }
    targetDate
    total {
      float
      string
      display
    }
    totalAdjustedForInflation {
      float
      string
      display
    }
    userId
    whatToInclude
  }
}
    `;

export function useCalculateCollegeCostsMutation() {
  return Urql.useMutation<CalculateCollegeCostsMutation, CalculateCollegeCostsMutationVariables>(CalculateCollegeCostsDocument);
};
export const GetAllCollegeCostsDocument = gql`
    query GetAllCollegeCosts($userId: ID!) {
  collegeCosts(userId: $userId) {
    __typename
    accommodationCost {
      float
      string
      display
    }
    accommodationType
    ageOfChild
    annualCost {
      float
      string
      display
    }
    courseDuration
    eligibleForFreeTuitionFees
    fees {
      float
      string
      display
    }
    goalId
    id
    monthlySavingsRequired {
      float
      string
      display
    }
    otherExpenses {
      float
      string
      display
    }
    targetDate
    total {
      float
      string
      display
    }
    totalAdjustedForInflation {
      float
      string
      display
    }
    userId
    whatToInclude
  }
}
    `;

export function useGetAllCollegeCostsQuery(options: Omit<Urql.UseQueryArgs<GetAllCollegeCostsQueryVariables>, 'query'>) {
  return Urql.useQuery<GetAllCollegeCostsQuery, GetAllCollegeCostsQueryVariables>({ query: GetAllCollegeCostsDocument, ...options });
};
export const GetCollegeCostDocument = gql`
    query GetCollegeCost($userId: ID!, $collegeCostId: ID, $collegeCostUuid: UUID) {
  collegeCost(
    userId: $userId
    collegeCostId: $collegeCostId
    collegeCostUuid: $collegeCostUuid
  ) {
    __typename
    accommodationCost {
      float
      string
      display
    }
    accommodationType
    ageOfChild
    annualCost {
      float
      string
      display
    }
    courseDuration
    eligibleForFreeTuitionFees
    fees {
      float
      string
      display
    }
    goalId
    id
    monthlySavingsRequired {
      float
      string
      display
    }
    otherExpenses {
      float
      string
      display
    }
    targetDate
    total {
      float
      string
      display
    }
    totalAdjustedForInflation {
      float
      string
      display
    }
    userId
    whatToInclude
  }
}
    `;

export function useGetCollegeCostQuery(options: Omit<Urql.UseQueryArgs<GetCollegeCostQueryVariables>, 'query'>) {
  return Urql.useQuery<GetCollegeCostQuery, GetCollegeCostQueryVariables>({ query: GetCollegeCostDocument, ...options });
};
export const GetPlanDocument = gql`
    query GetPlan($userId: ID!) {
  plan(userId: $userId) {
    id
    factfindErrors
    lastUpdated
    suitabilityReportLink
    monthlyAllocationAmount {
      display
      string
      float
    }
    recommendationGroups {
      id
      title
      subtitle
      summary {
        ... on ProtectionSummary {
          scenarios {
            title
            subtitle
            covered
            recommended {
              display
              string
              float
            }
            recommendedForUser {
              display
              string
              float
            }
            recommendedForPartner {
              display
              string
              float
            }
            description
          }
          currentCover
          idealCover
          missing
          missingPolicies
        }
        ... on RetirementSummary {
          recommendPRSA
          prsaRecommendedFund {
            fund
            percentage
          }
          currentProvision {
            display
            string
            float
          }
          targetProvision {
            display
            float
            string
          }
          realisticProvision {
            display
            string
            float
          }
          breakdown {
            name
            amount {
              display
              float
              string
            }
          }
        }
        ... on SavingsInvestingSummary {
          breakdown {
            name
            amount {
              display
              string
              float
            }
          }
          emergencyFundProgress {
            currentProvision {
              display
              string
              float
            }
            recommendedProvision {
              display
              string
              float
            }
            monthsProtected
            recommendedProtectedMonths
            progress
          }
          goalProgress {
            name
            goalType
            amountSaved {
              display
              string
              float
            }
            targetAmount {
              display
              string
              float
            }
            progress
          }
          savingsSummary
          investingSummary
        }
        ... on HealthSummary {
          missing
          covered
        }
        ... on EmergencyFundSummary {
          emergencyFundProgress {
            currentProvision {
              display
              string
              float
            }
            recommendedProvision {
              display
              string
              float
            }
            monthsProtected
            recommendedProtectedMonths
            progress
          }
        }
        ... on DebtSummary {
          totalDebtAmount {
            display
            string
            float
          }
          idealMonthlyRepayment {
            display
            string
            float
          }
          clearedBy
        }
        ... on EmergencyFundSummary {
          emergencyFundProgress {
            currentProvision {
              display
              string
              float
            }
            recommendedProvision {
              display
              string
              float
            }
            monthsProtected
            recommendedProtectedMonths
            progress
          }
        }
      }
      factfindSummary
      recommendationType
      thingsToDo
      riskProfileQuestionnaireRequired
      relatedProducts {
        missing
        preProductAmount
        productAmount
        postProductAmount
      }
      recommendations {
        id
        title
        subtitle
        warnings
        ctas {
          text
          url
        }
        explanation {
          __typename
          ... on MarkdownBlock {
            title
            body
          }
          ... on ComparisonBlock {
            packages {
              name
              features
              cost {
                float
                string
                display
              }
            }
            features {
              name
              description
            }
          }
          ... on UrlBlock {
            title
            links {
              text
              url
            }
          }
        }
      }
    }
    authorisationStatus
    triageReason
  }
}
    `;

export function useGetPlanQuery(options: Omit<Urql.UseQueryArgs<GetPlanQueryVariables>, 'query'>) {
  return Urql.useQuery<GetPlanQuery, GetPlanQueryVariables>({ query: GetPlanDocument, ...options });
};
export const GetPlanAdviceInfoDocument = gql`
    query GetPlanAdviceInfo($userId: ID!) {
  plan(userId: $userId) {
    id
    factfindErrors
    lastUpdated
    monthlyAllocationAmount {
      display
      string
      float
    }
    recommendationGroups {
      id
      title
      subtitle
      explanation
      responsiveImage {
        src
        srcset
        sizes
      }
      summary {
        ... on ProtectionSummary {
          currentCover
          idealCover
          missing
          missingPolicies
        }
        ... on RetirementSummary {
          recommendPRSA
          prsaRecommendedFund {
            fund
            percentage
          }
          currentProvision {
            display
            string
            float
          }
          targetProvision {
            display
            float
            string
          }
        }
        ... on SavingsInvestingSummary {
          savingsSummary
          investingSummary
          goalProgress {
            name
            goalType
            amountSaved {
              display
              string
              float
            }
            targetAmount {
              display
              string
              float
            }
            progress
          }
        }
        ... on HealthSummary {
          missing
          covered
        }
        ... on EmergencyFundSummary {
          emergencyFundProgress {
            monthsProtected
            recommendedProtectedMonths
          }
        }
        ... on DebtSummary {
          totalDebtAmount {
            display
            string
            float
          }
        }
      }
      recommendationType
      thingsToDo
    }
    authorisationStatus
    advisorPhoto
  }
}
    `;

export function useGetPlanAdviceInfoQuery(options: Omit<Urql.UseQueryArgs<GetPlanAdviceInfoQueryVariables>, 'query'>) {
  return Urql.useQuery<GetPlanAdviceInfoQuery, GetPlanAdviceInfoQueryVariables>({ query: GetPlanAdviceInfoDocument, ...options });
};
export const GetPlanRecommendationsDocument = gql`
    query GetPlanRecommendations($userId: ID!) {
  plan(userId: $userId) {
    id
    factfindErrors
    lastUpdated
    suitabilityReportLink
    monthlyAllocationAmount {
      display
      string
      float
    }
    recommendationGroups {
      id
      title
      subtitle
      explanation
      responsiveImage {
        src
        srcset
        sizes
      }
      summary {
        ... on ProtectionSummary {
          scenarios {
            title
            subtitle
            covered
            recommended {
              display
              string
              float
            }
            recommendedForUser {
              display
              string
              float
            }
            recommendedForPartner {
              display
              string
              float
            }
            description
          }
          currentCover
          idealCover
          missing
          missingPolicies
        }
        ... on RetirementSummary {
          recommendPRSA
          prsaRecommendedFund {
            fund
            percentage
          }
          currentProvision {
            display
            string
            float
          }
          targetProvision {
            display
            float
            string
          }
          realisticProvision {
            display
            string
            float
          }
          breakdown {
            name
            amount {
              display
              float
              string
            }
          }
        }
        ... on SavingsInvestingSummary {
          breakdown {
            name
            amount {
              display
              string
              float
            }
          }
          emergencyFundProgress {
            currentProvision {
              display
              string
              float
            }
            recommendedProvision {
              display
              string
              float
            }
            monthsProtected
            recommendedProtectedMonths
            progress
          }
          goalProgress {
            name
            goalType
            amountSaved {
              display
              string
              float
            }
            targetAmount {
              display
              string
              float
            }
            progress
          }
          savingsSummary
          investingSummary
        }
        ... on HealthSummary {
          missing
          covered
        }
        ... on EmergencyFundSummary {
          emergencyFundProgress {
            currentProvision {
              display
              string
              float
            }
            recommendedProvision {
              display
              string
              float
            }
            monthsProtected
            recommendedProtectedMonths
            progress
          }
        }
        ... on DebtSummary {
          totalDebtAmount {
            display
            string
            float
          }
          idealMonthlyRepayment {
            display
            string
            float
          }
          clearedBy
        }
        ... on EmergencyFundSummary {
          emergencyFundProgress {
            currentProvision {
              display
              string
              float
            }
            recommendedProvision {
              display
              string
              float
            }
            monthsProtected
            recommendedProtectedMonths
            progress
          }
        }
      }
      factfindSummary
      recommendationType
      thingsToDo
      riskProfileQuestionnaireRequired
      relatedProducts {
        missing
        preProductAmount
        productAmount
        postProductAmount
      }
      recommendations {
        id
        title
        subtitle
        warnings
        ctas {
          text
          url
        }
        explanation {
          __typename
          ... on MarkdownBlock {
            title
            body
          }
          ... on ComparisonBlock {
            packages {
              name
              features
              cost {
                float
                string
                display
              }
            }
            features {
              name
              description
            }
          }
          ... on UrlBlock {
            title
            links {
              text
              url
            }
          }
        }
      }
    }
    authorisationStatus
    triageReason
  }
}
    `;

export function useGetPlanRecommendationsQuery(options: Omit<Urql.UseQueryArgs<GetPlanRecommendationsQueryVariables>, 'query'>) {
  return Urql.useQuery<GetPlanRecommendationsQuery, GetPlanRecommendationsQueryVariables>({ query: GetPlanRecommendationsDocument, ...options });
};
export const GetPlanSuitabilityReportLinkDocument = gql`
    query GetPlanSuitabilityReportLink($userId: ID!) {
  plan(userId: $userId) {
    id
    suitabilityReportLink
  }
}
    `;

export function useGetPlanSuitabilityReportLinkQuery(options: Omit<Urql.UseQueryArgs<GetPlanSuitabilityReportLinkQueryVariables>, 'query'>) {
  return Urql.useQuery<GetPlanSuitabilityReportLinkQuery, GetPlanSuitabilityReportLinkQueryVariables>({ query: GetPlanSuitabilityReportLinkDocument, ...options });
};

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockBookAppointmentMutation((req, res, ctx) => {
 *   const { input } = req.variables;
 *   return res(
 *     ctx.data({ bookAppointment })
 *   )
 * })
 */
export const mockBookAppointmentMutation = (resolver: ResponseResolver<GraphQLRequest<BookAppointmentMutationVariables>, GraphQLContext<BookAppointmentMutation>, any>) =>
  graphql.mutation<BookAppointmentMutation, BookAppointmentMutationVariables>(
    'BookAppointment',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockChangeEmailVerificationMutation((req, res, ctx) => {
 *   const { input } = req.variables;
 *   return res(
 *     ctx.data({ changeEmailVerification })
 *   )
 * })
 */
export const mockChangeEmailVerificationMutation = (resolver: ResponseResolver<GraphQLRequest<ChangeEmailVerificationMutationVariables>, GraphQLContext<ChangeEmailVerificationMutation>, any>) =>
  graphql.mutation<ChangeEmailVerificationMutation, ChangeEmailVerificationMutationVariables>(
    'ChangeEmailVerification',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockCreateSurveyMutation((req, res, ctx) => {
 *   const { input } = req.variables;
 *   return res(
 *     ctx.data({ createNewSurvey })
 *   )
 * })
 */
export const mockCreateSurveyMutation = (resolver: ResponseResolver<GraphQLRequest<CreateSurveyMutationVariables>, GraphQLContext<CreateSurveyMutation>, any>) =>
  graphql.mutation<CreateSurveyMutation, CreateSurveyMutationVariables>(
    'CreateSurvey',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockDeclineSurveyMutation((req, res, ctx) => {
 *   const { input } = req.variables;
 *   return res(
 *     ctx.data({ declineSurvey })
 *   )
 * })
 */
export const mockDeclineSurveyMutation = (resolver: ResponseResolver<GraphQLRequest<DeclineSurveyMutationVariables>, GraphQLContext<DeclineSurveyMutation>, any>) =>
  graphql.mutation<DeclineSurveyMutation, DeclineSurveyMutationVariables>(
    'DeclineSurvey',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockDeleteAssetMutation((req, res, ctx) => {
 *   const { input } = req.variables;
 *   return res(
 *     ctx.data({ deleteAsset })
 *   )
 * })
 */
export const mockDeleteAssetMutation = (resolver: ResponseResolver<GraphQLRequest<DeleteAssetMutationVariables>, GraphQLContext<DeleteAssetMutation>, any>) =>
  graphql.mutation<DeleteAssetMutation, DeleteAssetMutationVariables>(
    'DeleteAsset',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockDeleteDebtMutation((req, res, ctx) => {
 *   const { input } = req.variables;
 *   return res(
 *     ctx.data({ deleteDebt })
 *   )
 * })
 */
export const mockDeleteDebtMutation = (resolver: ResponseResolver<GraphQLRequest<DeleteDebtMutationVariables>, GraphQLContext<DeleteDebtMutation>, any>) =>
  graphql.mutation<DeleteDebtMutation, DeleteDebtMutationVariables>(
    'DeleteDebt',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockDeleteGoalMutation((req, res, ctx) => {
 *   const { input } = req.variables;
 *   return res(
 *     ctx.data({ deleteGoal })
 *   )
 * })
 */
export const mockDeleteGoalMutation = (resolver: ResponseResolver<GraphQLRequest<DeleteGoalMutationVariables>, GraphQLContext<DeleteGoalMutation>, any>) =>
  graphql.mutation<DeleteGoalMutation, DeleteGoalMutationVariables>(
    'DeleteGoal',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockDeletePolicyMutation((req, res, ctx) => {
 *   const { input } = req.variables;
 *   return res(
 *     ctx.data({ deletePolicy })
 *   )
 * })
 */
export const mockDeletePolicyMutation = (resolver: ResponseResolver<GraphQLRequest<DeletePolicyMutationVariables>, GraphQLContext<DeletePolicyMutation>, any>) =>
  graphql.mutation<DeletePolicyMutation, DeletePolicyMutationVariables>(
    'DeletePolicy',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockDeleteVulnerabilityReminderMutation((req, res, ctx) => {
 *   const { input } = req.variables;
 *   return res(
 *     ctx.data({ deleteVulnerabilityReminder })
 *   )
 * })
 */
export const mockDeleteVulnerabilityReminderMutation = (resolver: ResponseResolver<GraphQLRequest<DeleteVulnerabilityReminderMutationVariables>, GraphQLContext<DeleteVulnerabilityReminderMutation>, any>) =>
  graphql.mutation<DeleteVulnerabilityReminderMutation, DeleteVulnerabilityReminderMutationVariables>(
    'DeleteVulnerabilityReminder',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockGetAssetQuery((req, res, ctx) => {
 *   const { userId, assetId } = req.variables;
 *   return res(
 *     ctx.data({ asset })
 *   )
 * })
 */
export const mockGetAssetQuery = (resolver: ResponseResolver<GraphQLRequest<GetAssetQueryVariables>, GraphQLContext<GetAssetQuery>, any>) =>
  graphql.query<GetAssetQuery, GetAssetQueryVariables>(
    'GetAsset',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockGetAssetsQuery((req, res, ctx) => {
 *   const { userId } = req.variables;
 *   return res(
 *     ctx.data({ assets })
 *   )
 * })
 */
export const mockGetAssetsQuery = (resolver: ResponseResolver<GraphQLRequest<GetAssetsQueryVariables>, GraphQLContext<GetAssetsQuery>, any>) =>
  graphql.query<GetAssetsQuery, GetAssetsQueryVariables>(
    'GetAssets',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockGetAvailableAppointmentDaysQuery((req, res, ctx) => {
 *   const { userId, startDate, endDate } = req.variables;
 *   return res(
 *     ctx.data({ availableAppointmentDays })
 *   )
 * })
 */
export const mockGetAvailableAppointmentDaysQuery = (resolver: ResponseResolver<GraphQLRequest<GetAvailableAppointmentDaysQueryVariables>, GraphQLContext<GetAvailableAppointmentDaysQuery>, any>) =>
  graphql.query<GetAvailableAppointmentDaysQuery, GetAvailableAppointmentDaysQueryVariables>(
    'GetAvailableAppointmentDays',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockGetAvailableAppointmentsQuery((req, res, ctx) => {
 *   const { userId, date } = req.variables;
 *   return res(
 *     ctx.data({ availableAppointments })
 *   )
 * })
 */
export const mockGetAvailableAppointmentsQuery = (resolver: ResponseResolver<GraphQLRequest<GetAvailableAppointmentsQueryVariables>, GraphQLContext<GetAvailableAppointmentsQuery>, any>) =>
  graphql.query<GetAvailableAppointmentsQuery, GetAvailableAppointmentsQueryVariables>(
    'GetAvailableAppointments',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockGetBasicInfoFactFindQuery((req, res, ctx) => {
 *   const { userId } = req.variables;
 *   return res(
 *     ctx.data({ factfind })
 *   )
 * })
 */
export const mockGetBasicInfoFactFindQuery = (resolver: ResponseResolver<GraphQLRequest<GetBasicInfoFactFindQueryVariables>, GraphQLContext<GetBasicInfoFactFindQuery>, any>) =>
  graphql.query<GetBasicInfoFactFindQuery, GetBasicInfoFactFindQueryVariables>(
    'GetBasicInfoFactFind',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockCheckInQuery((req, res, ctx) => {
 *   const { userId } = req.variables;
 *   return res(
 *     ctx.data({ checkIn })
 *   )
 * })
 */
export const mockCheckInQuery = (resolver: ResponseResolver<GraphQLRequest<CheckInQueryVariables>, GraphQLContext<CheckInQuery>, any>) =>
  graphql.query<CheckInQuery, CheckInQueryVariables>(
    'CheckIn',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockGetConsentQuery((req, res, ctx) => {
 *   const { userId } = req.variables;
 *   return res(
 *     ctx.data({ consent })
 *   )
 * })
 */
export const mockGetConsentQuery = (resolver: ResponseResolver<GraphQLRequest<GetConsentQueryVariables>, GraphQLContext<GetConsentQuery>, any>) =>
  graphql.query<GetConsentQuery, GetConsentQueryVariables>(
    'GetConsent',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockGetCountriesQuery((req, res, ctx) => {
 *   return res(
 *     ctx.data({ countries })
 *   )
 * })
 */
export const mockGetCountriesQuery = (resolver: ResponseResolver<GraphQLRequest<GetCountriesQueryVariables>, GraphQLContext<GetCountriesQuery>, any>) =>
  graphql.query<GetCountriesQuery, GetCountriesQueryVariables>(
    'GetCountries',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockGetDebtQuery((req, res, ctx) => {
 *   const { userId, debtId } = req.variables;
 *   return res(
 *     ctx.data({ debt })
 *   )
 * })
 */
export const mockGetDebtQuery = (resolver: ResponseResolver<GraphQLRequest<GetDebtQueryVariables>, GraphQLContext<GetDebtQuery>, any>) =>
  graphql.query<GetDebtQuery, GetDebtQueryVariables>(
    'GetDebt',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockGetDebtsQuery((req, res, ctx) => {
 *   const { userId } = req.variables;
 *   return res(
 *     ctx.data({ debts })
 *   )
 * })
 */
export const mockGetDebtsQuery = (resolver: ResponseResolver<GraphQLRequest<GetDebtsQueryVariables>, GraphQLContext<GetDebtsQuery>, any>) =>
  graphql.query<GetDebtsQuery, GetDebtsQueryVariables>(
    'GetDebts',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockGetFactFindQuery((req, res, ctx) => {
 *   const { userId } = req.variables;
 *   return res(
 *     ctx.data({ factfind })
 *   )
 * })
 */
export const mockGetFactFindQuery = (resolver: ResponseResolver<GraphQLRequest<GetFactFindQueryVariables>, GraphQLContext<GetFactFindQuery>, any>) =>
  graphql.query<GetFactFindQuery, GetFactFindQueryVariables>(
    'GetFactFind',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockGetFieldsQuery((req, res, ctx) => {
 *   const { userId, context } = req.variables;
 *   return res(
 *     ctx.data({ factfindFields })
 *   )
 * })
 */
export const mockGetFieldsQuery = (resolver: ResponseResolver<GraphQLRequest<GetFieldsQueryVariables>, GraphQLContext<GetFieldsQuery>, any>) =>
  graphql.query<GetFieldsQuery, GetFieldsQueryVariables>(
    'GetFields',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockGetFinancialsFactFindQuery((req, res, ctx) => {
 *   const { userId } = req.variables;
 *   return res(
 *     ctx.data({ factfind })
 *   )
 * })
 */
export const mockGetFinancialsFactFindQuery = (resolver: ResponseResolver<GraphQLRequest<GetFinancialsFactFindQueryVariables>, GraphQLContext<GetFinancialsFactFindQuery>, any>) =>
  graphql.query<GetFinancialsFactFindQuery, GetFinancialsFactFindQueryVariables>(
    'GetFinancialsFactFind',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockGetGoalQuery((req, res, ctx) => {
 *   const { userId, goalId } = req.variables;
 *   return res(
 *     ctx.data({ goal })
 *   )
 * })
 */
export const mockGetGoalQuery = (resolver: ResponseResolver<GraphQLRequest<GetGoalQueryVariables>, GraphQLContext<GetGoalQuery>, any>) =>
  graphql.query<GetGoalQuery, GetGoalQueryVariables>(
    'GetGoal',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockGetGoalsQuery((req, res, ctx) => {
 *   const { userId } = req.variables;
 *   return res(
 *     ctx.data({ goals })
 *   )
 * })
 */
export const mockGetGoalsQuery = (resolver: ResponseResolver<GraphQLRequest<GetGoalsQueryVariables>, GraphQLContext<GetGoalsQuery>, any>) =>
  graphql.query<GetGoalsQuery, GetGoalsQueryVariables>(
    'GetGoals',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockGetInteractionFlagQuery((req, res, ctx) => {
 *   const { userId, flagKey } = req.variables;
 *   return res(
 *     ctx.data({ interactionFlag })
 *   )
 * })
 */
export const mockGetInteractionFlagQuery = (resolver: ResponseResolver<GraphQLRequest<GetInteractionFlagQueryVariables>, GraphQLContext<GetInteractionFlagQuery>, any>) =>
  graphql.query<GetInteractionFlagQuery, GetInteractionFlagQueryVariables>(
    'GetInteractionFlag',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockGetMessagesQuery((req, res, ctx) => {
 *   const { userId } = req.variables;
 *   return res(
 *     ctx.data({ messages })
 *   )
 * })
 */
export const mockGetMessagesQuery = (resolver: ResponseResolver<GraphQLRequest<GetMessagesQueryVariables>, GraphQLContext<GetMessagesQuery>, any>) =>
  graphql.query<GetMessagesQuery, GetMessagesQueryVariables>(
    'GetMessages',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockGetNationalitiesQuery((req, res, ctx) => {
 *   return res(
 *     ctx.data({ nationalities })
 *   )
 * })
 */
export const mockGetNationalitiesQuery = (resolver: ResponseResolver<GraphQLRequest<GetNationalitiesQueryVariables>, GraphQLContext<GetNationalitiesQuery>, any>) =>
  graphql.query<GetNationalitiesQuery, GetNationalitiesQueryVariables>(
    'GetNationalities',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockGetNextAvailableAppointmentQuery((req, res, ctx) => {
 *   const { userId } = req.variables;
 *   return res(
 *     ctx.data({ nextAvailableAppointment })
 *   )
 * })
 */
export const mockGetNextAvailableAppointmentQuery = (resolver: ResponseResolver<GraphQLRequest<GetNextAvailableAppointmentQueryVariables>, GraphQLContext<GetNextAvailableAppointmentQuery>, any>) =>
  graphql.query<GetNextAvailableAppointmentQuery, GetNextAvailableAppointmentQueryVariables>(
    'GetNextAvailableAppointment',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockGetOccupationsQuery((req, res, ctx) => {
 *   return res(
 *     ctx.data({ occupations })
 *   )
 * })
 */
export const mockGetOccupationsQuery = (resolver: ResponseResolver<GraphQLRequest<GetOccupationsQueryVariables>, GraphQLContext<GetOccupationsQuery>, any>) =>
  graphql.query<GetOccupationsQuery, GetOccupationsQueryVariables>(
    'GetOccupations',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockGetPensionCalculationQuery((req, res, ctx) => {
 *   const { input } = req.variables;
 *   return res(
 *     ctx.data({ calculatePension })
 *   )
 * })
 */
export const mockGetPensionCalculationQuery = (resolver: ResponseResolver<GraphQLRequest<GetPensionCalculationQueryVariables>, GraphQLContext<GetPensionCalculationQuery>, any>) =>
  graphql.query<GetPensionCalculationQuery, GetPensionCalculationQueryVariables>(
    'GetPensionCalculation',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockGetPersonQuery((req, res, ctx) => {
 *   const { userId, personId } = req.variables;
 *   return res(
 *     ctx.data({ person })
 *   )
 * })
 */
export const mockGetPersonQuery = (resolver: ResponseResolver<GraphQLRequest<GetPersonQueryVariables>, GraphQLContext<GetPersonQuery>, any>) =>
  graphql.query<GetPersonQuery, GetPersonQueryVariables>(
    'GetPerson',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockGetPersonsQuery((req, res, ctx) => {
 *   const { userId } = req.variables;
 *   return res(
 *     ctx.data({ persons })
 *   )
 * })
 */
export const mockGetPersonsQuery = (resolver: ResponseResolver<GraphQLRequest<GetPersonsQueryVariables>, GraphQLContext<GetPersonsQuery>, any>) =>
  graphql.query<GetPersonsQuery, GetPersonsQueryVariables>(
    'GetPersons',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockGetPlanGraphQuery((req, res, ctx) => {
 *   const { userId, startDate, endDate } = req.variables;
 *   return res(
 *     ctx.data({ planGraph })
 *   )
 * })
 */
export const mockGetPlanGraphQuery = (resolver: ResponseResolver<GraphQLRequest<GetPlanGraphQueryVariables>, GraphQLContext<GetPlanGraphQuery>, any>) =>
  graphql.query<GetPlanGraphQuery, GetPlanGraphQueryVariables>(
    'GetPlanGraph',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockGetPoliciesQuery((req, res, ctx) => {
 *   const { userId } = req.variables;
 *   return res(
 *     ctx.data({ policies })
 *   )
 * })
 */
export const mockGetPoliciesQuery = (resolver: ResponseResolver<GraphQLRequest<GetPoliciesQueryVariables>, GraphQLContext<GetPoliciesQuery>, any>) =>
  graphql.query<GetPoliciesQuery, GetPoliciesQueryVariables>(
    'GetPolicies',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockGetPolicyQuery((req, res, ctx) => {
 *   const { userId, policyId } = req.variables;
 *   return res(
 *     ctx.data({ policy })
 *   )
 * })
 */
export const mockGetPolicyQuery = (resolver: ResponseResolver<GraphQLRequest<GetPolicyQueryVariables>, GraphQLContext<GetPolicyQuery>, any>) =>
  graphql.query<GetPolicyQuery, GetPolicyQueryVariables>(
    'GetPolicy',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockGetProvidersQuery((req, res, ctx) => {
 *   return res(
 *     ctx.data({ providers })
 *   )
 * })
 */
export const mockGetProvidersQuery = (resolver: ResponseResolver<GraphQLRequest<GetProvidersQueryVariables>, GraphQLContext<GetProvidersQuery>, any>) =>
  graphql.query<GetProvidersQuery, GetProvidersQueryVariables>(
    'GetProviders',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockGetPrsaPensionApplicationQuery((req, res, ctx) => {
 *   const { userId } = req.variables;
 *   return res(
 *     ctx.data({ prsaPensionApplication })
 *   )
 * })
 */
export const mockGetPrsaPensionApplicationQuery = (resolver: ResponseResolver<GraphQLRequest<GetPrsaPensionApplicationQueryVariables>, GraphQLContext<GetPrsaPensionApplicationQuery>, any>) =>
  graphql.query<GetPrsaPensionApplicationQuery, GetPrsaPensionApplicationQueryVariables>(
    'GetPrsaPensionApplication',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockGetRetirementAgeFactFindQuery((req, res, ctx) => {
 *   const { userId } = req.variables;
 *   return res(
 *     ctx.data({ factfind })
 *   )
 * })
 */
export const mockGetRetirementAgeFactFindQuery = (resolver: ResponseResolver<GraphQLRequest<GetRetirementAgeFactFindQueryVariables>, GraphQLContext<GetRetirementAgeFactFindQuery>, any>) =>
  graphql.query<GetRetirementAgeFactFindQuery, GetRetirementAgeFactFindQueryVariables>(
    'GetRetirementAgeFactFind',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockGetRiskQuery((req, res, ctx) => {
 *   const { userId } = req.variables;
 *   return res(
 *     ctx.data({ risk })
 *   )
 * })
 */
export const mockGetRiskQuery = (resolver: ResponseResolver<GraphQLRequest<GetRiskQueryVariables>, GraphQLContext<GetRiskQuery>, any>) =>
  graphql.query<GetRiskQuery, GetRiskQueryVariables>(
    'GetRisk',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockGetRiskProfilesQuery((req, res, ctx) => {
 *   const { userId } = req.variables;
 *   return res(
 *     ctx.data({ riskProfiles })
 *   )
 * })
 */
export const mockGetRiskProfilesQuery = (resolver: ResponseResolver<GraphQLRequest<GetRiskProfilesQueryVariables>, GraphQLContext<GetRiskProfilesQuery>, any>) =>
  graphql.query<GetRiskProfilesQuery, GetRiskProfilesQueryVariables>(
    'GetRiskProfiles',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockGetScheduledAppointmentsQuery((req, res, ctx) => {
 *   const { userId } = req.variables;
 *   return res(
 *     ctx.data({ scheduledAppointments })
 *   )
 * })
 */
export const mockGetScheduledAppointmentsQuery = (resolver: ResponseResolver<GraphQLRequest<GetScheduledAppointmentsQueryVariables>, GraphQLContext<GetScheduledAppointmentsQuery>, any>) =>
  graphql.query<GetScheduledAppointmentsQuery, GetScheduledAppointmentsQueryVariables>(
    'GetScheduledAppointments',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockGetToolsQuery((req, res, ctx) => {
 *   const { userId } = req.variables;
 *   return res(
 *     ctx.data({ tools })
 *   )
 * })
 */
export const mockGetToolsQuery = (resolver: ResponseResolver<GraphQLRequest<GetToolsQueryVariables>, GraphQLContext<GetToolsQuery>, any>) =>
  graphql.query<GetToolsQuery, GetToolsQueryVariables>(
    'GetTools',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockGetUserQuery((req, res, ctx) => {
 *   const { userId } = req.variables;
 *   return res(
 *     ctx.data({ user })
 *   )
 * })
 */
export const mockGetUserQuery = (resolver: ResponseResolver<GraphQLRequest<GetUserQueryVariables>, GraphQLContext<GetUserQuery>, any>) =>
  graphql.query<GetUserQuery, GetUserQueryVariables>(
    'GetUser',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockGetVulnerabilityReminderQuery((req, res, ctx) => {
 *   const { userId } = req.variables;
 *   return res(
 *     ctx.data({ vulnerabilityReminder })
 *   )
 * })
 */
export const mockGetVulnerabilityReminderQuery = (resolver: ResponseResolver<GraphQLRequest<GetVulnerabilityReminderQueryVariables>, GraphQLContext<GetVulnerabilityReminderQuery>, any>) =>
  graphql.query<GetVulnerabilityReminderQuery, GetVulnerabilityReminderQueryVariables>(
    'GetVulnerabilityReminder',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockRequestPlanMutation((req, res, ctx) => {
 *   const { input } = req.variables;
 *   return res(
 *     ctx.data({ requestPlan })
 *   )
 * })
 */
export const mockRequestPlanMutation = (resolver: ResponseResolver<GraphQLRequest<RequestPlanMutationVariables>, GraphQLContext<RequestPlanMutation>, any>) =>
  graphql.mutation<RequestPlanMutation, RequestPlanMutationVariables>(
    'RequestPlan',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockSetVulnerabilityReminderMutation((req, res, ctx) => {
 *   const { input } = req.variables;
 *   return res(
 *     ctx.data({ setVulnerabilityReminder })
 *   )
 * })
 */
export const mockSetVulnerabilityReminderMutation = (resolver: ResponseResolver<GraphQLRequest<SetVulnerabilityReminderMutationVariables>, GraphQLContext<SetVulnerabilityReminderMutation>, any>) =>
  graphql.mutation<SetVulnerabilityReminderMutation, SetVulnerabilityReminderMutationVariables>(
    'SetVulnerabilityReminder',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockShowSurveyQuery((req, res, ctx) => {
 *   const { userId } = req.variables;
 *   return res(
 *     ctx.data({ showSurvey })
 *   )
 * })
 */
export const mockShowSurveyQuery = (resolver: ResponseResolver<GraphQLRequest<ShowSurveyQueryVariables>, GraphQLContext<ShowSurveyQuery>, any>) =>
  graphql.query<ShowSurveyQuery, ShowSurveyQueryVariables>(
    'ShowSurvey',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockSignUpMutation((req, res, ctx) => {
 *   const { input } = req.variables;
 *   return res(
 *     ctx.data({ signUp })
 *   )
 * })
 */
export const mockSignUpMutation = (resolver: ResponseResolver<GraphQLRequest<SignUpMutationVariables>, GraphQLContext<SignUpMutation>, any>) =>
  graphql.mutation<SignUpMutation, SignUpMutationVariables>(
    'SignUp',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockSubmitPensionApplicationMutation((req, res, ctx) => {
 *   const { input } = req.variables;
 *   return res(
 *     ctx.data({ submitPensionApplication })
 *   )
 * })
 */
export const mockSubmitPensionApplicationMutation = (resolver: ResponseResolver<GraphQLRequest<SubmitPensionApplicationMutationVariables>, GraphQLContext<SubmitPensionApplicationMutation>, any>) =>
  graphql.mutation<SubmitPensionApplicationMutation, SubmitPensionApplicationMutationVariables>(
    'SubmitPensionApplication',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockSubscribeToToolMutation((req, res, ctx) => {
 *   const { input } = req.variables;
 *   return res(
 *     ctx.data({ subscribeToTool })
 *   )
 * })
 */
export const mockSubscribeToToolMutation = (resolver: ResponseResolver<GraphQLRequest<SubscribeToToolMutationVariables>, GraphQLContext<SubscribeToToolMutation>, any>) =>
  graphql.mutation<SubscribeToToolMutation, SubscribeToToolMutationVariables>(
    'SubscribeToTool',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockSuggestNewToolMutation((req, res, ctx) => {
 *   const { input } = req.variables;
 *   return res(
 *     ctx.data({ suggestNewTool })
 *   )
 * })
 */
export const mockSuggestNewToolMutation = (resolver: ResponseResolver<GraphQLRequest<SuggestNewToolMutationVariables>, GraphQLContext<SuggestNewToolMutation>, any>) =>
  graphql.mutation<SuggestNewToolMutation, SuggestNewToolMutationVariables>(
    'SuggestNewTool',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockSyncUserMutation((req, res, ctx) => {
 *   const { input } = req.variables;
 *   return res(
 *     ctx.data({ syncUser })
 *   )
 * })
 */
export const mockSyncUserMutation = (resolver: ResponseResolver<GraphQLRequest<SyncUserMutationVariables>, GraphQLContext<SyncUserMutation>, any>) =>
  graphql.mutation<SyncUserMutation, SyncUserMutationVariables>(
    'SyncUser',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockUpdateAssetMutation((req, res, ctx) => {
 *   const { input } = req.variables;
 *   return res(
 *     ctx.data({ updateAsset })
 *   )
 * })
 */
export const mockUpdateAssetMutation = (resolver: ResponseResolver<GraphQLRequest<UpdateAssetMutationVariables>, GraphQLContext<UpdateAssetMutation>, any>) =>
  graphql.mutation<UpdateAssetMutation, UpdateAssetMutationVariables>(
    'UpdateAsset',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockUpdateAssetsMutation((req, res, ctx) => {
 *   const { input } = req.variables;
 *   return res(
 *     ctx.data({ updateAssets })
 *   )
 * })
 */
export const mockUpdateAssetsMutation = (resolver: ResponseResolver<GraphQLRequest<UpdateAssetsMutationVariables>, GraphQLContext<UpdateAssetsMutation>, any>) =>
  graphql.mutation<UpdateAssetsMutation, UpdateAssetsMutationVariables>(
    'UpdateAssets',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockUpdateBasicInfoFactFindMutation((req, res, ctx) => {
 *   const { input } = req.variables;
 *   return res(
 *     ctx.data({ updateFactfind })
 *   )
 * })
 */
export const mockUpdateBasicInfoFactFindMutation = (resolver: ResponseResolver<GraphQLRequest<UpdateBasicInfoFactFindMutationVariables>, GraphQLContext<UpdateBasicInfoFactFindMutation>, any>) =>
  graphql.mutation<UpdateBasicInfoFactFindMutation, UpdateBasicInfoFactFindMutationVariables>(
    'UpdateBasicInfoFactFind',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockUpdateCheckInMutation((req, res, ctx) => {
 *   const { input } = req.variables;
 *   return res(
 *     ctx.data({ updateCheckIn })
 *   )
 * })
 */
export const mockUpdateCheckInMutation = (resolver: ResponseResolver<GraphQLRequest<UpdateCheckInMutationVariables>, GraphQLContext<UpdateCheckInMutation>, any>) =>
  graphql.mutation<UpdateCheckInMutation, UpdateCheckInMutationVariables>(
    'UpdateCheckIn',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockUpdateConsentMutation((req, res, ctx) => {
 *   const { input } = req.variables;
 *   return res(
 *     ctx.data({ updateConsent })
 *   )
 * })
 */
export const mockUpdateConsentMutation = (resolver: ResponseResolver<GraphQLRequest<UpdateConsentMutationVariables>, GraphQLContext<UpdateConsentMutation>, any>) =>
  graphql.mutation<UpdateConsentMutation, UpdateConsentMutationVariables>(
    'UpdateConsent',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockUpdateDebtMutation((req, res, ctx) => {
 *   const { input } = req.variables;
 *   return res(
 *     ctx.data({ updateDebt })
 *   )
 * })
 */
export const mockUpdateDebtMutation = (resolver: ResponseResolver<GraphQLRequest<UpdateDebtMutationVariables>, GraphQLContext<UpdateDebtMutation>, any>) =>
  graphql.mutation<UpdateDebtMutation, UpdateDebtMutationVariables>(
    'UpdateDebt',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockUpdateDebtsMutation((req, res, ctx) => {
 *   const { input } = req.variables;
 *   return res(
 *     ctx.data({ updateDebts })
 *   )
 * })
 */
export const mockUpdateDebtsMutation = (resolver: ResponseResolver<GraphQLRequest<UpdateDebtsMutationVariables>, GraphQLContext<UpdateDebtsMutation>, any>) =>
  graphql.mutation<UpdateDebtsMutation, UpdateDebtsMutationVariables>(
    'UpdateDebts',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockUpdateEmailMutation((req, res, ctx) => {
 *   const { input } = req.variables;
 *   return res(
 *     ctx.data({ updateEmail })
 *   )
 * })
 */
export const mockUpdateEmailMutation = (resolver: ResponseResolver<GraphQLRequest<UpdateEmailMutationVariables>, GraphQLContext<UpdateEmailMutation>, any>) =>
  graphql.mutation<UpdateEmailMutation, UpdateEmailMutationVariables>(
    'UpdateEmail',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockUpdateFactFindMutation((req, res, ctx) => {
 *   const { input } = req.variables;
 *   return res(
 *     ctx.data({ updateFactfind })
 *   )
 * })
 */
export const mockUpdateFactFindMutation = (resolver: ResponseResolver<GraphQLRequest<UpdateFactFindMutationVariables>, GraphQLContext<UpdateFactFindMutation>, any>) =>
  graphql.mutation<UpdateFactFindMutation, UpdateFactFindMutationVariables>(
    'UpdateFactFind',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockUpdateFinancialsFactFindMutation((req, res, ctx) => {
 *   const { input } = req.variables;
 *   return res(
 *     ctx.data({ updateFactfind })
 *   )
 * })
 */
export const mockUpdateFinancialsFactFindMutation = (resolver: ResponseResolver<GraphQLRequest<UpdateFinancialsFactFindMutationVariables>, GraphQLContext<UpdateFinancialsFactFindMutation>, any>) =>
  graphql.mutation<UpdateFinancialsFactFindMutation, UpdateFinancialsFactFindMutationVariables>(
    'UpdateFinancialsFactFind',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockUpdateGoalMutation((req, res, ctx) => {
 *   const { input } = req.variables;
 *   return res(
 *     ctx.data({ updateGoal })
 *   )
 * })
 */
export const mockUpdateGoalMutation = (resolver: ResponseResolver<GraphQLRequest<UpdateGoalMutationVariables>, GraphQLContext<UpdateGoalMutation>, any>) =>
  graphql.mutation<UpdateGoalMutation, UpdateGoalMutationVariables>(
    'UpdateGoal',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockUpdateGoalsMutation((req, res, ctx) => {
 *   const { userId, goals } = req.variables;
 *   return res(
 *     ctx.data({ updateGoals })
 *   )
 * })
 */
export const mockUpdateGoalsMutation = (resolver: ResponseResolver<GraphQLRequest<UpdateGoalsMutationVariables>, GraphQLContext<UpdateGoalsMutation>, any>) =>
  graphql.mutation<UpdateGoalsMutation, UpdateGoalsMutationVariables>(
    'UpdateGoals',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockUpdateInteractionFlagMutation((req, res, ctx) => {
 *   const { input } = req.variables;
 *   return res(
 *     ctx.data({ updateInteractionFlag })
 *   )
 * })
 */
export const mockUpdateInteractionFlagMutation = (resolver: ResponseResolver<GraphQLRequest<UpdateInteractionFlagMutationVariables>, GraphQLContext<UpdateInteractionFlagMutation>, any>) =>
  graphql.mutation<UpdateInteractionFlagMutation, UpdateInteractionFlagMutationVariables>(
    'UpdateInteractionFlag',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockUpdatePensionApplicationMutation((req, res, ctx) => {
 *   const { input } = req.variables;
 *   return res(
 *     ctx.data({ updatePensionApplication })
 *   )
 * })
 */
export const mockUpdatePensionApplicationMutation = (resolver: ResponseResolver<GraphQLRequest<UpdatePensionApplicationMutationVariables>, GraphQLContext<UpdatePensionApplicationMutation>, any>) =>
  graphql.mutation<UpdatePensionApplicationMutation, UpdatePensionApplicationMutationVariables>(
    'UpdatePensionApplication',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockUpdatePersonMutation((req, res, ctx) => {
 *   const { input } = req.variables;
 *   return res(
 *     ctx.data({ updatePerson })
 *   )
 * })
 */
export const mockUpdatePersonMutation = (resolver: ResponseResolver<GraphQLRequest<UpdatePersonMutationVariables>, GraphQLContext<UpdatePersonMutation>, any>) =>
  graphql.mutation<UpdatePersonMutation, UpdatePersonMutationVariables>(
    'UpdatePerson',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockUpdatePoliciesMutation((req, res, ctx) => {
 *   const { input } = req.variables;
 *   return res(
 *     ctx.data({ updatePolicies })
 *   )
 * })
 */
export const mockUpdatePoliciesMutation = (resolver: ResponseResolver<GraphQLRequest<UpdatePoliciesMutationVariables>, GraphQLContext<UpdatePoliciesMutation>, any>) =>
  graphql.mutation<UpdatePoliciesMutation, UpdatePoliciesMutationVariables>(
    'UpdatePolicies',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockUpdatePolicyMutation((req, res, ctx) => {
 *   const { input } = req.variables;
 *   return res(
 *     ctx.data({ updatePolicy })
 *   )
 * })
 */
export const mockUpdatePolicyMutation = (resolver: ResponseResolver<GraphQLRequest<UpdatePolicyMutationVariables>, GraphQLContext<UpdatePolicyMutation>, any>) =>
  graphql.mutation<UpdatePolicyMutation, UpdatePolicyMutationVariables>(
    'UpdatePolicy',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockUpdateRiskMutation((req, res, ctx) => {
 *   const { input } = req.variables;
 *   return res(
 *     ctx.data({ updateRisk })
 *   )
 * })
 */
export const mockUpdateRiskMutation = (resolver: ResponseResolver<GraphQLRequest<UpdateRiskMutationVariables>, GraphQLContext<UpdateRiskMutation>, any>) =>
  graphql.mutation<UpdateRiskMutation, UpdateRiskMutationVariables>(
    'UpdateRisk',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockCalculateCollegeCostsMutation((req, res, ctx) => {
 *   const { input } = req.variables;
 *   return res(
 *     ctx.data({ updateCollegeCosts })
 *   )
 * })
 */
export const mockCalculateCollegeCostsMutation = (resolver: ResponseResolver<GraphQLRequest<CalculateCollegeCostsMutationVariables>, GraphQLContext<CalculateCollegeCostsMutation>, any>) =>
  graphql.mutation<CalculateCollegeCostsMutation, CalculateCollegeCostsMutationVariables>(
    'CalculateCollegeCosts',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockGetAllCollegeCostsQuery((req, res, ctx) => {
 *   const { userId } = req.variables;
 *   return res(
 *     ctx.data({ collegeCosts })
 *   )
 * })
 */
export const mockGetAllCollegeCostsQuery = (resolver: ResponseResolver<GraphQLRequest<GetAllCollegeCostsQueryVariables>, GraphQLContext<GetAllCollegeCostsQuery>, any>) =>
  graphql.query<GetAllCollegeCostsQuery, GetAllCollegeCostsQueryVariables>(
    'GetAllCollegeCosts',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockGetCollegeCostQuery((req, res, ctx) => {
 *   const { userId, collegeCostId, collegeCostUuid } = req.variables;
 *   return res(
 *     ctx.data({ collegeCost })
 *   )
 * })
 */
export const mockGetCollegeCostQuery = (resolver: ResponseResolver<GraphQLRequest<GetCollegeCostQueryVariables>, GraphQLContext<GetCollegeCostQuery>, any>) =>
  graphql.query<GetCollegeCostQuery, GetCollegeCostQueryVariables>(
    'GetCollegeCost',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockGetPlanQuery((req, res, ctx) => {
 *   const { userId } = req.variables;
 *   return res(
 *     ctx.data({ plan })
 *   )
 * })
 */
export const mockGetPlanQuery = (resolver: ResponseResolver<GraphQLRequest<GetPlanQueryVariables>, GraphQLContext<GetPlanQuery>, any>) =>
  graphql.query<GetPlanQuery, GetPlanQueryVariables>(
    'GetPlan',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockGetPlanAdviceInfoQuery((req, res, ctx) => {
 *   const { userId } = req.variables;
 *   return res(
 *     ctx.data({ plan })
 *   )
 * })
 */
export const mockGetPlanAdviceInfoQuery = (resolver: ResponseResolver<GraphQLRequest<GetPlanAdviceInfoQueryVariables>, GraphQLContext<GetPlanAdviceInfoQuery>, any>) =>
  graphql.query<GetPlanAdviceInfoQuery, GetPlanAdviceInfoQueryVariables>(
    'GetPlanAdviceInfo',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockGetPlanRecommendationsQuery((req, res, ctx) => {
 *   const { userId } = req.variables;
 *   return res(
 *     ctx.data({ plan })
 *   )
 * })
 */
export const mockGetPlanRecommendationsQuery = (resolver: ResponseResolver<GraphQLRequest<GetPlanRecommendationsQueryVariables>, GraphQLContext<GetPlanRecommendationsQuery>, any>) =>
  graphql.query<GetPlanRecommendationsQuery, GetPlanRecommendationsQueryVariables>(
    'GetPlanRecommendations',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockGetPlanSuitabilityReportLinkQuery((req, res, ctx) => {
 *   const { userId } = req.variables;
 *   return res(
 *     ctx.data({ plan })
 *   )
 * })
 */
export const mockGetPlanSuitabilityReportLinkQuery = (resolver: ResponseResolver<GraphQLRequest<GetPlanSuitabilityReportLinkQueryVariables>, GraphQLContext<GetPlanSuitabilityReportLinkQuery>, any>) =>
  graphql.query<GetPlanSuitabilityReportLinkQuery, GetPlanSuitabilityReportLinkQueryVariables>(
    'GetPlanSuitabilityReportLink',
    resolver
  )
